// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAddonHealthStatus = z.enum([
  'unknown',
  'healthy',
  'unhealthy',
  'credential-invalid',
]);

export const zAddonLifecycleStatus = z.enum([
  'installing',
  'upgrading',
  'installed',
  'failed',
  'unknown',
  'uninstalling',
]);

export const zAddonOperation = z.enum(['install', 'upgrade', 'uninstall']);

export const zAddonproxyAddon = z.object({
  description: z.string().optional(),
  displayName: z.string().optional(),
  healthCheckPath: z.string().optional(),
  helmChartRepository: z.string().optional(),
  icon: z.string().optional(),
  id: z.string().optional(),
  path: z.string().optional(),
  serviceUrl: z.string().optional(),
  shortDescription: z.string().optional(),
  tlsVerify: z.boolean().optional(),
});

export const zAddonproxyCatalog = z.object({
  addons: z.array(zAddonproxyAddon).optional(),
});

export const zAddonsAddonEnvironmentResponse = z.object({
  environmentId: z.int().optional(),
});

export const zAddonsAddonLifecycleResponse = z.object({
  chartVersion: z.string().optional(),
  enabled: z.boolean().optional(),
  id: z.string().optional(),
  lifecycleStatus: zAddonLifecycleStatus.optional(),
  lifecycleStatusMessage: z.string().optional(),
});

export const zAddonsCapabilitiesResponse = z.object({
  capabilities: z.array(z.string()).optional(),
});

export const zAddonsChartSourceStatusResponse = z.object({
  reachable: z.boolean().optional(),
  reason: z.string().optional(),
  tlsVerify: z.boolean().optional(),
  versions: z.array(z.string()).optional(),
});

export const zAddonsConfigEntryPayload = z.object({
  key: z.string().optional(),
  sensitive: z.boolean().optional(),
  value: z.string().optional(),
});

export const zAddonsConfigEntryResponse = z.object({
  key: z.string().optional(),
  sensitive: z.boolean().optional(),
  value: z.string().optional(),
});

export const zAddonsConfigEntryUpdatePayload = z.object({
  sensitive: z.boolean().optional(),
  value: z.string().optional(),
});

export const zAddonsConfigMutationResponse = z.object({
  entries: z.array(zAddonsConfigEntryResponse).optional(),
});

export const zAddonsConfigResponse = z.object({
  entries: z.array(zAddonsConfigEntryResponse).optional(),
});

export const zAddonsConfigUpdatePayload = z.object({
  entries: z.array(zAddonsConfigEntryPayload).optional(),
});

export const zAddonsInstallPayload = z.object({
  chart: z.string().optional(),
  imageRegistryId: z.int().optional(),
  registryId: z.int().optional(),
  values: z.record(z.string(), z.unknown()).optional(),
  version: z.string().optional(),
});

export const zAuthAuthenticatePayload = z.object({
  apiKey: z.string(),
  password: z.string(),
  username: z.string(),
});

export const zAuthAuthenticateResponse = z.object({
  jwt: z.string().optional(),
});

export const zAuthOauthPayload = z.object({
  Code: z.string().optional(),
});

export const zBackupAzureBackupStatus = z.object({
  Failed: z.boolean().optional(),
  TimestampUTC: z.string().optional(),
});

export const zBackupBackupPayload = z.object({
  Password: z.string().optional(),
});

export const zBackupBackupStatus = z.object({
  Failed: z.boolean().optional(),
  TimestampUTC: z.string().optional(),
});

export const zBackupLocalBackupStatus = z.object({
  failed: z.boolean().optional(),
  path: z.string().optional(),
  timestampUTC: z.string().optional(),
});

export const zBackupRestorePayload = z.object({
  FileContent: z.array(z.int()),
  FileName: z.string(),
  Password: z.string().optional(),
});

export const zBackupRestoreS3Settings = z.object({
  AccessKeyID: z.string().optional(),
  BucketName: z.string().optional(),
  Filename: z.string().optional(),
  Password: z.string().optional(),
  Region: z.string().optional(),
  S3CompatibleHost: z.string().optional(),
  SecretAccessKey: z.string().optional(),
});

export const zBackupS3BackupPayload = z.object({
  accessKeyID: z.string().optional(),
  bucketName: z.string().optional(),
  cronRule: z.string().optional(),
  password: z.string().optional(),
  region: z.string().optional(),
  s3CompatibleHost: z.string().optional(),
  secretAccessKey: z.string().optional(),
});

export const zBuildBuildInfo = z.object({
  BuildNumber: z.string().optional(),
  GitCommit: z.string().optional(),
  GoVersion: z.string().optional(),
  ImageTag: z.string().optional(),
  NodejsVersion: z.string().optional(),
  PnpmVersion: z.string().optional(),
  WebpackVersion: z.string().optional(),
});

export const zBuildDependenciesInfo = z.object({
  ComposeVersion: z.string().optional(),
  DockerVersion: z.string().optional(),
  HelmVersion: z.string().optional(),
  KubectlVersion: z.string().optional(),
});

export const zBuildRuntimeInfo = z.object({
  Env: z.array(z.string()).optional(),
});

export const zContainerContainerState = z.enum([
  'created',
  'running',
  'paused',
  'restarting',
  'removing',
  'exited',
  'dead',
]);

export const zContainerPort = z.object({
  IP: z.string().optional(),
  PrivatePort: z.int().optional(),
  PublicPort: z.int().optional(),
  Type: z.string().optional(),
});

export const zContainersContainerGpusResponse = z.object({
  gpus: z.string().optional(),
});

export const zDockerImagesCounters = z.object({
  size: z.int().optional(),
  total: z.int().optional(),
});

export const zEdgegroupsEdgeGroupCreatePayload = z.object({
  Dynamic: z.boolean().optional(),
  Endpoints: z.array(z.int()).optional(),
  Name: z.string().optional(),
  PartialMatch: z.boolean().optional(),
  TagIDs: z.array(z.int()).optional(),
});

export const zEdgegroupsEdgeGroupUpdatePayload = z.object({
  Dynamic: z.boolean().optional(),
  Endpoints: z.array(z.int()).optional(),
  Name: z.string().optional(),
  PartialMatch: z.boolean().optional(),
  TagIDs: z.array(z.int()).optional(),
});

export const zEdgejobsEdgeJobCreateFromFileContentPayload = z.object({
  CronExpression: z.string().optional(),
  EdgeGroups: z.array(z.int()).optional(),
  Endpoints: z.array(z.int()).optional(),
  FileContent: z.string().optional(),
  Name: z.string().optional(),
  Recurring: z.boolean().optional(),
});

export const zEdgejobsEdgeJobFileResponse = z.object({
  FileContent: z.string().optional(),
});

export const zEdgejobsEdgeJobUpdatePayload = z.object({
  CronExpression: z.string().optional(),
  EdgeGroups: z.array(z.int()).optional(),
  Endpoints: z.array(z.int()).optional(),
  FileContent: z.string().optional(),
  Name: z.string().optional(),
  Recurring: z.boolean().optional(),
});

export const zEdgejobsFileResponse = z.object({
  FileContent: z.string().optional(),
});

export const zEdgestacksSummarizedStatus = z.enum([
  'Unavailable',
  'Deploying',
  'Failed',
  'Paused',
  'PartiallyRunning',
  'Completed',
  'Running',
]);

export const zEdgestacksDeployerOptionsPayload = z.object({
  Prune: z.boolean().optional(),
  RemoveVolumes: z.boolean().optional(),
});

export const zEdgestacksEdgeStackStaggerStatusResponse = z.object({
  status: z.string().optional(),
});

export const zEdgestacksGitHelmConfig = z.object({
  Atomic: z.boolean().optional(),
  ChartPath: z.string().optional(),
  Namespace: z.string().optional(),
  Timeout: z.string().optional(),
  ValuesFiles: z.array(z.string()).optional(),
});

export const zEdgestacksHelmRepositoryConfig = z.object({
  Atomic: z.boolean().optional(),
  ChartName: z.string().optional(),
  ChartURL: z.string().optional(),
  ChartVersion: z.string().optional(),
  Namespace: z.string().optional(),
  Timeout: z.string().optional(),
  ValuesInline: z.string().optional(),
});

export const zEdgeupdateschedulesActiveSchedulePayload = z.object({
  EnvironmentIDs: z.array(z.int()).optional(),
});

export const zEdgeupdateschedulesInfoResponse = z.object({
  HasLocalTimeZone: z.boolean().optional(),
  HasNoLocalTimeZone: z.boolean().optional(),
  MinAgentVersion: z.string().optional(),
  OutdatedCount: z.int().optional(),
  UpToDateCount: z.int().optional(),
});

export const zEdgeupdateschedulesInspectResponse = z.object({
  agentImage: z.string().optional(),
  created: z.int().optional(),
  createdBy: z.int().optional(),
  edgeGroupIds: z.array(z.int()).optional(),
  edgeStackId: z.int().optional(),
  environmentIds: z.array(z.int()).optional(),
  environmentsPreviousVersions: z.record(z.string(), z.string()).optional(),
  id: z.int().optional(),
  isActive: z.boolean().optional(),
  name: z.string().optional(),
  registryId: z.int().optional(),
  scheduledTime: z.string().optional(),
  type: z.union([z.literal(1), z.literal(2)]).optional(),
  updated: z.int().optional(),
  updaterImage: z.string().optional(),
  version: z.string().optional(),
});

export const zEndpointedgeEndpointTrustUpdateRelation = z.object({
  EdgeGroups: z.array(z.int()).optional(),
  Group: z.int().optional(),
  Tags: z.array(z.int()).optional(),
});

export const zEndpointedgeEndpointsTrustPayload = z.object({
  EndpointIDs: z.array(z.int()).optional(),
  Relations: z
    .record(z.string(), zEndpointedgeEndpointTrustUpdateRelation)
    .optional(),
});

export const zEndpointedgeGenerateKeyResponse = z.object({
  edgeKey: z.string().optional(),
});

export const zEndpointgroupsEndpointGroupTypeInfo = z.object({
  Docker: z.int(),
  Kubernetes: z.int(),
  Mixed: z.boolean(),
  Podman: z.int(),
});

export const zEndpointsAgentResponse = z.object({
  IsOutdated: z.boolean().optional(),
  PreviousVersion: z.string().optional(),
  Version: z.string().optional(),
});

export const zEndpointsDockerhubStatusResponse = z.object({
  limit: z.int().optional(),
  remaining: z.int().optional(),
});

export const zEndpointsEndpointCreateGlobalKeyResponse = z.object({
  endpointID: z.int().optional(),
});

export const zEndpointsEndpointDeleteBatchPartialResponse = z.object({
  deleted: z.array(z.int()).optional(),
  errors: z.array(z.int()).optional(),
});

export const zEndpointsEndpointDeleteRequest = z.object({
  deleteCluster: z.boolean().optional(),
  id: z.int().optional(),
});

export const zEndpointsEndpointDeleteBatchPayload = z.object({
  endpoints: z.array(zEndpointsEndpointDeleteRequest).optional(),
});

export const zEndpointsEndpointUpdateRelation = z.object({
  EdgeGroups: z.array(z.int()).optional(),
  Group: z.int().optional(),
  Tags: z.array(z.int()).optional(),
});

export const zEndpointsEndpointUpdateRelationsPayload = z.object({
  Relations: z.record(z.string(), zEndpointsEndpointUpdateRelation).optional(),
});

export const zEndpointsForceUpdateServicePayload = z.object({
  PullImage: z.boolean().optional(),
  ServiceID: z.string().optional(),
});

export const zEndpointsGroupCount = z.object({
  count: z.int().optional(),
  groupID: z.int().optional(),
  groupName: z.string().optional(),
});

export const zEndpointsHealthCounts = z.object({
  down: z.int().optional(),
  heartbeat: z.int().optional(),
  outdated: z.int().optional(),
  up: z.int().optional(),
});

export const zEndpointsPlatformCounts = z.object({
  azure: z.int().optional(),
  docker: z.int().optional(),
  kubernetes: z.int().optional(),
  podman: z.int().optional(),
});

export const zEndpointsEnvironmentSummaryCountsResponse = z.object({
  byGroup: z.array(zEndpointsGroupCount).optional(),
  byHealth: zEndpointsHealthCounts.optional(),
  byPlatformType: zEndpointsPlatformCounts.optional(),
  down: z.int().optional(),
  outdated: z.int().optional(),
  total: z.int().optional(),
  unassigned: z.int().optional(),
  up: z.int().optional(),
});

export const zEndpointsResourcePoolUpdatePayload = z.object({
  TeamsToAdd: z.array(z.int()).optional(),
  TeamsToRemove: z.array(z.int()).optional(),
  UsersToAdd: z.array(z.int()).optional(),
  UsersToRemove: z.array(z.int()).optional(),
});

export const zGithubComPortainerPortainerEeApiDockerImagesStatus = z.enum([
  'processing',
  'outdated',
  'updated',
  'skipped',
  'preparing',
  'error',
  'processing',
  'outdated',
  'updated',
  'skipped',
  'preparing',
  'error',
]);

export const zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType =
  z.union([z.literal(0), z.literal(1)]);

export const zGithubComPortainerPortainerEeApiGitTypesGitProvider = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
]);

export const zGitGitCredentialCreatePayload = z.object({
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType,
  name: z.string(),
  password: z.string(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider,
  urlPattern: z.string(),
  username: z.string(),
});

export const zGitGitCredentialUpdatePayload = z.object({
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType,
  name: z.string(),
  password: z.string(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider,
  urlPattern: z.string(),
  username: z.string(),
});

export const zGitShadowedGitCredential = z.object({
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  creationDate: z.int().optional(),
  id: z.int().optional(),
  name: z.string().optional(),
  password: z.string().optional(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  urlPattern: z.string().optional(),
  username: z.string().optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesFileResponse =
  z.object({
    FileContent: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksAggregatedStatusesMap =
  z.record(z.string(), z.int());

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackStatusSummary =
  z.object({
    AggregatedStatus:
      zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksAggregatedStatusesMap.optional(),
    Reason: z.string().optional(),
    Status: zEdgestacksSummarizedStatus.optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksStackFileResponse =
  z.object({
    StackFileContent: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerEndpointgroupsEndpointGroupCreatePayload =
  z.object({
    AssociatedEndpoints: z.array(z.int()).optional(),
    Description: z.string().optional(),
    Name: z.string(),
    TagIDs: z.array(z.int()).optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesDescribeResourceResponse =
  z.object({
    describe: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesDrainNodePayload =
  z.object({
    DeleteEmptyDirData: z.boolean().optional(),
    DisableEviction: z.boolean().optional(),
    Force: z.boolean().optional(),
    GracePeriodSeconds: z.int().optional(),
    IgnoreDaemonSets: z.boolean().optional(),
    TimeoutSeconds: z.int().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesVersionResponse =
  z.object({
    buildDate: z.string().optional(),
    compiler: z.string().optional(),
    emulationMajor: z.string().optional(),
    emulationMinor: z.string().optional(),
    gitCommit: z.string().optional(),
    gitTreeState: z.string().optional(),
    gitVersion: z.string().optional(),
    goVersion: z.string().optional(),
    major: z.string().optional(),
    minCompatibilityMajor: z.string().optional(),
    minCompatibilityMinor: z.string().optional(),
    minor: z.string().optional(),
    platform: z.string().optional(),
    supportsPodRestart: z.boolean().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesManifestDryRunPayload =
  z.object({
    manifests: z.array(z.string()).optional(),
    namespace: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesManifestDryRunResult =
  z.object({
    documentIndex: z.int().optional(),
    kind: z.string().optional(),
    message: z.string().optional(),
    name: z.string().optional(),
    namespace: z.string().optional(),
    status: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesManifestDryRunResponse =
  z.object({
    results: z
      .array(
        zGithubComPortainerPortainerEeApiHttpHandlerKubernetesManifestDryRunResult
      )
      .optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesNamespacesToggleSystemPayload =
  z.object({
    System: z.boolean().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerSystemNodesCountResponse =
  z.object({
    nodes: z.int().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerSystemStatus =
  z.object({
    InstanceID: z.string().optional(),
    Version: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerSystemVersionResponse =
  z.object({
    Build: zBuildBuildInfo.optional(),
    DatabaseVersion: z.string().optional(),
    Dependencies: zBuildDependenciesInfo.optional(),
    LatestVersion: z.string().optional(),
    Runtime: zBuildRuntimeInfo.optional(),
    ServerEdition: z.string().optional(),
    ServerVersion: z.string().optional(),
    UpdateAvailable: z.boolean().optional(),
    VersionSupport: z.string().optional(),
  });

export const zGithubComPortainerPortainerApiGitopsWorkflowsStatus = z.enum([
  'healthy',
  'syncing',
  'error',
  'paused',
  'unknown',
]);

export const zGitopsFileResponse = z.object({
  FileContent: z.string().optional(),
});

export const zGitopsHelmValuesPreviewPayload = z.object({
  TLSSkipVerify: z.boolean().optional(),
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  createdFromCustomTemplateID: z.int().optional(),
  fromEdgeStack: z.boolean().optional(),
  password: z.string().optional(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  reference: z.string().optional(),
  repository: z.string().optional(),
  sourceId: z.int().optional(),
  stackId: z.int().optional(),
  username: z.string().optional(),
  valuesFiles: z.array(z.string()),
});

export const zGitopsHelmValuesPreviewResponse = z.object({
  commitHash: z.string().optional(),
  filesProcessed: z.array(z.string()).optional(),
  mergedValues: z.string().optional(),
});

export const zGitopsRepositoryFilePreviewPayload = z.object({
  TLSSkipVerify: z.boolean().optional(),
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  createdFromCustomTemplateID: z.int().optional(),
  fromEdgeStack: z.boolean().optional(),
  password: z.string().optional(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  reference: z.string().optional(),
  repository: z.string().optional(),
  sourceId: z.int().optional(),
  stackId: z.int().optional(),
  targetFile: z.string().optional(),
  username: z.string().optional(),
});

export const zGitopsRepositoryFileSearchPayload = z.object({
  TLSSkipVerify: z.boolean().optional(),
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  createdFromCustomTemplateID: z.int().optional(),
  dirOnly: z.boolean().optional(),
  fromEdgeStack: z.boolean().optional(),
  include: z.string().optional(),
  keyword: z.string().optional(),
  password: z.string().optional(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  reference: z.string().optional(),
  repository: z.string().optional(),
  sourceId: z.int().optional(),
  stackId: z.int().optional(),
  username: z.string().optional(),
});

export const zGitopsRepositoryReferenceListPayload = z.object({
  TLSSkipVerify: z.boolean().optional(),
  authorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  createdFromCustomTemplateID: z.int().optional(),
  fromEdgeStack: z.boolean().optional(),
  password: z.string().optional(),
  provider: zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  repository: z.string().optional(),
  sourceId: z.int().optional(),
  stackId: z.int().optional(),
  username: z.string().optional(),
});

export const zGittypes = z.union([z.literal(0), z.literal(1)]);

export const zGithubComPortainerPortainerEeApiGitTypesGitAuthentication =
  z.object({
    AuthorizationType: zGittypes.optional(),
    GitCredentialID: z.int().optional(),
    Password: z.string().optional(),
    Provider: zGittypes.optional(),
    Username: z.string().optional(),
  });

export const zGithubComPortainerPortainerApiGitTypesGitAuthentication =
  z.object({
    AuthorizationType: zGittypes.optional(),
    GitCredentialID: z.int().optional(),
    Password: z.string().optional(),
    Provider: zGittypes.optional(),
    Username: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiGitTypesRepoConfig = z.object({
  Authentication:
    zGithubComPortainerPortainerApiGitTypesGitAuthentication.optional(),
  ConfigFilePath: z.string().optional(),
  ConfigHash: z.string().optional(),
  ReferenceName: z.string().optional(),
  TLSSkipVerify: z.boolean().optional(),
  URL: z.string().optional(),
});

export const zGithubComPortainerPortainerApiGitTypesGitSource = z.object({
  Authentication:
    zGithubComPortainerPortainerApiGitTypesGitAuthentication.optional(),
  TLSSkipVerify: z.boolean().optional(),
  URL: z.string().optional(),
});

export const zGithubComPortainerPortainerApiGitTypesRepoConfig = z.object({
  Authentication:
    zGithubComPortainerPortainerApiGitTypesGitAuthentication.optional(),
  ConfigFilePath: z.string().optional(),
  ConfigHash: z.string().optional(),
  ReferenceName: z.string().optional(),
  TLSSkipVerify: z.boolean().optional(),
  URL: z.string().optional(),
});

export const zHelmGitHelmDryRunPayload = z.object({
  helmChartPath: z.string().optional(),
  helmValuesFiles: z.array(z.string()).optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  repositoryAuthentication: z.boolean().optional(),
  repositoryAuthorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  repositoryPassword: z.string().optional(),
  repositoryProvider:
    zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  repositoryReferenceName: z.string().optional(),
  repositoryURL: z.string().optional(),
  repositoryUsername: z.string().optional(),
  sourceId: z.int().optional(),
  tlsSkipVerify: z.boolean().optional(),
});

export const zHelmInstallChartPayload = z.object({
  atomic: z.boolean().optional(),
  chart: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  registryId: z.int().optional(),
  repo: z.string().optional(),
  values: z.string().optional(),
  version: z.string().optional(),
});

export const zImagesImageResponse = z.object({
  created: z.int().optional(),
  id: z.string().optional(),
  nodeName: z.string().optional(),
  size: z.int().optional(),
  tags: z.array(z.string()).optional(),
  used: z.boolean().optional(),
});

export const zImagesStatusResponse = z.object({
  Message: z.string().optional(),
  Status: zGithubComPortainerPortainerEeApiDockerImagesStatus.optional(),
});

export const zIntstrType = z.union([z.literal(0), z.literal(1)]);

export const zIntstrIntOrString = z.object({
  IntVal: z.int().optional(),
  StrVal: z.string().optional(),
  Type: zIntstrType.optional(),
});

export const zK8sIoApiAppsV1DeploymentConditionType = z.enum([
  'Available',
  'Progressing',
  'ReplicaFailure',
]);

export const zK8sIoApiAppsV1DeploymentStrategyType = z.enum([
  'Recreate',
  'RollingUpdate',
]);

export const zK8sIoApiCoreV1ConditionStatus = z.enum([
  'True',
  'False',
  'Unknown',
]);

export const zK8sIoApiAppsV1DeploymentCondition = z.object({
  lastTransitionTime: z.string().optional(),
  lastUpdateTime: z.string().optional(),
  message: z.string().optional(),
  reason: z.string().optional(),
  status: zK8sIoApiCoreV1ConditionStatus.optional(),
  type: zK8sIoApiAppsV1DeploymentConditionType.optional(),
});

export const zK8sIoApiCoreV1HttpHeader = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
});

export const zK8sIoApiCoreV1LocalObjectReference = z.object({
  name: z.string().optional(),
});

export const zK8sIoApiCoreV1ObjectReference = z.object({
  apiVersion: z.string().optional(),
  fieldPath: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  resourceVersion: z.string().optional(),
  uid: z.string().optional(),
});

export const zK8sIoApiCoreV1ResourceClaim = z.object({
  name: z.string().optional(),
  request: z.string().optional(),
});

export const zK8sIoApiRbacV1Subject = z.object({
  apiGroup: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
});

export const zKubernetesConfiguration = z.object({
  ConfigurationOwner: z.string().optional(),
  Data: z.record(z.string(), z.unknown()).optional(),
  Kind: z.string().optional(),
});

export const zKubernetesCustomResourceMetadata = z.object({
  apiVersion: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  plural: z.string().optional(),
  scope: z.string().optional(),
});

export const zKubernetesK8sApplicationResource = z.object({
  CpuLimit: z.number().optional(),
  CpuRequest: z.number().optional(),
  MemoryLimit: z.int().optional(),
  MemoryRequest: z.int().optional(),
});

export const zKubernetesK8sClusterRole = z.object({
  creationDate: z.string().optional(),
  isSystem: z.boolean().optional(),
  name: z.string().optional(),
  uid: z.string().optional(),
});

export const zKubernetesK8sConfigMapWriteRequest = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  Data: z.record(z.string(), z.string()).optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Name: z.string().optional(),
});

export const zKubernetesK8sContainerPort = z.object({
  containerPort: z.int().optional(),
  name: z.string().optional(),
  protocol: z.string().optional(),
});

export const zKubernetesK8sCronJobDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zKubernetesK8sDeploymentPatchRequest = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  podAnnotations: z.record(z.string(), z.string()).optional(),
});

export const zKubernetesK8sDeploymentRollbackRequest = z.object({
  revision: z.int().optional(),
});

export const zKubernetesK8sDeploymentScaleRequest = z.object({
  replicas: z.int().optional(),
});

export const zKubernetesK8sEndpointAddress = z.object({
  ip: z.string().optional(),
  nodeName: z.string().optional(),
});

export const zKubernetesK8sEndpointPort = z.object({
  name: z.string().optional(),
  port: z.int().optional(),
  protocol: z.string().optional(),
});

export const zKubernetesK8sEndpoint = z.object({
  addresses: z.array(zKubernetesK8sEndpointAddress).optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  ports: z.array(zKubernetesK8sEndpointPort).optional(),
  uid: z.string().optional(),
});

export const zKubernetesK8sEventInvolvedObject = z.object({
  kind: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  uid: z.string().optional(),
});

export const zKubernetesK8sEvent = z.object({
  count: z.int().optional(),
  eventTime: z.string().optional(),
  firstTimestamp: z.string().optional(),
  involvedObject: zKubernetesK8sEventInvolvedObject.optional(),
  kind: z.string().optional(),
  lastTimestamp: z.string().optional(),
  message: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  reason: z.string().optional(),
  type: z.string().optional(),
  uid: z.string().optional(),
});

export const zKubernetesK8sIngressClass = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  Controller: z.string().optional(),
  IsDefault: z.boolean().optional(),
  Name: z.string().optional(),
});

export const zKubernetesK8sJobDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zKubernetesK8sPodVolume = z.object({
  claimName: z.string().optional(),
  name: z.string().optional(),
});

export const zKubernetesK8sResourceRequirements = z.object({
  limits: z.record(z.string(), z.string()).optional(),
  requests: z.record(z.string(), z.string()).optional(),
});

export const zKubernetesK8sSecretKeyRef = z.object({
  key: z.string().optional(),
  name: z.string().optional(),
});

export const zKubernetesK8sEnvVar = z.object({
  name: z.string().optional(),
  secretRef: zKubernetesK8sSecretKeyRef.optional(),
  value: z.string().optional(),
});

export const zKubernetesK8sSecretWriteRequest = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  Data: z.record(z.string(), z.string()).optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Name: z.string().optional(),
  SecretType: z.string().optional(),
});

export const zKubernetesK8sServiceAccount = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  automountServiceAccountToken: z.boolean().optional(),
  creationDate: z.string().optional(),
  imagePullSecrets: z.array(zK8sIoApiCoreV1LocalObjectReference).optional(),
  isSystem: z.boolean().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  uid: z.string().optional(),
});

export const zKubernetesK8sServiceAccountDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zKubernetesK8sServiceAccountImagePullSecretsUpdatePayload =
  z.object({
    secretNames: z.array(z.string()).optional(),
  });

export const zKubernetesK8sVolumeMount = z.object({
  mountPath: z.string().optional(),
  name: z.string().optional(),
  readOnly: z.boolean().optional(),
  subPath: z.string().optional(),
});

export const zKubernetesK8sContainer = z.object({
  args: z.array(z.string()).optional(),
  command: z.array(z.string()).optional(),
  env: z.array(zKubernetesK8sEnvVar).optional(),
  envFromSecrets: z.array(z.string()).optional(),
  image: z.string().optional(),
  imagePullPolicy: z.string().optional(),
  name: z.string().optional(),
  ports: z.array(zKubernetesK8sContainerPort).optional(),
  resources: zKubernetesK8sResourceRequirements.optional(),
  volumeMounts: z.array(zKubernetesK8sVolumeMount).optional(),
  workingDir: z.string().optional(),
});

export const zKubernetesK8sPodTemplate = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  containers: z.array(zKubernetesK8sContainer).optional(),
  labels: z.record(z.string(), z.string()).optional(),
  volumes: z.array(zKubernetesK8sPodVolume).optional(),
});

export const zKubernetesK8sDeploymentWriteRequest = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  pod: zKubernetesK8sPodTemplate.optional(),
  replicas: z.int().optional(),
  selector: z.record(z.string(), z.string()).optional(),
});

export const zKubernetesMetadata = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  labels: z.record(z.string(), z.string()).optional(),
});

export const zKubernetesPod = z.object({
  ContainerName: z.string().optional(),
  CreationDate: z.string().optional(),
  Image: z.string().optional(),
  ImagePullPolicy: z.string().optional(),
  Name: z.string().optional(),
  NodeName: z.string().optional(),
  PodIP: z.string().optional(),
  Resource: zKubernetesK8sApplicationResource.optional(),
  Status: z.string().optional(),
  Uid: z.string().optional(),
});

export const zKubernetesTlsInfo = z.object({
  hosts: z.array(z.string()).optional(),
});

export const zKubernetesIngressRule = z.object({
  Host: z.string().optional(),
  IP: z.string().optional(),
  Path: z.string().optional(),
  TLS: z.array(zKubernetesTlsInfo).optional(),
});

export const zKubernetesPublishedPort = z.object({
  IngressRules: z.array(zKubernetesIngressRule).optional(),
  Port: z.int().optional(),
});

export const zKubernetesK8sApplication = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  ApplicationOwner: z.string().optional(),
  ApplicationType: z.string().optional(),
  Configurations: z.array(zKubernetesConfiguration).optional(),
  Containers: z.array(z.unknown()).optional(),
  CreationDate: z.string().optional(),
  CustomResourceMetadata: zKubernetesCustomResourceMetadata.optional(),
  DeploymentType: z.string().optional(),
  Id: z.string().optional(),
  Image: z.string().optional(),
  Kind: z.string().optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  LoadBalancerIPAddress: z.string().optional(),
  MatchLabels: z.record(z.string(), z.string()).optional(),
  Metadata: zKubernetesMetadata.optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Pods: z.array(zKubernetesPod).optional(),
  PublishedPorts: z.array(zKubernetesPublishedPort).optional(),
  Resource: zKubernetesK8sApplicationResource.optional(),
  ResourcePool: z.string().optional(),
  RunningPodsCount: z.int().optional(),
  ServiceId: z.string().optional(),
  ServiceName: z.string().optional(),
  ServiceType: z.string().optional(),
  StackId: z.string().optional(),
  StackKind: z.string().optional(),
  StackName: z.string().optional(),
  Status: z.string().optional(),
  TotalPodsCount: z.int().optional(),
  Uid: z.string().optional(),
});

export const zKubernetesScopedKubeconfigPayload = z.object({
  description: z.string().optional(),
  expirySeconds: z.int(),
  includeSecrets: z.boolean().optional(),
  namespaces: z.array(z.string()).optional(),
});

export const zKubernetesScopedKubeconfigResponse = z.object({
  expiresAt: z.int().optional(),
  id: z.int().optional(),
  includeSecrets: z.boolean().optional(),
  kubeconfig: z.string().optional(),
  namespaces: z.array(z.string()).optional(),
  serviceAccount: z.string().optional(),
});

export const zKubernetesScopedKubeconfigStatusResponse = z.object({
  active: z.boolean().optional(),
  description: z.string().optional(),
  expiresAt: z.int().optional(),
  id: z.int().optional(),
  includeSecrets: z.boolean().optional(),
  namespaces: z.array(z.string()).optional(),
  serviceAccount: z.string().optional(),
});

export const zLdapTestLoginResponse = z.object({
  valid: z.boolean().optional(),
});

export const zLiblicensePortainerLicenseType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
]);

export const zLiblicenseProductEdition = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zLiblicensePortainerLicense = z.object({
  company: z.string().optional(),
  created: z.int().optional(),
  email: z.string().optional(),
  expiresAfter: z.int().optional(),
  expiresAt: z.int().optional(),
  firstCheckin: z.int().optional(),
  id: z.string().optional(),
  lastCheckin: z.int().optional(),
  licenseKey: z.string().optional(),
  multiCheckinCount: z.int().optional(),
  multiuseInstancesCount: z.int().optional(),
  nodes: z.int().optional(),
  productEdition: zLiblicenseProductEdition.optional(),
  redisRef: z.string().optional(),
  reference: z.string().optional(),
  revoked: z.boolean().optional(),
  revokedAt: z.int().optional(),
  type: zLiblicensePortainerLicenseType.optional(),
  uniqueId: z.string().optional(),
  version: z.int().optional(),
});

export const zLicensesLicenseInfo = z.object({
  company: z.string().optional(),
  enforcedAt: z.int().optional(),
  expiresAt: z.int().optional(),
  nodes: z.int().optional(),
  overuseStartedTimestamp: z.int().optional(),
  type: zLiblicensePortainerLicenseType.optional(),
  valid: z.boolean().optional(),
});

export const zLicensesAttachData = z.object({
  conflictingKeys: z.array(z.string()).optional(),
});

export const zLicensesAttachPayload = z.object({
  key: z.string().optional(),
});

export const zLicensesDeletePayload = z.object({
  LicenseKeys: z.array(z.string()).optional(),
});

export const zModelsCloudCredentialMap = z.record(z.string(), z.string());

export const zModelsCloudCredential = z.object({
  created: z.int().optional(),
  credentials: zModelsCloudCredentialMap.optional(),
  id: z.int().optional(),
  name: z.string().optional(),
  provider: z.string().optional(),
});

export const zModelsConfiguration = z.object({
  ConfigurationOwner: z.string().optional(),
  Data: z.record(z.string(), z.unknown()).optional(),
  Kind: z.string().optional(),
});

export const zModelsK8sApplicationResource = z.object({
  CpuLimit: z.number().optional(),
  CpuRequest: z.number().optional(),
  MemoryLimit: z.int().optional(),
  MemoryRequest: z.int().optional(),
});

export const zModelsK8sConfigurationOwnerResource = z.object({
  Id: z.string().optional(),
  Name: z.string().optional(),
  ResourceKind: z.string().optional(),
});

export const zModelsK8sConfigMap = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  ConfigurationOwner: z.string().optional(),
  ConfigurationOwnerId: z.string().optional(),
  ConfigurationOwners: z.array(zModelsK8sConfigurationOwnerResource).optional(),
  CreationDate: z.string().optional(),
  Data: z.record(z.string(), z.string()).optional(),
  IsUsed: z.boolean().optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  UID: z.string().optional(),
});

export const zModelsK8sCustomResource = z.object({
  creationDate: z.string().optional(),
  definitionName: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  uid: z.string().optional(),
});

export const zModelsK8sCustomResourceDefinition = z.object({
  creationDate: z.string().optional(),
  group: z.string().optional(),
  name: z.string().optional(),
  releaseName: z.string().optional(),
  releaseNamespace: z.string().optional(),
  releaseVersion: z.string().optional(),
  scope: z.string().optional(),
});

export const zModelsK8sDashboard = z.object({
  applicationsCount: z.int().optional(),
  configMapsCount: z.int().optional(),
  ingressesCount: z.int().optional(),
  namespacesCount: z.int().optional(),
  secretsCount: z.int().optional(),
  servicesCount: z.int().optional(),
  volumesCount: z.int().optional(),
});

export const zModelsK8sGpuNodeStatus = z.enum([
  'Ready',
  'Degraded',
  'Not Available',
]);

export const zModelsK8sGpuNode = z.object({
  Allocatable: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  Allocated: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  Capacity: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  Name: z.string().optional(),
  Status: zModelsK8sGpuNodeStatus.optional(),
  StatusReason: z.string().optional(),
});

export const zModelsK8sGpuSummary = z.object({
  DegradedCount: z.int().optional(),
  DevicePluginDetected: z.boolean().optional(),
  GPUNodeCount: z.int().optional(),
  OperatorDetected: z.boolean().optional(),
  TotalAllocatable: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  TotalAllocated: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  TotalCapacity: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
});

export const zModelsK8sGpuWorkload = z.object({
  GPURequests: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  Namespace: z.string().optional(),
  NodeName: z.string().optional(),
  OwnerKind: z.string().optional(),
  OwnerName: z.string().optional(),
  PodName: z.string().optional(),
  PodPhase: z.string().optional(),
  SchedulingIssue: z.string().optional(),
});

export const zModelsK8sGpuInfo = z.object({
  Nodes: z.array(zModelsK8sGpuNode).optional(),
  Summary: zModelsK8sGpuSummary.optional(),
  Workloads: z.array(zModelsK8sGpuWorkload).optional(),
});

export const zModelsK8sIngressController = z.object({
  Availability: z.boolean().optional(),
  ClassName: z.string().optional(),
  Name: z.string().optional(),
  New: z.boolean().optional(),
  Type: z.string().optional(),
  Used: z.boolean().optional(),
});

export const zModelsK8sIngressDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zModelsK8sIngressPath = z.object({
  HasService: z.boolean().optional(),
  Host: z.string().optional(),
  IngressName: z.string().optional(),
  Path: z.string().optional(),
  PathType: z.string().optional(),
  Port: z.int().optional(),
  ServiceName: z.string().optional(),
});

export const zModelsK8sIngressTls = z.object({
  Hosts: z.array(z.string()).optional(),
  SecretName: z.string().optional(),
});

export const zModelsK8sIngressInfo = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  ClassName: z.string().optional(),
  CreationDate: z.string().optional(),
  Hosts: z.array(z.string()).optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Paths: z.array(zModelsK8sIngressPath).optional(),
  TLS: z.array(zModelsK8sIngressTls).optional(),
  Type: z.string().optional(),
  UID: z.string().optional(),
});

export const zModelsK8sLoadBalancerQuota = z.object({
  enabled: z.boolean().optional(),
  limit: z.int().optional(),
});

export const zModelsK8sPvcResizeRequest = z.object({
  name: z.string().optional(),
  namespace: z.string().optional(),
  newSize: z.string().optional(),
});

export const zModelsK8sResourceQuota = z.object({
  cpuLimit: z.string().optional(),
  cpuRequest: z.string().optional(),
  enabled: z.boolean().optional(),
  memoryLimit: z.string().optional(),
  memoryRequest: z.string().optional(),
});

export const zModelsK8sRoleBindingDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zModelsK8sRoleDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zModelsK8sSecret = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  ConfigurationOwner: z.string().optional(),
  ConfigurationOwnerId: z.string().optional(),
  ConfigurationOwners: z.array(zModelsK8sConfigurationOwnerResource).optional(),
  CreationDate: z.string().optional(),
  Data: z.record(z.string(), z.string()).optional(),
  IsUsed: z.boolean().optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  SecretType: z.string().optional(),
  UID: z.string().optional(),
});

export const zModelsK8sServiceDeleteRequests = z.record(
  z.string(),
  z.array(z.string())
);

export const zModelsK8sServiceIngress = z.object({
  Host: z.string().optional(),
  IP: z.string().optional(),
});

export const zModelsK8sServicePort = z.object({
  Name: z.string().optional(),
  NodePort: z.int().optional(),
  Port: z.int().optional(),
  Protocol: z.string().optional(),
  TargetPort: z.string().optional(),
});

export const zModelsK8sStorageQuota = z.object({
  enabled: z.boolean().optional(),
  limit: z.string().optional(),
});

export const zModelsK8sNamespaceDetails = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  LoadBalancerQuota: zModelsK8sLoadBalancerQuota.optional(),
  Name: z.string().optional(),
  Owner: z.string().optional(),
  ResourceQuota: zModelsK8sResourceQuota.optional(),
  StorageQuotas: z.record(z.string(), zModelsK8sStorageQuota).optional(),
});

export const zModelsK8sVolumeDeleteRequest = z.object({
  name: z.string().optional(),
  namespace: z.string().optional(),
});

export const zModelsMatcher = z.object({
  isEqual: z.boolean().optional(),
  isRegex: z.boolean().optional(),
  name: z.string().optional(),
  value: z.string().optional(),
});

export const zModelsMetadata = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  labels: z.record(z.string(), z.string()).optional(),
});

export const zModelsPod = z.object({
  ContainerName: z.string().optional(),
  CreationDate: z.string().optional(),
  Image: z.string().optional(),
  ImagePullPolicy: z.string().optional(),
  Name: z.string().optional(),
  NodeName: z.string().optional(),
  PodIP: z.string().optional(),
  Status: z.string().optional(),
  Uid: z.string().optional(),
});

export const zModelsPostableSilence = z.object({
  comment: z.string().optional(),
  createdBy: z.string().optional(),
  endsAt: z.string().optional(),
  id: z.string().optional(),
  matchers: z.array(zModelsMatcher).optional(),
  startsAt: z.string().optional(),
});

export const zModelsSshKeyPair = z.object({
  private: z.string().optional(),
  public: z.string().optional(),
});

export const zModelsTlsInfo = z.object({
  hosts: z.array(z.string()).optional(),
});

export const zModelsIngressRule = z.object({
  Host: z.string().optional(),
  IP: z.string().optional(),
  Path: z.string().optional(),
  TLS: z.array(zModelsTlsInfo).optional(),
});

export const zModelsPublishedPort = z.object({
  IngressRules: z.array(zModelsIngressRule).optional(),
  Port: z.int().optional(),
});

export const zModelsK8sApplication = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  ApplicationOwner: z.string().optional(),
  ApplicationType: z.string().optional(),
  Configurations: z.array(zModelsConfiguration).optional(),
  Containers: z.array(z.unknown()).optional(),
  CreationDate: z.string().optional(),
  DeploymentType: z.string().optional(),
  Id: z.string().optional(),
  Image: z.string().optional(),
  Kind: z.string().optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  LoadBalancerIPAddress: z.string().optional(),
  MatchLabels: z.record(z.string(), z.string()).optional(),
  Metadata: zModelsMetadata.optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Pods: z.array(zModelsPod).optional(),
  PublishedPorts: z.array(zModelsPublishedPort).optional(),
  Resource: zModelsK8sApplicationResource.optional(),
  ResourcePool: z.string().optional(),
  RunningPodsCount: z.int().optional(),
  ServiceId: z.string().optional(),
  ServiceName: z.string().optional(),
  ServiceType: z.string().optional(),
  StackId: z.string().optional(),
  StackName: z.string().optional(),
  Status: z.string().optional(),
  TotalPodsCount: z.int().optional(),
  Uid: z.string().optional(),
});

export const zModelsK8sServiceInfo = z.object({
  AllocateLoadBalancerNodePorts: z.boolean().optional(),
  Annotations: z.record(z.string(), z.string()).optional(),
  Applications: z.array(zModelsK8sApplication).optional(),
  ClusterIPs: z.array(z.string()).optional(),
  CreationDate: z.string().optional(),
  ExternalIPs: z.array(z.string()).optional(),
  ExternalName: z.string().optional(),
  IngressStatus: z.array(zModelsK8sServiceIngress).optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Ports: z.array(zModelsK8sServicePort).optional(),
  Selector: z.record(z.string(), z.string()).optional(),
  Type: z.string().optional(),
  UID: z.string().optional(),
});

export const zMotdMotd = z.object({
  ContentLayout: z.record(z.string(), z.string()).optional(),
  Hash: z.array(z.int()).optional(),
  Message: z.string().optional(),
  Style: z.string().optional(),
  Title: z.string().optional(),
});

export const zMountPropagation = z.enum([
  'rprivate',
  'private',
  'rshared',
  'shared',
  'rslave',
  'slave',
]);

export const zMountType = z.enum([
  'bind',
  'volume',
  'tmpfs',
  'npipe',
  'cluster',
  'image',
]);

export const zContainerMountPoint = z.object({
  Destination: z.string().optional(),
  Driver: z.string().optional(),
  Mode: z.string().optional(),
  Name: z.string().optional(),
  Propagation: zMountPropagation.optional(),
  RW: z.boolean().optional(),
  Source: z.string().optional(),
  Type: zMountType.optional(),
});

export const zNetworkEndpointIpamConfig = z.object({
  IPv4Address: z.string().optional(),
  IPv6Address: z.string().optional(),
  LinkLocalIPs: z.array(z.string()).optional(),
});

export const zNetworkEndpointSettings = z.object({
  Aliases: z.array(z.string()).optional(),
  DNSNames: z.array(z.string()).optional(),
  DriverOpts: z.record(z.string(), z.string()).optional(),
  EndpointID: z.string().optional(),
  Gateway: z.string().optional(),
  GlobalIPv6Address: z.string().optional(),
  GlobalIPv6PrefixLen: z.int().optional(),
  GwPriority: z.int().optional(),
  IPAMConfig: zNetworkEndpointIpamConfig.optional(),
  IPAddress: z.string().optional(),
  IPPrefixLen: z.int().optional(),
  IPv6Gateway: z.string().optional(),
  Links: z.array(z.string()).optional(),
  MacAddress: z.string().optional(),
  NetworkID: z.string().optional(),
});

export const zContainerNetworkSettingsSummary = z.object({
  Networks: z.record(z.string(), zNetworkEndpointSettings).optional(),
});

export const zOauth2AuthStyle = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zObservabilityAlertRuleGroupsUpdatePayload = z.object({
  endpointGroupIds: z.array(z.int()).optional(),
});

export const zObservabilityCreateSilencePayload = z.object({
  alertManagerURL: z.string(),
  silence: zModelsPostableSilence,
});

export const zObservabilityEnvironmentObservabilityResponse = z.object({
  clusterId: z.string().optional(),
  clusterName: z.string().optional(),
  enabled: z.boolean().optional(),
  projectId: z.string().optional(),
  provider: z.string().optional(),
  url: z.string().optional(),
});

export const zObservabilityLogEntry = z.object({
  labels: z.record(z.string(), z.string()).optional(),
  message: z.string().optional(),
  severity: z.string().optional(),
  source: z.string().optional(),
  time: z.string().optional(),
});

export const zObservabilityLogsResponse = z.object({
  logs: z.array(zObservabilityLogEntry).optional(),
});

export const zOmniCancelProvisioningPayload = z.object({
  deleteCluster: z.boolean().optional(),
  endpointId: z.int().optional(),
});

export const zOmniClusterSpecBackupConfiguration = z.object({
  enabled: z.boolean().optional(),
  interval: z.string().optional(),
});

export const zOmniClusterSpecFeatures = z.object({
  disk_encryption: z.boolean().optional(),
  enable_workload_proxy: z.boolean().optional(),
  use_embedded_discovery_service: z.boolean().optional(),
});

export const zOmniClusterSpec = z.object({
  backup_configuration: zOmniClusterSpecBackupConfiguration.optional(),
  features: zOmniClusterSpecFeatures.optional(),
  kubernetes_version: z.string().optional(),
  talos_version: z.string().optional(),
});

export const zOmniClusterStatusMachines = z.object({
  connected: z.int().optional(),
  healthy: z.int().optional(),
  requested: z.int().optional(),
  total: z.int().optional(),
});

export const zOmniClusterStatusSpec = z.object({
  available: z.boolean().optional(),
  controlplaneReady: z.boolean().optional(),
  has_connected_control_planes: z.boolean().optional(),
  kubernetesAPIReady: z.boolean().optional(),
  machines: zOmniClusterStatusMachines.optional(),
  phase: z.int().optional(),
  ready: z.boolean().optional(),
  use_embedded_discovery_service: z.boolean().optional(),
});

export const zOmniClusterData = z.object({
  metadata: zOmniClusterSpec.optional(),
  status: zOmniClusterStatusSpec.optional(),
});

export const zOmniMachineHardwareBlockDevice = z.object({
  linux_name: z.string().optional(),
  model: z.string().optional(),
  size: z.int().optional(),
  system_disk: z.boolean().optional(),
  type: z.string().optional(),
});

export const zOmniMachineHardwareMemory = z.object({
  description: z.string().optional(),
  size_mb: z.int().optional(),
});

export const zOmniMachineHardwareProcessor = z.object({
  core_count: z.int().optional(),
  description: z.string().optional(),
  frequency: z.int().optional(),
  manufacturer: z.string().optional(),
  thread_count: z.int().optional(),
});

export const zOmniMachineHardwareStatus = z.object({
  arch: z.string().optional(),
  blockdevices: z.array(zOmniMachineHardwareBlockDevice).optional(),
  memory_modules: z.array(zOmniMachineHardwareMemory).optional(),
  processors: z.array(zOmniMachineHardwareProcessor).optional(),
});

export const zOmniMachineNetworkLink = z.object({
  hardware_address: z.string().optional(),
  link_up: z.boolean().optional(),
  linux_name: z.string().optional(),
  speed_mbps: z.int().optional(),
});

export const zOmniMachineNetworkStatus = z.object({
  addresses: z.array(z.string()).optional(),
  default_gateways: z.array(z.string()).optional(),
  domainname: z.string().optional(),
  hostname: z.string().optional(),
  network_links: z.array(zOmniMachineNetworkLink).optional(),
});

export const zOmniMachinePlatformMetadata = z.object({
  hostname: z.string().optional(),
  instance_id: z.string().optional(),
  instance_type: z.string().optional(),
  platform: z.string().optional(),
  region: z.string().optional(),
  zone: z.string().optional(),
});

export const zOmniMachineStatusSpec = z.object({
  cluster: z.string().optional(),
  connected: z.boolean().optional(),
  hardware: zOmniMachineHardwareStatus.optional(),
  last_error: z.string().optional(),
  maintenance: z.boolean().optional(),
  management_address: z.string().optional(),
  network: zOmniMachineNetworkStatus.optional(),
  platform_metadata: zOmniMachinePlatformMetadata.optional(),
  power_state: z.string().optional(),
  role: z.string().optional(),
  talos_version: z.string().optional(),
});

export const zOmniMachineData = z.object({
  labels: z.record(z.string(), z.string()).optional(),
  machineName: z.string().optional(),
  spec: zOmniMachineStatusSpec.optional(),
});

export const zOmniUpgradeStatusResponse = z.object({
  current_upgrade_version: z.string().optional(),
  error: z.string().optional(),
  last_upgrade_version: z.string().optional(),
  phase: z.int().optional(),
  status: z.string().optional(),
  step: z.string().optional(),
  upgrade_versions: z.array(z.string()).optional(),
});

export const zOneuptimeMetricsAggregateResponse = z.object({
  data: z.array(z.record(z.string(), z.unknown())).optional(),
});

export const zPlatformContainerPlatform = z.enum([
  'Docker',
  'Docker Standalone',
  'Docker Swarm',
  'Kubernetes',
  'Podman',
]);

export const zGithubComPortainerPortainerEeApiHttpHandlerSystemSystemInfoResponse =
  z.object({
    addonsAvailable: z.boolean().optional(),
    agents: z.int().optional(),
    edgeAgents: z.int().optional(),
    edgeDevices: z.int().optional(),
    platform: zPlatformContainerPlatform.optional(),
  });

export const zPodsecurityFsGroupStrategyType = z.enum([
  'MayRunAs',
  'MustRunAs',
  'RunAsAny',
]);

export const zPodsecurityFsType = z.enum([
  'azureFile',
  'flocker',
  'flexVolume',
  'hostPath',
  'emptyDir',
  'gcePersistentDisk',
  'awsElasticBlockStore',
  'gitRepo',
  'secret',
  'nfs',
  'iscsi',
  'glusterfs',
  'persistentVolumeClaim',
  'rbd',
  'cinder',
  'cephFS',
  'downwardAPI',
  'fc',
  'configMap',
  'vsphereVolume',
  'quobyte',
  'azureDisk',
  'photonPersistentDisk',
  'storageos',
  'projected',
  'portworxVolume',
  'scaleIO',
  'csi',
  'ephemeral',
  '*',
]);

export const zPodsecurityPodSecurityAllowFlexVolumes = z.object({
  allowedVolumes: z.array(z.string()).optional(),
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityAllowPrivilegeEscalation = z.object({
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityAllowProcMount = z.object({
  enabled: z.boolean().optional(),
  procMountType: z.string().optional(),
});

export const zPodsecurityPodSecurityAllowedCapabilities = z.object({
  level: z.string().optional(),
  role: z.string().optional(),
  type: z.string().optional(),
  user: z.string().optional(),
});

export const zPodsecurityPodSecurityAllowedPaths = z.object({
  pathPrefix: z.string().optional(),
  readonly: z.boolean().optional(),
});

export const zPodsecurityPodSecurityAppArmour = z.object({
  AppArmorType: z.array(z.string()).optional(),
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityCapabilities = z.object({
  allowedCapabilities: z.array(z.string()).optional(),
  enabled: z.boolean().optional(),
  requiredDropCapabilities: z.array(z.string()).optional(),
});

export const zPodsecurityPodSecurityForbiddenSysctlsList = z.object({
  enabled: z.boolean().optional(),
  requiredDropCapabilities: z.array(z.string()).optional(),
});

export const zPodsecurityPodSecurityHostFilesystem = z.object({
  allowedPaths: z.array(zPodsecurityPodSecurityAllowedPaths).optional(),
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityHostNamespaces = z.object({
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityHostNetworkingPorts = z.object({
  enabled: z.boolean().optional(),
  hostNetwork: z.boolean().optional(),
  max: z.int().optional(),
  min: z.int().optional(),
});

export const zPodsecurityPodSecurityIdrange = z.object({
  max: z.int().optional(),
  min: z.int().optional(),
});

export const zPodsecurityPodSecurityFsGroups = z.object({
  idrange: z.array(zPodsecurityPodSecurityIdrange).optional(),
  type: zPodsecurityFsGroupStrategyType.optional(),
});

export const zPodsecurityPodSecurityPrivilegedContainers = z.object({
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityReadOnlyRootFileSystem = z.object({
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecuritySecComp = z.object({
  enabled: z.boolean().optional(),
  secCompType: z.array(z.string()).optional(),
});

export const zPodsecurityPodSecuritySelinux = z.object({
  allowedCapabilities: z
    .array(zPodsecurityPodSecurityAllowedCapabilities)
    .optional(),
  enabled: z.boolean().optional(),
});

export const zPodsecurityPodSecurityVolumeTypes = z.object({
  allowedTypes: z.array(zPodsecurityFsType).optional(),
  enabled: z.boolean().optional(),
});

export const zPodsecurityRunAsGroupStrategy = z.enum([
  'MayRunAs',
  'MustRunAs',
  'RunAsAny',
]);

export const zPodsecurityPodSecurityRunAsGroup = z.object({
  idrange: z.array(zPodsecurityPodSecurityIdrange).optional(),
  type: zPodsecurityRunAsGroupStrategy.optional(),
});

export const zPodsecurityRunAsUserStrategy = z.enum([
  'MustRunAs',
  'MustRunAsNonRoot',
  'RunAsAny',
]);

export const zPodsecurityPodSecurityRunAsUser = z.object({
  idrange: z.array(zPodsecurityPodSecurityIdrange).optional(),
  type: zPodsecurityRunAsUserStrategy.optional(),
});

export const zPodsecuritySupplementalGroupsStrategyType = z.enum([
  'MayRunAs',
  'MustRunAs',
  'RunAsAny',
]);

export const zPodsecurityPodSecuritySupplementalGroups = z.object({
  idrange: z.array(zPodsecurityPodSecurityIdrange).optional(),
  type: zPodsecuritySupplementalGroupsStrategyType.optional(),
});

export const zPodsecurityPodSecurityUsers = z.object({
  enabled: z.boolean().optional(),
  fsGroups: zPodsecurityPodSecurityFsGroups.optional(),
  runAsGroup: zPodsecurityPodSecurityRunAsGroup.optional(),
  runAsUser: zPodsecurityPodSecurityRunAsUser.optional(),
  supplementalGroups: zPodsecurityPodSecuritySupplementalGroups.optional(),
});

export const zPodsecurityPodSecurityRule = z.object({
  allowFlexVolumes: zPodsecurityPodSecurityAllowFlexVolumes.optional(),
  allowPrivilegeEscalation:
    zPodsecurityPodSecurityAllowPrivilegeEscalation.optional(),
  allowProcMount: zPodsecurityPodSecurityAllowProcMount.optional(),
  appArmor: zPodsecurityPodSecurityAppArmour.optional(),
  capabilities: zPodsecurityPodSecurityCapabilities.optional(),
  enabled: z.boolean().optional(),
  endPointID: z.int().optional(),
  forbiddenSysctlsList: zPodsecurityPodSecurityForbiddenSysctlsList.optional(),
  hostFilesystem: zPodsecurityPodSecurityHostFilesystem.optional(),
  hostNamespaces: zPodsecurityPodSecurityHostNamespaces.optional(),
  hostPorts: zPodsecurityPodSecurityHostNetworkingPorts.optional(),
  id: z.int().optional(),
  privilegedContainers: zPodsecurityPodSecurityPrivilegedContainers.optional(),
  readOnlyRootFileSystem:
    zPodsecurityPodSecurityReadOnlyRootFileSystem.optional(),
  restrictDefaultNamespace: z.boolean().optional(),
  restrictSecrets: z.boolean().optional(),
  secComp: zPodsecurityPodSecuritySecComp.optional(),
  selinux: zPodsecurityPodSecuritySelinux.optional(),
  users: zPodsecurityPodSecurityUsers.optional(),
  volumeTypes: zPodsecurityPodSecurityVolumeTypes.optional(),
});

export const zPoliciesPolicyCategory = z.enum([
  'rbac',
  'security',
  'setup',
  'registry',
  'cleanup',
  'observability',
]);

export const zPoliciesPolicyStatusBreakdown = z.object({
  Applied: z.int().optional(),
  Failed: z.int().optional(),
  InProgress: z.int().optional(),
  NotSupported: z.int().optional(),
  Warning: z.int().optional(),
});

export const zPoliciesGenericPolicy = z.object({
  CreatedAt: z.string(),
  Data: z.record(z.string(), z.unknown()).optional(),
  EnvironmentGroups: z.array(z.int()).optional(),
  EnvironmentTypes: z
    .array(z.enum(['kubernetes', 'docker', 'podman', 'swarm']))
    .optional(),
  Id: z.int(),
  Name: z.string(),
  StatusBreakdown: zPoliciesPolicyStatusBreakdown.optional(),
  Type: z.enum([
    'rbac-k8s',
    'rbac-docker',
    'security-k8s',
    'security-docker',
    'setup-k8s',
    'setup-docker',
    'registry-k8s',
    'registry-docker',
    'change-confirmation',
    'cleanup-docker',
    'observability-k8s',
    'network-security-k8s',
    'pod-security-standards-k8s',
  ]),
  UpdatedAt: z.string(),
});

export const zPoliciesPolicy = z.object({
  CreatedAt: z.string(),
  EnvironmentGroups: z.array(z.int()).optional(),
  EnvironmentTypes: z
    .array(z.enum(['kubernetes', 'docker', 'podman', 'swarm']))
    .optional(),
  Id: z.int(),
  Name: z.string(),
  StatusBreakdown: zPoliciesPolicyStatusBreakdown.optional(),
  Type: z.enum([
    'rbac-k8s',
    'rbac-docker',
    'security-k8s',
    'security-docker',
    'setup-k8s',
    'setup-docker',
    'registry-k8s',
    'registry-docker',
    'change-confirmation',
    'cleanup-docker',
    'observability-k8s',
    'network-security-k8s',
    'pod-security-standards-k8s',
  ]),
  UpdatedAt: z.string(),
});

export const zPoliciesPolicyType = z.enum([
  'rbac-k8s',
  'security-k8s',
  'setup-k8s',
  'registry-k8s',
  'rbac-docker',
  'security-docker',
  'setup-docker',
  'registry-docker',
  'change-confirmation',
  'cleanup-docker',
  'observability-k8s',
  'pod-security-standards-k8s',
  'network-security-k8s',
  'rbac-k8s',
  'security-k8s',
  'setup-k8s',
  'registry-k8s',
  'rbac-docker',
  'security-docker',
  'setup-docker',
  'registry-docker',
  'observability-k8s',
  'pod-security-standards-k8s',
  'network-security-k8s',
]);

export const zPoliciesPolicyTemplate = z.object({
  category: zPoliciesPolicyCategory.optional(),
  data: z.record(z.string(), z.unknown()).optional(),
  description: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  type: zPoliciesPolicyType.optional(),
});

export const zPoliciesConflictInfo = z.object({
  environmentCount: z.int().optional(),
  environmentGroupId: z.int().optional(),
  environmentGroupName: z.string().optional(),
  existingPolicyId: z.int().optional(),
  existingPolicyName: z.string().optional(),
  supportedEnvironments: z.int().optional(),
  unsupportedEnvironments: z.int().optional(),
});

export const zPoliciesNewGroupInfo = z.object({
  environmentCount: z.int().optional(),
  environmentGroupId: z.int().optional(),
  environmentGroupName: z.string().optional(),
  supportedEnvironments: z.int().optional(),
  unsupportedEnvironments: z.int().optional(),
});

export const zPoliciesPolicyConflictsPayload = z.record(
  z.string(),
  z.unknown()
);

export const zPoliciesPolicyConflictsResponse = z.object({
  conflicts: z.array(zPoliciesConflictInfo).optional(),
  newGroups: z.array(zPoliciesNewGroupInfo).optional(),
  supportedEnvironments: z.int().optional(),
  totalEnvironments: z.int().optional(),
  unsupportedEnvironments: z.int().optional(),
});

export const zPoliciesPolicyCreatePayload = z.record(z.string(), z.unknown());

export const zPoliciesPolicyListResponse = z.object({
  policies: z.array(zPoliciesGenericPolicy).optional(),
});

export const zPoliciesPolicyMetadataResponse = z.object({
  minimumAgentVersions: z.record(z.string(), z.string()).optional(),
});

export const zPoliciesPolicyUpdatePayload = z.object({
  AllowOverride: z.boolean().optional(),
  Data: z.record(z.string(), z.unknown()).optional(),
  EnvironmentGroups: z.array(z.int()).optional(),
  Name: z.string().optional(),
  Type: z
    .enum([
      'rbac-k8s',
      'rbac-docker',
      'security-k8s',
      'security-docker',
      'setup-k8s',
      'setup-docker',
      'registry-k8s',
      'registry-docker',
      'change-confirmation',
      'observability-k8s',
    ])
    .optional(),
});

export const zPoliciesTemplateListResponse = z.object({
  templates: z.array(zPoliciesPolicyTemplate).optional(),
});

export const zPoliciesTestObservabilityConnectionPayload = z.object({
  apiKey: z.string().optional(),
  autoProvisionIngestionKey: z.boolean().optional(),
  autoRotateKey: z.boolean().optional(),
  oneUptimeURL: z.string().optional(),
  policyId: z.int().optional(),
  projectID: z.string().optional(),
  tlsSkipVerify: z.boolean().optional(),
});

export const zPoliciesTestObservabilityConnectionResponse = z.object({
  message: z.string().optional(),
  success: z.boolean().optional(),
});

export const zPortainerApiKey = z.object({
  dateCreated: z.int().optional(),
  description: z.string().optional(),
  digest: z.string().optional(),
  id: z.int().optional(),
  lastUsed: z.int().optional(),
  prefix: z.string().optional(),
  userId: z.int().optional(),
});

export const zPortainerAccessPolicy = z.object({
  Namespaces: z.array(z.string()).optional(),
  RoleId: z.int(),
});

export const zPortainerAllowListKey = z.literal(0);

export const zPortainerAuthenticationMethod = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zPortainerAuthorizations = z.record(z.string(), z.boolean());

export const zPortainerAutoUpdateSettings = z.object({
  ForcePullImage: z.boolean().optional(),
  ForceUpdate: z.boolean().optional(),
  Interval: z.string().optional(),
  JobID: z.string().optional(),
  Webhook: z.string().optional(),
});

export const zPortainerAzureCredentials = z.object({
  ApplicationID: z.string(),
  AuthenticationKey: z.string(),
  TenantID: z.string(),
});

export const zPortainerCustomTemplatePlatform = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainerCustomTemplateVariableDefinition = z.object({
  defaultValue: z.string().optional(),
  description: z.string().optional(),
  label: z.string().optional(),
  name: z.string().optional(),
});

export const zPortainerDiagnosticsData = z.object({
  DNS: z.record(z.string(), z.string()).optional(),
  Log: z.string().optional(),
  Proxy: z.record(z.string(), z.string()).optional(),
  Telnet: z.record(z.string(), z.string()).optional(),
});

export const zPortainerDockerSnapshotRaw = z.record(z.string(), z.unknown());

export const zPortainerEcrData = z.object({
  Region: z.string().optional(),
});

export const zPortainerEdgeJobLogsStatus = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zEdgejobsTaskContainer = z.object({
  EndpointId: z.int().optional(),
  EndpointName: z.string().optional(),
  Id: z.string().optional(),
  LogsStatus: zPortainerEdgeJobLogsStatus.optional(),
});

export const zPortainerEdgeJobEndpointMeta = z.object({
  CollectLogs: z.boolean().optional(),
  LogsStatus: zPortainerEdgeJobLogsStatus.optional(),
});

export const zPortainerEdgeJob = z.object({
  Created: z.int().optional(),
  CronExpression: z.string().optional(),
  EdgeGroups: z.array(z.int()).optional(),
  Endpoints: z.record(z.string(), zPortainerEdgeJobEndpointMeta).optional(),
  GroupLogsCollection: z
    .record(z.string(), zPortainerEdgeJobEndpointMeta)
    .optional(),
  Id: z.int().optional(),
  Name: z.string().optional(),
  Recurring: z.boolean().optional(),
  ScriptPath: z.string().optional(),
  Version: z.int().optional(),
});

export const zPortainerEdgeStackDeploymentType = z.union([
  z.literal(0),
  z.literal(1),
]);

export const zPortainerEdgeStackStatusDetails = z.object({
  Acknowledged: z.boolean().optional(),
  Error: z.boolean().optional(),
  ImagesPulled: z.boolean().optional(),
  Ok: z.boolean().optional(),
  Pending: z.boolean().optional(),
  RemoteUpdateSuccess: z.boolean().optional(),
  Remove: z.boolean().optional(),
});

export const zPortainerEdgeStackStatusType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
  z.literal(7),
  z.literal(8),
  z.literal(9),
  z.literal(10),
  z.literal(11),
  z.literal(12),
  z.literal(13),
]);

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksUpdateStatusPayload =
  z.object({
    EndpointID: z.int().optional(),
    Error: z.string().optional(),
    RollbackTo: z.int().optional(),
    Status: zPortainerEdgeStackStatusType.optional(),
    Time: z.coerce
      .bigint()
      .min(BigInt('-9223372036854775808'), {
        error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
      })
      .max(BigInt('9223372036854775807'), {
        error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
      })
      .optional(),
    Version: z.int().optional(),
  });

export const zPortainerEdgeStackDeploymentStatus = z.object({
  Error: z.string().optional(),
  RollbackTo: z.int().optional(),
  Time: z.coerce
    .bigint()
    .min(BigInt('-9223372036854775808'), {
      error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
    })
    .max(BigInt('9223372036854775807'), {
      error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
    })
    .optional(),
  Type: zPortainerEdgeStackStatusType.optional(),
  Version: z.int().optional(),
});

export const zPortainerEndpointSecuritySettings = z.object({
  allowBindMountsForRegularUsers: z.boolean(),
  allowContainerCapabilitiesForRegularUsers: z.boolean(),
  allowDeviceMappingForRegularUsers: z.boolean(),
  allowHostNamespaceForRegularUsers: z.boolean(),
  allowPrivilegedModeForRegularUsers: z.boolean(),
  allowSecurityOptForRegularUsers: z.boolean(),
  allowStackManagementForRegularUsers: z.boolean(),
  allowSysctlSettingForRegularUsers: z.boolean(),
  allowVolumeBrowserForRegularUsers: z.boolean(),
  enableHostManagementFeatures: z.boolean(),
});

export const zPortainerEndpointStatus = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainerEndpointType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
  z.literal(7),
]);

export const zEdgegroupsDecoratedEdgeGroup = z.object({
  Dynamic: z.boolean().optional(),
  EdgeUpdateID: z.int().optional(),
  EndpointIds: z.int().optional(),
  EndpointTypes: z.array(zPortainerEndpointType).optional(),
  Endpoints: z.array(z.int()).optional(),
  EndpointsCount: z.int().optional(),
  HasEdgeConfig: z.boolean().optional(),
  HasEdgeJob: z.boolean().optional(),
  HasEdgeStack: z.boolean().optional(),
  Id: z.int().optional(),
  Name: z.string().optional(),
  PartialMatch: z.boolean().optional(),
  TagIds: z.array(z.int()).optional(),
  TrustedEndpoints: z.array(z.int()).optional(),
  TrustedEndpointsCount: z.int().optional(),
});

export const zPortainerEnvironmentEdgeSettings = z.object({
  AsyncMode: z.boolean(),
  CommandInterval: z.int(),
  PingInterval: z.int(),
  SnapshotInterval: z.int(),
});

export const zPortainerGithubRegistryData = z.object({
  OrganisationName: z.string().optional(),
  UseOrganisation: z.boolean().optional(),
});

export const zPortainerGitlabRegistryData = z.object({
  InstanceURL: z.string().optional(),
  ProjectId: z.int().optional(),
  ProjectPath: z.string().optional(),
});

export const zPortainerHelmConfig = z.object({
  Atomic: z.boolean().optional(),
  ChartName: z.string().optional(),
  ChartPath: z.string().optional(),
  ChartURL: z.string().optional(),
  ChartVersion: z.string().optional(),
  Namespace: z.string().optional(),
  Timeout: z.string().optional(),
  ValuesFiles: z.array(z.string()).optional(),
  ValuesInline: z.string().optional(),
});

export const zPortainerHelmUserRepository = z.object({
  Id: z.int().optional(),
  URL: z.string().optional(),
  UserId: z.int().optional(),
});

export const zPortainerInternalAuthSettings = z.object({
  RequiredPasswordLength: z.int().optional(),
});

export const zPortainerK8sNodeLimits = z.object({
  CPU: z.int().optional(),
  Memory: z.int().optional(),
});

export const zPortainerK8sNodesLimits = z.record(
  z.string(),
  zPortainerK8sNodeLimits
);

export const zPortainerKubernetesFlags = z.object({
  GPUOperator: z.boolean().optional(),
  IsServerIngressClassDetected: z.boolean(),
  IsServerMetricsDetected: z.boolean(),
  IsServerStorageDetected: z.boolean(),
});

export const zPortainerKubernetesIngressClassConfig = z.object({
  Blocked: z.boolean().optional(),
  BlockedNamespaces: z.array(z.string()).optional(),
  Name: z.string(),
  Type: z.string(),
});

export const zPortainerKubernetesStorageClassConfig = z.object({
  AccessModes: z.array(z.string()).optional(),
  AllowVolumeExpansion: z.boolean(),
  Name: z.string(),
  Provisioner: z.string(),
});

export const zPortainerLdapGroupSearchSettings = z.object({
  GroupAttribute: z.string().optional(),
  GroupBaseDN: z.string().optional(),
  GroupFilter: z.string().optional(),
});

export const zPortainerLdapSearchSettings = z.object({
  BaseDN: z.string().optional(),
  Filter: z.string().optional(),
  UserNameAttribute: z.string().optional(),
});

export const zPortainerLdapUser = z.object({
  Groups: z.array(z.string()).optional(),
  Name: z.string().optional(),
});

export const zPortainerMembershipRole = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainerPair = z.object({
  name: z.string(),
  value: z.string(),
});

export const zPortainerPerDevConfigsFilterType = z.enum(['file', 'dir']);

export const zPortainerPerformanceMetrics = z.object({
  CPUUsage: z.number().optional(),
  DiskUsage: z.number().optional(),
  MemoryUsage: z.number().optional(),
  NetworkUsage: z.number().optional(),
});

export const zPortainerDockerSnapshot = z.object({
  ContainerCount: z.int(),
  DiagnosticsData: zPortainerDiagnosticsData.optional(),
  DockerSnapshotRaw: zPortainerDockerSnapshotRaw.optional(),
  DockerVersion: z.string(),
  GpuUseAll: z.boolean(),
  GpuUseList: z.array(z.string()).optional(),
  HealthyContainerCount: z.int(),
  ImageCount: z.int(),
  IsPodman: z.boolean(),
  NodeCount: z.int(),
  PerformanceMetrics: zPortainerPerformanceMetrics.optional(),
  RunningContainerCount: z.int(),
  ServiceCount: z.int(),
  StackCount: z.int(),
  StoppedContainerCount: z.int(),
  Swarm: z.boolean(),
  Time: z.int(),
  TotalCPU: z.int(),
  TotalMemory: z.int(),
  UnhealthyContainerCount: z.int(),
  VolumeCount: z.int(),
});

export const zPortainerKubernetesSnapshot = z.object({
  ClusterType: z.string().optional(),
  DiagnosticsData: zPortainerDiagnosticsData.optional(),
  GPUNodeCount: z.int().optional(),
  KubernetesVersion: z.string(),
  NodeCount: z.int(),
  PerformanceMetrics: zPortainerPerformanceMetrics.optional(),
  Time: z.int(),
  TotalCPU: z.int(),
  TotalGPU: z
    .record(
      z.string(),
      z.coerce
        .bigint()
        .min(BigInt('-9223372036854775808'), {
          error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
        })
        .max(BigInt('9223372036854775807'), {
          error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
        })
    )
    .optional(),
  TotalMemory: z.int(),
});

export const zPortainerPolicyActualState = z.object({
  fingerprint: z.string().optional(),
  message: z.string().optional(),
  policyID: z.int().optional(),
  status: z.string().optional(),
  type: z.string().optional(),
});

export const zEndpointedgePolicyStatusesPayload = z.object({
  statuses: z.array(zPortainerPolicyActualState).optional(),
});

export const zPortainerQuayRegistryData = z.object({
  OrganisationName: z.string().optional(),
  UseOrganisation: z.boolean().optional(),
});

export const zPortainerRegistryType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
  z.literal(7),
  z.literal(8),
]);

export const zPortainerResourceAccessLevel = z.union([
  z.literal(0),
  z.literal(1),
]);

export const zPortainerResourceControlType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
  z.literal(7),
  z.literal(8),
  z.literal(9),
]);

export const zPortainerSsrfMode = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zAllowlistAllowListUpdatePayload = z.object({
  Entries: z.array(z.string()).optional(),
  Mode: zPortainerSsrfMode.optional(),
});

export const zPortainerAllowList = z.object({
  Entries: z.array(z.string()).optional(),
  Id: zPortainerAllowListKey.optional(),
  Mode: zPortainerSsrfMode.optional(),
});

export const zPortainerSourceStatus = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainerArtifactFile = z.object({
  hash: z.string().optional(),
  path: z.string().optional(),
  pathError: z.string().optional(),
  pathStatus: zPortainerSourceStatus.optional(),
  ref: z.string().optional(),
  refError: z.string().optional(),
  refStatus: zPortainerSourceStatus.optional(),
  sourceId: z.int().optional(),
});

export const zPortainerArtifact = z.object({
  edgeGroups: z.array(z.int()).optional(),
  edgeStackId: z.int().optional(),
  envGroups: z.array(z.int()).optional(),
  envIds: z.array(z.int()).optional(),
  files: z.array(zPortainerArtifactFile).optional(),
  stackId: z.int().optional(),
});

export const zPortainerSourceType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zPortainerStackDeploymentInfo = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  ConfigFilePath: z.string().optional(),
  ConfigHash: z.string().optional(),
  FileVersion: z.int().optional(),
  ReferenceName: z.string().optional(),
  RepositoryURL: z.string().optional(),
  SourceID: z.int().optional(),
  Version: z.int().optional(),
});

export const zPortainerEdgeStackStatus = z.object({
  DeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  Details: zPortainerEdgeStackStatusDetails.optional(),
  EndpointID: z.int().optional(),
  Error: z.string().optional(),
  ReadyRePullImage: z.boolean().optional(),
  Status: z.array(zPortainerEdgeStackDeploymentStatus).optional(),
  Type: zPortainerEdgeStackStatusType.optional(),
});

export const zPortainerStackOption = z.object({
  HelmAtomic: z.boolean().optional(),
  Prune: z.boolean().optional(),
});

export const zPortainerStackStatus = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
]);

export const zPortainerStackDeploymentStatus = z.object({
  Message: z.string().optional(),
  Status: zPortainerStackStatus.optional(),
  Time: z.int().optional(),
});

export const zPortainerStackType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zPortainerTlsConfiguration = z.object({
  TLS: z.boolean(),
  TLSCACert: z.string().optional(),
  TLSCert: z.string().optional(),
  TLSKey: z.string().optional(),
  TLSSkipVerify: z.boolean(),
});

export const zPortainerRegistryManagementConfiguration = z.object({
  AccessToken: z.string().optional(),
  AccessTokenExpiry: z.int().optional(),
  Authentication: z.boolean().optional(),
  Ecr: zPortainerEcrData.optional(),
  Password: z.string().optional(),
  TLSConfig: zPortainerTlsConfiguration.optional(),
  Type: zPortainerRegistryType.optional(),
  Username: z.string().optional(),
});

export const zPortainerTag = z.object({
  EndpointGroups: z.record(z.string(), z.boolean()).optional(),
  Endpoints: z.record(z.string(), z.boolean()).optional(),
  ID: z.int().optional(),
  Name: z.string().optional(),
});

export const zPortainerTeam = z.object({
  DenyPortainerAccess: z.boolean().optional(),
  Id: z.int().optional(),
  Name: z.string().optional(),
});

export const zPortainerTeamAccessPolicies = z.record(
  z.string(),
  zPortainerAccessPolicy
);

export const zPortainerTeamMembership = z.object({
  Id: z.int().optional(),
  Role: zPortainerMembershipRole.optional(),
  TeamID: z.int().optional(),
  UserID: z.int().optional(),
});

export const zPortainerTeamResourceAccess = z.object({
  AccessLevel: zPortainerResourceAccessLevel.optional(),
  TeamId: z.int().optional(),
});

export const zPortainerTemplateEnvSelect = z.object({
  default: z.boolean().optional(),
  text: z.string().optional(),
  value: z.string().optional(),
});

export const zPortainerTemplateEnv = z.object({
  default: z.string().optional(),
  description: z.string().optional(),
  label: z.string().optional(),
  name: z.string().optional(),
  preset: z.boolean().optional(),
  select: z.array(zPortainerTemplateEnvSelect).optional(),
});

export const zPortainerTemplateRepository = z.object({
  stackfile: z.string().optional(),
  url: z.string().optional(),
});

export const zPortainerTemplateType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zPortainerTemplateVolume = z.object({
  bind: z.string().optional(),
  container: z.string().optional(),
  readonly: z.boolean().optional(),
});

export const zPortainerTemplate = z.object({
  administrator_only: z.boolean().optional(),
  categories: z.array(z.string()).optional(),
  command: z.string().optional(),
  description: z.string().optional(),
  env: z.array(zPortainerTemplateEnv).optional(),
  hostname: z.string().optional(),
  id: z.int().optional(),
  image: z.string().optional(),
  interactive: z.boolean().optional(),
  labels: z.array(zPortainerPair).optional(),
  logo: z.string().optional(),
  name: z.string().optional(),
  network: z.string().optional(),
  note: z.string().optional(),
  platform: z.string().optional(),
  ports: z.array(z.string()).optional(),
  privileged: z.boolean().optional(),
  registry: z.string().optional(),
  repository: zPortainerTemplateRepository.optional(),
  restart_policy: z.string().optional(),
  stackFile: z.string().optional(),
  title: z.string().optional(),
  type: zPortainerTemplateType.optional(),
  volumes: z.array(zPortainerTemplateVolume).optional(),
});

export const zPortainerUserAccessPolicies = z.record(
  z.string(),
  zPortainerAccessPolicy
);

export const zAddonsAddonAccessResponse = z.object({
  enabled: z.boolean().optional(),
  id: z.string().optional(),
  teamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  userAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zAddonsAddonAccessUpdatePayload = z.object({
  enabled: z.boolean().optional(),
  teamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  userAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zAddonsAddonRecord = z.object({
  availableVersions: z.array(z.string()).optional(),
  chartPath: z.string().optional(),
  chartVersion: z.string().optional(),
  helmChartRepository: z.string().optional(),
  imageRegistryId: z.int().optional(),
  registryId: z.int().optional(),
  teamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  upgradeAvailable: z.boolean().optional(),
  userAccessPolicies: zPortainerUserAccessPolicies.optional(),
  versionCheckError: z.string().optional(),
});

export const zAddonsAddonListItem = z.object({
  description: z.string().optional(),
  displayName: z.string().optional(),
  enabled: z.boolean().optional(),
  failedOperation: zAddonOperation.optional(),
  healthMessage: z.string().optional(),
  healthStatus: zAddonHealthStatus.optional(),
  icon: z.string().optional(),
  id: z.string().optional(),
  lifecycleStatus: zAddonLifecycleStatus.optional(),
  lifecycleStatusMessage: z.string().optional(),
  path: z.string().optional(),
  record: zAddonsAddonRecord.optional(),
  shortDescription: z.string().optional(),
});

export const zAddonsAddonListResponse = z.object({
  addons: z.array(zAddonsAddonListItem).optional(),
  catalogError: z.string().optional(),
});

export const zEndpointgroupsEndpointGroupResponse = z.object({
  Description: z.string(),
  Id: z.int(),
  Name: z.string(),
  Policies: z.array(zPoliciesGenericPolicy),
  TagIds: z.array(z.int()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  Total: z.int().optional(),
  TypeInfo: zEndpointgroupsEndpointGroupTypeInfo.optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zEndpointsRegistryAccessPayload = z.object({
  Namespaces: z.array(z.string()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerEndpointgroupsEndpointGroupUpdatePayload =
  z.object({
    AssociatedEndpoints: z.array(z.int()).optional(),
    Description: z.string().optional(),
    Name: z.string().optional(),
    TagIDs: z.array(z.int()).optional(),
    TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
    UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
  });

export const zPortainerEndpointGroup = z.object({
  Description: z.string(),
  Id: z.int(),
  Name: z.string(),
  TagIds: z.array(z.int()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zPortainerRegistryAccessPolicies = z.object({
  Namespaces: z.array(z.string()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zPortainerRegistryAccesses = z.record(
  z.string(),
  zPortainerRegistryAccessPolicies
);

export const zPortainerRegistry = z.object({
  AccessToken: z.string().optional(),
  AccessTokenExpiry: z.int().optional(),
  Authentication: z.boolean().optional(),
  AuthorizedTeams: z.array(z.int()).optional(),
  AuthorizedUsers: z.array(z.int()).optional(),
  BaseURL: z.string().optional(),
  Ecr: zPortainerEcrData.optional(),
  Github: zPortainerGithubRegistryData.optional(),
  Gitlab: zPortainerGitlabRegistryData.optional(),
  Id: z.int().optional(),
  ManagementConfiguration: zPortainerRegistryManagementConfiguration.optional(),
  Name: z.string().optional(),
  Password: z.string().optional(),
  Quay: zPortainerQuayRegistryData.optional(),
  RegistryAccesses: zPortainerRegistryAccesses.optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  Type: z
    .union([
      z.literal(1),
      z.literal(2),
      z.literal(3),
      z.literal(4),
      z.literal(5),
      z.literal(6),
      z.literal(7),
    ])
    .optional(),
  URL: z.string().optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
  Username: z.string().optional(),
});

export const zPortainerSource = z.object({
  administratorsOnly: z.boolean().optional(),
  git: zGithubComPortainerPortainerApiGitTypesGitSource.optional(),
  helm: zPortainerHelmConfig.optional(),
  id: z.int().optional(),
  interval: z.string().optional(),
  lastSync: z.int().optional(),
  name: z.string().optional(),
  ownerID: z.int().optional(),
  public: z.boolean().optional(),
  registry: zPortainerRegistry.optional(),
  status: zPortainerSourceStatus.optional(),
  statusError: z.string().optional(),
  teamAccesses: z.array(z.int()).optional(),
  type: zPortainerSourceType.optional(),
  userAccesses: z.array(z.int()).optional(),
});

export const zPortainerUserResourceAccess = z.object({
  AccessLevel: zPortainerResourceAccessLevel.optional(),
  UserId: z.int().optional(),
});

export const zPortainerResourceControl = z.object({
  AccessLevel: zPortainerResourceAccessLevel.optional(),
  AdministratorsOnly: z.boolean().optional(),
  Id: z.int().optional(),
  OwnerId: z.int().optional(),
  Public: z.boolean().optional(),
  ResourceId: z.string().optional(),
  SubResourceIds: z.array(z.string()).optional(),
  System: z.boolean().optional(),
  TeamAccesses: z.array(zPortainerTeamResourceAccess).optional(),
  Type: zPortainerResourceControlType.optional(),
  UserAccesses: z.array(zPortainerUserResourceAccess).optional(),
});

export const zPortainerUserRole = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainerWebhookType = z.union([z.literal(0), z.literal(1)]);

export const zPortainerWebhook = z.object({
  EndpointId: z.int().optional(),
  Id: z.int().optional(),
  RegistryId: z.int().optional(),
  ResourceId: z.string().optional(),
  Token: z.string().optional(),
  Type: zPortainerWebhookType.optional(),
});

export const zPortainerWorkflow = z.object({
  artifacts: z.array(zPortainerArtifact).optional(),
  id: z.int().optional(),
  name: z.string().optional(),
});

export const zPortainereeAdditionalFunctionality = z.record(
  z.string(),
  z.unknown()
);

export const zPortainereeAlertRuleCategory = z.enum([
  'portainer',
  'security',
  'environment',
  'backup',
]);

export const zPortainereeAlertRuleEnvReason = z.enum([
  'included',
  'environment_type_mismatch',
  'agent_version_mismatch',
  'endpoint_group_mismatch',
  'tag_mismatch',
  'empty_scope',
  'retry_requested',
  'agent_last_error',
]);

export const zPortainereeAlertRuleEnvStatus = z.enum([
  'active',
  'excluded',
  'not_supported',
  'error',
  'pending',
]);

export const zObservabilityAlertRuleEnvironmentResponse = z.object({
  endpointId: z.int().optional(),
  message: z.string().optional(),
  name: z.string().optional(),
  reasonCode: zPortainereeAlertRuleEnvReason.optional(),
  status: zPortainereeAlertRuleEnvStatus.optional(),
  updatedAt: z.int().optional(),
});

export const zObservabilityAlertRuleEnvironmentGroupResponse = z.object({
  endpointGroupId: z.int().optional(),
  endpointGroupName: z.string().optional(),
  environments: z.array(zObservabilityAlertRuleEnvironmentResponse).optional(),
  size: z.int().optional(),
});

export const zObservabilityAlertRuleEnvironmentsResponse = z.object({
  active: z.int().optional(),
  error: z.int().optional(),
  excluded: z.int().optional(),
  groups: z.array(zObservabilityAlertRuleEnvironmentGroupResponse).optional(),
  notSupported: z.int().optional(),
  pending: z.int().optional(),
  total: z.int().optional(),
});

export const zPortainereeAlertingNotificationChannel = z.object({
  config: z.record(z.string(), z.unknown()).optional(),
  enabled: z.boolean().optional(),
  id: z.int().optional(),
  name: z.string().optional(),
  type: z
    .enum([
      'slack',
      'webhook',
      'teams',
      'discord',
      'email',
      'pagerduty',
      'opsgenie',
    ])
    .optional(),
});

export const zPortainereeAlertingRuleTier = z.object({
  enabled: z.boolean().optional(),
  severity: z.enum(['critical', 'warning', 'info']).optional(),
  threshold: z.number().optional(),
});

export const zPortainereeAlertingRule = z.object({
  alertManagerID: z.int().optional(),
  annotationTemplate: z.string().optional(),
  category: z.enum(['portainer', 'security', 'environment']).optional(),
  conditionOperator: z.string().optional(),
  createdAt: z.string().optional(),
  createdBy: z.string().optional(),
  description: z.string().optional(),
  duration: z.int().optional(),
  enabled: z.boolean().optional(),
  endpointGroupIds: z.array(z.int()).optional(),
  forDurationMinutes: z.int().optional(),
  id: z.int().optional(),
  isEditable: z.boolean().optional(),
  isInternal: z.boolean().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  metricType: z.enum(['percentage', 'bytes', 'raw', 'days']).optional(),
  name: z.string().optional(),
  operatorFixed: z.boolean().optional(),
  promqlExpr: z.string().optional(),
  promqlScalarTemplate: z.string().optional(),
  promqlTemplate: z.string().optional(),
  severity: z.enum(['critical', 'warning', 'info']).optional(),
  summary: z.string().optional(),
  supportedAgentVersion: z.string().optional(),
  supportedEnvironmentTypes: z
    .enum(['docker', 'kubernetes', 'podman', 'all'])
    .optional(),
  tagIds: z.array(z.int()).optional(),
  threshold: z.number().optional(),
  tiers: z.array(zPortainereeAlertingRuleTier).optional(),
  updatedAt: z.string().optional(),
  useDurationAsFor: z.boolean().optional(),
  useTiers: z.boolean().optional(),
});

export const zObservabilityAlertRuleCreatePayload = z.object({
  AlertingRule: zPortainereeAlertingRule.optional(),
});

export const zObservabilityAlertRuleUpdatePayload = z.object({
  AlertingRule: zPortainereeAlertingRule.optional(),
});

export const zPortainereeAlertingSettings = z.object({
  createdAt: z.string().optional(),
  createdBy: z.string().optional(),
  enabled: z.boolean().optional(),
  id: z.int().optional(),
  isInternal: z.boolean().optional(),
  name: z.string().optional(),
  notificationChannels: z
    .array(zPortainereeAlertingNotificationChannel)
    .optional(),
  portainerURL: z.string().optional(),
  status: z.enum(['disabled', 'connected', 'disconnected', 'error']).optional(),
  uptime: z.string().optional(),
  url: z.string().optional(),
});

export const zObservabilityAlertingUpdatePayload = z.object({
  AlertingSettings: zPortainereeAlertingSettings.optional(),
});

export const zPortainereeAuthenticationActivityType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zPortainereeAuthActivityLog = z.object({
  context: zPortainerAuthenticationMethod.optional(),
  id: z.int().optional(),
  origin: z.string().optional(),
  timestamp: z.int().optional(),
  type: zPortainereeAuthenticationActivityType.optional(),
  username: z.string().optional(),
});

export const zPortainereeAutoPatchSettings = z.object({
  Enabled: z.boolean().optional(),
  PatchCron: z.string().optional(),
  PortainerRepository: z.string().optional(),
  RegistryID: z.int().optional(),
  UpdaterRepository: z.string().optional(),
});

export const zPortainereeAutoUpdateStatus = z.enum([
  'inProgress',
  'completed',
  'failed',
]);

export const zAutoupdatesAutoUpdateResponseItem = z.object({
  doneAtUnix: z.int().optional(),
  startedAtUnix: z.int().optional(),
  status: zPortainereeAutoUpdateStatus.optional(),
  version: z.string().optional(),
});

export const zAutoupdatesListResponse = z.object({
  autoUpdates: z.array(zAutoupdatesAutoUpdateResponseItem).optional(),
});

export const zPortainereeAzureAuthMethod = z.enum([
  'servicePrincipalSecret',
  'servicePrincipalCertificate',
  'managedIdentity',
  'storageAccountKey',
]);

export const zBackupRestoreAzureSettings = z.object({
  AuthMethod: zPortainereeAzureAuthMethod.optional(),
  BlobName: z.string().optional(),
  ClientCertificate: z.string().optional(),
  ClientCertificatePassword: z.string().optional(),
  ClientID: z.string().optional(),
  ClientSecret: z.string().optional(),
  ContainerName: z.string().optional(),
  ManagedIdentityClientID: z.string().optional(),
  Password: z.string().optional(),
  ServiceURL: z.string().optional(),
  StorageAccountKey: z.string().optional(),
  StorageAccountName: z.string().optional(),
  TenantID: z.string().optional(),
});

export const zPortainereeAzureBlobBackupSettings = z.object({
  authMethod: zPortainereeAzureAuthMethod.optional(),
  clientCertificate: z.string().optional(),
  clientCertificatePassword: z.string().optional(),
  clientId: z.string().optional(),
  clientSecret: z.string().optional(),
  containerName: z.string().optional(),
  cronRule: z.string().optional(),
  managedIdentityClientId: z.string().optional(),
  password: z.string().optional(),
  serviceUrl: z.string().optional(),
  storageAccountKey: z.string().optional(),
  storageAccountName: z.string().optional(),
  tenantId: z.string().optional(),
});

export const zPortainereeCloudApiKeys = z.object({
  CivoApiKey: z.string().optional(),
  DigitalOceanToken: z.string().optional(),
  GKEApiKey: z.string().optional(),
  LinodeToken: z.string().optional(),
});

export const zPortainereeCloudProvider = z.object({
  AmiType: z.string().optional(),
  CPU: z.int().optional(),
  CredentialID: z.int().optional(),
  DNSPrefix: z.string().optional(),
  HDD: z.int().optional(),
  InstanceType: z.string().optional(),
  KubernetesVersion: z.string().optional(),
  Name: z.string().optional(),
  NetworkID: z.string().optional(),
  NodeCount: z.int().optional(),
  NodeVolumeSize: z.int().optional(),
  PoolName: z.string().optional(),
  Provider: z.string().optional(),
  RAM: z.number().optional(),
  Region: z.string().optional(),
  ResourceGroup: z.string().optional(),
  Size: z.string().optional(),
  Tier: z.string().optional(),
  URL: z.string().optional(),
});

export const zPortainereeConditionOperator = z.enum([
  '>',
  '<',
  '=',
  '>=',
  '<=',
]);

export const zObservabilityAlertRuleTiersUpdatePayload = z.object({
  conditionOperator: zPortainereeConditionOperator.optional(),
  description: z.string().optional(),
  duration: z.int().optional(),
  enabled: z.boolean().optional(),
  tiers: z.array(zPortainereeAlertingRuleTier).optional(),
});

export const zPortainereeCustomTemplateRelativePathSettings = z.object({
  FilesystemPath: z.string().optional(),
  PerDeviceConfigsGroupMatchType: z.enum(['file', ' dir']).optional(),
  PerDeviceConfigsMatchType: z.enum(['file', ' dir']).optional(),
  PerDeviceConfigsPath: z.string().optional(),
  SupportPerDeviceConfigs: z.boolean().optional(),
  SupportRelativePath: z.boolean().optional(),
});

export const zPortainereeDeploymentOptions = z.object({
  hideAddWithForm: z.boolean(),
  hideFileUpload: z.boolean(),
  hideWebEditor: z.boolean(),
  overrideGlobalOptions: z.boolean(),
});

export const zPortainereeEdgeConfigCategory = z.enum([
  'configuration',
  'secret',
]);

export const zEdgeconfigsEdgeConfigCreatePayload = z.object({
  BaseDir: z.string().optional(),
  Category: zPortainereeEdgeConfigCategory.optional(),
  EdgeGroupIDs: z.array(z.int()).optional(),
  Name: z.string().optional(),
  Type: z.string().optional(),
});

export const zPortainereeEdgeConfigProgress = z.object({
  success: z.int().optional(),
  total: z.int().optional(),
});

export const zPortainereeEdgeConfigStateType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
]);

export const zPortainereeEdgeConfig = z.object({
  baseDir: z.string().optional(),
  category: zPortainereeEdgeConfigCategory.optional(),
  created: z.int().optional(),
  createdBy: z.int().optional(),
  edgeGroupIDs: z.array(z.int()).optional(),
  id: z.int().optional(),
  name: z.string().optional(),
  prev: z.lazy((): any => zPortainereeEdgeConfig).optional(),
  progress: zPortainereeEdgeConfigProgress.optional(),
  state: zPortainereeEdgeConfigStateType.optional(),
  type: z.int().optional(),
  updated: z.int().optional(),
  updatedBy: z.int().optional(),
});

export const zPortainereeEdgeStackDeployerOptions = z.object({
  Prune: z.boolean().optional(),
  RemoveVolumes: z.boolean().optional(),
});

export const zPortainereeEdgeStaggerOption = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainereeEdgeStaggerParallelOption = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainereeEdgeUpdateFailureAction = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
]);

export const zPortainereeEdgeStaggerConfig = z.object({
  DeviceNumber: z.int().optional(),
  DeviceNumberIncrementBy: z.int().optional(),
  DeviceNumberStartFrom: z.int().optional(),
  StaggerOption: zPortainereeEdgeStaggerOption.optional(),
  StaggerParallelOption: zPortainereeEdgeStaggerParallelOption.optional(),
  Timeout: z.string().optional(),
  UpdateDelay: z.string().optional(),
  UpdateFailureAction: zPortainereeEdgeUpdateFailureAction.optional(),
});

export const zEdgestacksEdgeStackFromHelmRepositoryPayload = z.object({
  EdgeGroups: z.array(z.int()).optional(),
  HelmConfig: zEdgestacksHelmRepositoryConfig.optional(),
  Name: z.string(),
  StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
});

export const zEdgestacksStackGitUpdatePayload = z.object({
  Authentication:
    zGithubComPortainerPortainerEeApiGitTypesGitAuthentication.optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  DeployerOptions: zEdgestacksDeployerOptionsPayload.optional(),
  DeploymentType: zPortainerEdgeStackDeploymentType.optional(),
  EnvVars: z.array(zPortainerPair).optional(),
  GroupIds: z.array(z.int()).optional(),
  HelmConfig: zEdgestacksGitHelmConfig.optional(),
  PrePullImage: z.boolean().optional(),
  RePullImage: z.boolean().optional(),
  RefName: z.string().optional(),
  Registries: z.array(z.int()).optional(),
  RepullImageAndRedeploy: z.boolean().optional(),
  RetryDeploy: z.boolean().optional(),
  RetryPeriod: z.int().optional(),
  StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
  UpdateVersion: z.boolean().optional(),
});

export const zEdgestacksUpdateEdgeStackHelmRepositoryPayload = z.object({
  EdgeGroups: z.array(z.int()).optional(),
  HelmConfig: zEdgestacksHelmRepositoryConfig.optional(),
  StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackFromGitRepositoryPayload =
  z.object({
    AlwaysCloneGitRepoForRelativePath: z.boolean().optional(),
    AutoUpdate: zPortainerAutoUpdateSettings.optional(),
    CreatedFromCustomTemplateID: z.int().optional(),
    DeploymentType: z.union([z.literal(0), z.literal(1)]).optional(),
    EdgeGroups: z.array(z.int()),
    EnvVars: z.array(zPortainerPair).optional(),
    FilePathInRepository: z.string().optional().default('docker-compose.yml'),
    FilesystemPath: z.string().optional(),
    HelmConfig: zEdgestacksGitHelmConfig.optional(),
    Name: z.string(),
    PerDeviceConfigsGroupMatchType: z.enum(['file', ' dir']).optional(),
    PerDeviceConfigsMatchType: z.enum(['file', ' dir']).optional(),
    PerDeviceConfigsPath: z.string().optional(),
    PrePullImage: z.boolean().optional(),
    Registries: z.array(z.int()).optional(),
    RepositoryAuthentication: z.boolean().optional(),
    RepositoryAuthorizationType:
      zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
    RepositoryPassword: z.string().optional(),
    RepositoryProvider:
      zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
    RepositoryReferenceName: z.string().optional(),
    RepositoryURL: z.string().optional(),
    RepositoryUsername: z.string().optional(),
    RetryDeploy: z.boolean().optional(),
    RetryPeriod: z.int().optional(),
    SourceID: z.int().optional(),
    StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
    SupportPerDeviceConfigs: z.boolean().optional(),
    SupportRelativePath: z.boolean().optional(),
    TLSSkipVerify: z.boolean().optional(),
    UseManifestNamespaces: z.boolean().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackFromStringPayload =
  z.object({
    DeploymentType: z.union([z.literal(0), z.literal(1)]).optional(),
    EdgeGroups: z.array(z.int()).optional(),
    EnvVars: z.array(zPortainerPair).optional(),
    Name: z.string(),
    PrePullImage: z.boolean().optional(),
    Registries: z.array(z.int()).optional(),
    RetryDeploy: z.boolean().optional(),
    RetryPeriod: z.int().optional(),
    StackFileContent: z.string(),
    StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
    UseManifestNamespaces: z.boolean().optional(),
    Webhook: z.string().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackListResponseItem =
  z.object({
    AlwaysCloneGitRepoForRelativePath: z.boolean().optional(),
    AutoUpdate: zPortainerAutoUpdateSettings.optional(),
    CreatedBy: z.string().optional(),
    CreatedByUserId: z.string().optional(),
    CreationDate: z.int().optional(),
    CurrentDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
    DeployerOptions: zPortainereeEdgeStackDeployerOptions.optional(),
    DeploymentType: zPortainerEdgeStackDeploymentType.optional(),
    EdgeGroups: z.array(z.int()).optional(),
    EdgeUpdateID: z.int().optional(),
    EntryPoint: z.string().optional(),
    EnvVars: z.array(zPortainerPair).optional(),
    FilesystemPath: z.string().optional(),
    GitConfig: zGithubComPortainerPortainerEeApiGitTypesRepoConfig.optional(),
    GitSourceId: z.int().optional(),
    HelmConfig: zPortainerHelmConfig.optional(),
    Id: z.int().optional(),
    ManifestPath: z.string().optional(),
    Name: z.string().optional(),
    NumDeployments: z.int().optional(),
    PerDeviceConfigsGroupMatchType: z.enum(['file', ' dir']).optional(),
    PerDeviceConfigsMatchType: z.enum(['file', ' dir']).optional(),
    PerDeviceConfigsPath: z.string().optional(),
    PrePullImage: z.boolean().optional(),
    PreviousDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
    ProjectPath: z.string().optional(),
    RePullImage: z.boolean().optional(),
    Registries: z.array(z.int()).optional(),
    RetryDeploy: z.boolean().optional(),
    RetryPeriod: z.int().optional(),
    ScheduledTime: z.string().optional(),
    StackFileVersion: z.int().optional(),
    StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
    Status: z.record(z.string(), zPortainerEdgeStackStatus).optional(),
    StatusSummary:
      zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackStatusSummary.optional(),
    SupportPerDeviceConfigs: z.boolean().optional(),
    SupportRelativePath: z.boolean().optional(),
    UseManifestNamespaces: z.boolean().optional(),
    Version: z.int().optional(),
    Webhook: z.string().optional(),
    WorkflowID: z.int().optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksUpdateEdgeStackPayload =
  z.object({
    DeployerOptions: zEdgestacksDeployerOptionsPayload.optional(),
    DeploymentType: zPortainerEdgeStackDeploymentType.optional(),
    EdgeGroups: z.array(z.int()).optional(),
    EnvVars: z.array(zPortainerPair).optional(),
    PrePullImage: z.boolean().optional(),
    RePullImage: z.boolean().optional(),
    Registries: z.array(z.int()).optional(),
    RepullImageAndRedeploy: z.boolean().optional(),
    RetryDeploy: z.boolean().optional(),
    RetryPeriod: z.int().optional(),
    RollbackTo: z.int().optional(),
    StackFileContent: z.string().optional(),
    StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
    UpdateVersion: z.boolean().optional(),
    UseManifestNamespaces: z.boolean().optional(),
    Webhook: z.string().optional(),
  });

export const zPortainereeCustomTemplateEdgeSettings = z.object({
  PrePullImage: z.boolean().optional(),
  PrivateRegistryId: z.int().optional(),
  RelativePathSettings:
    zPortainereeCustomTemplateRelativePathSettings.optional(),
  RetryDeploy: z.boolean().optional(),
  RetryPeriod: z.int().optional(),
  StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesCustomTemplateFromFileContentPayload =
  z.object({
    Description: z.string(),
    EdgeSettings: zPortainereeCustomTemplateEdgeSettings.optional(),
    EdgeTemplate: z.boolean().optional(),
    FileContent: z.string(),
    Logo: z.string().optional(),
    Note: z.string().optional(),
    Platform: z.union([z.literal(1), z.literal(2)]).optional(),
    Title: z.string(),
    Type: z.union([z.literal(1), z.literal(2), z.literal(3)]),
    Variables: z.array(zPortainerCustomTemplateVariableDefinition).optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesCustomTemplateFromGitRepositoryPayload =
  z.object({
    ComposeFilePathInRepository: z
      .string()
      .optional()
      .default('docker-compose.yml'),
    Description: z.string(),
    EdgeSettings: zPortainereeCustomTemplateEdgeSettings.optional(),
    EdgeTemplate: z.boolean().optional(),
    IsComposeFormat: z.boolean().optional(),
    Logo: z.string().optional(),
    Note: z.string().optional(),
    Platform: z.union([z.literal(1), z.literal(2)]).optional(),
    RepositoryAuthentication: z.boolean().optional(),
    RepositoryAuthorizationType:
      zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
    RepositoryPassword: z.string().optional(),
    RepositoryProvider:
      zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
    RepositoryReferenceName: z.string().optional(),
    RepositoryURL: z.string().optional(),
    RepositoryUsername: z.string().optional(),
    SourceID: z.int(),
    TLSSkipVerify: z.boolean().optional(),
    Title: z.string(),
    Type: z.union([z.literal(1), z.literal(2)]),
    Variables: z.array(zPortainerCustomTemplateVariableDefinition).optional(),
  });

export const zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesCustomTemplateUpdatePayload =
  z.object({
    ComposeFilePathInRepository: z
      .string()
      .optional()
      .default('docker-compose.yml'),
    Description: z.string(),
    EdgeSettings: zPortainereeCustomTemplateEdgeSettings.optional(),
    EdgeTemplate: z.boolean().optional(),
    FileContent: z.string(),
    IsComposeFormat: z.boolean().optional(),
    Logo: z.string().optional(),
    Note: z.string().optional(),
    Platform: z.union([z.literal(1), z.literal(2)]).optional(),
    RepositoryAuthentication: z.boolean().optional(),
    RepositoryAuthorizationType:
      zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
    RepositoryPassword: z.string().optional(),
    RepositoryProvider:
      zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
    RepositoryReferenceName: z.string().optional(),
    RepositoryURL: z.string().optional(),
    RepositoryUsername: z.string().optional(),
    SourceID: z.int().optional(),
    TLSSkipVerify: z.boolean().optional(),
    Title: z.string(),
    Type: z.union([z.literal(1), z.literal(2), z.literal(3)]),
    Variables: z.array(zPortainerCustomTemplateVariableDefinition).optional(),
  });

export const zPortainereeCustomTemplate = z.object({
  CreatedByUserId: z.int().optional(),
  Description: z.string().optional(),
  EdgeSettings: zPortainereeCustomTemplateEdgeSettings.optional(),
  EdgeTemplate: z.boolean().optional(),
  EntryPoint: z.string().optional(),
  GitConfig: zGithubComPortainerPortainerEeApiGitTypesRepoConfig.optional(),
  Id: z.int().optional(),
  IsComposeFormat: z.boolean().optional(),
  Logo: z.string().optional(),
  Note: z.string().optional(),
  Platform: z.union([z.literal(1), z.literal(2)]).optional(),
  ProjectPath: z.string().optional(),
  ResourceControl: zPortainerResourceControl.optional(),
  Title: z.string().optional(),
  Type: z.union([z.literal(1), z.literal(2), z.literal(3)]).optional(),
  Variables: z.array(zPortainerCustomTemplateVariableDefinition).optional(),
  artifact: zPortainerArtifact.optional(),
});

export const zPortainereeEdgeStack = z.object({
  AlwaysCloneGitRepoForRelativePath: z.boolean().optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  CreatedBy: z.string().optional(),
  CreatedByUserId: z.string().optional(),
  CreationDate: z.int().optional(),
  CurrentDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  DeployerOptions: zPortainereeEdgeStackDeployerOptions.optional(),
  DeploymentType: zPortainerEdgeStackDeploymentType.optional(),
  EdgeGroups: z.array(z.int()).optional(),
  EdgeUpdateID: z.int().optional(),
  EntryPoint: z.string().optional(),
  EnvVars: z.array(zPortainerPair).optional(),
  FilesystemPath: z.string().optional(),
  GitConfig: zGithubComPortainerPortainerEeApiGitTypesRepoConfig.optional(),
  HelmConfig: zPortainerHelmConfig.optional(),
  Id: z.int().optional(),
  ManifestPath: z.string().optional(),
  Name: z.string().optional(),
  NumDeployments: z.int().optional(),
  PerDeviceConfigsGroupMatchType: z.enum(['file', ' dir']).optional(),
  PerDeviceConfigsMatchType: z.enum(['file', ' dir']).optional(),
  PerDeviceConfigsPath: z.string().optional(),
  PrePullImage: z.boolean().optional(),
  PreviousDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  ProjectPath: z.string().optional(),
  RePullImage: z.boolean().optional(),
  Registries: z.array(z.int()).optional(),
  RetryDeploy: z.boolean().optional(),
  RetryPeriod: z.int().optional(),
  ScheduledTime: z.string().optional(),
  StackFileVersion: z.int().optional(),
  StaggerConfig: zPortainereeEdgeStaggerConfig.optional(),
  Status: z.record(z.string(), zPortainerEdgeStackStatus).optional(),
  SupportPerDeviceConfigs: z.boolean().optional(),
  SupportRelativePath: z.boolean().optional(),
  UseManifestNamespaces: z.boolean().optional(),
  Version: z.int().optional(),
  Webhook: z.string().optional(),
  WorkflowID: z.int().optional(),
});

export const zPortainereeEndpointChangeWindow = z.object({
  Enabled: z.boolean(),
  EndTime: z.string(),
  StartTime: z.string(),
});

export const zEndpointsEndpointSettingsUpdatePayload = z.object({
  changeWindow: zPortainereeEndpointChangeWindow.optional(),
  deploymentOptions: zPortainereeDeploymentOptions.optional(),
  enableGPUManagement: z.boolean().optional(),
  enableImageNotification: z.boolean().optional(),
  gpus: z.array(zPortainerPair).optional(),
  securitySettings: z
    .object({
      allowBindMountsForRegularUsers: z.boolean().optional(),
      allowContainerCapabilitiesForRegularUsers: z.boolean().optional(),
      allowDeviceMappingForRegularUsers: z.boolean().optional(),
      allowHostNamespaceForRegularUsers: z.boolean().optional(),
      allowPrivilegedModeForRegularUsers: z.boolean().optional(),
      allowSecurityOptForRegularUsers: z.boolean().optional(),
      allowStackManagementForRegularUsers: z.boolean().optional(),
      allowSysctlSettingForRegularUsers: z.boolean().optional(),
      allowVolumeBrowserForRegularUsers: z.boolean().optional(),
      enableHostManagementFeatures: z.boolean().optional(),
    })
    .optional(),
});

export const zPortainereeEndpointOperationStatus = z.enum([
  'processing',
  'warning',
  'error',
  '',
]);

export const zPortainereeEndpointStatusMessage = z.object({
  detail: z.string().optional(),
  operation: z.string().optional(),
  operationStatus: zPortainereeEndpointOperationStatus.optional(),
  summary: z.string().optional(),
  warnings: z.array(z.string()).optional(),
});

export const zPortainereeEnvironmentAgentData = z.object({
  PreviousVersion: z.string().optional(),
  Version: z.string().optional(),
});

export const zPortainereeExperimentalFeatures = z.record(
  z.string(),
  z.unknown()
);

export const zPortainereeGlobalDeploymentOptions = z.object({
  hideAddWithForm: z.boolean().optional(),
  hideFileUpload: z.boolean().optional(),
  hideStacksFunctionality: z.boolean().optional(),
  hideWebEditor: z.boolean().optional(),
  minApplicationNoteLength: z.int().optional(),
  perEnvOverride: z.boolean().optional(),
  requireNoteOnApplications: z.boolean().optional(),
});

export const zPortainereeKubernetesConfiguration = z.object({
  AllowNoneIngressClass: z.boolean(),
  EnableNodeShell: z.boolean().optional(),
  EnableResourceOverCommit: z.boolean().optional(),
  IngressAvailabilityPerNamespace: z.boolean(),
  IngressClasses: z.array(zPortainerKubernetesIngressClassConfig).optional(),
  ResourceOverCommitPercentage: z.int().optional(),
  RestrictDefaultNamespace: z.boolean().optional(),
  RestrictSecrets: z.boolean().optional(),
  RestrictStandardUserIngressW: z.boolean().optional(),
  StorageClasses: z.array(zPortainerKubernetesStorageClassConfig).optional(),
  UseLoadBalancer: z.boolean().optional(),
  UseServerMetrics: z.boolean().optional(),
});

export const zPortainereeKubernetesData = z.object({
  Configuration: zPortainereeKubernetesConfiguration,
  Flags: zPortainerKubernetesFlags,
  Snapshots: z.array(zPortainerKubernetesSnapshot).optional(),
});

export const zEndpointsEndpointUpdatePayload = z.object({
  AzureApplicationID: z.string().optional(),
  AzureAuthenticationKey: z.string().optional(),
  AzureTenantID: z.string().optional(),
  ChangeWindow: zPortainereeEndpointChangeWindow.optional(),
  DeploymentOptions: zPortainereeDeploymentOptions.optional(),
  Edge: z
    .object({
      CommandInterval: z.int().optional(),
      PingInterval: z.int().optional(),
      SnapshotInterval: z.int().optional(),
    })
    .optional(),
  EdgeCheckinInterval: z.int().optional(),
  Gpus: z.array(zPortainerPair).optional(),
  GroupID: z.int().optional(),
  IsSetStatusMessage: z.boolean().optional(),
  Kubernetes: zPortainereeKubernetesData.optional(),
  Name: z.string().optional(),
  PublicURL: z.string().optional(),
  Status: z.int().optional(),
  StatusMessage: z
    .object({
      detail: z.string().optional(),
      operation: z.string().optional(),
      operationStatus: zPortainereeEndpointOperationStatus.optional(),
      summary: z.string().optional(),
    })
    .optional(),
  TLS: z.boolean().optional(),
  TLSSkipClientVerify: z.boolean().optional(),
  TLSSkipVerify: z.boolean().optional(),
  TagIDs: z.array(z.int()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  URL: z.string().optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
});

export const zPortainereeLdapKerberosSettings = z.object({
  Configuration: z.string().optional(),
  Password: z.string().optional(),
  Realm: z.string().optional(),
  Service: z.string().optional(),
  Username: z.string().optional(),
});

export const zPortainereeLdapServerType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zPortainereeLdapSettings = z.object({
  AdminAutoPopulate: z.boolean().optional(),
  AdminGroupSearchSettings: z
    .array(zPortainerLdapGroupSearchSettings)
    .optional(),
  AdminGroups: z.array(z.string()).optional(),
  AnonymousMode: z.boolean().optional(),
  AutoCreateUsers: z.boolean().optional(),
  GroupSearchSettings: z.array(zPortainerLdapGroupSearchSettings).optional(),
  Kerberos: zPortainereeLdapKerberosSettings.optional(),
  Password: z.string().optional(),
  ReaderDN: z.string().optional(),
  SearchSettings: z.array(zPortainerLdapSearchSettings).optional(),
  ServerType: zPortainereeLdapServerType.optional(),
  StartTLS: z.boolean().optional(),
  TLSConfig: zPortainerTlsConfiguration.optional(),
  URL: z.string().optional(),
  URLs: z.array(z.string()).optional(),
});

export const zLdapAdminGroupsPayload = z.object({
  LDAPSettings: zPortainereeLdapSettings.optional(),
});

export const zLdapCheckPayload = z.object({
  LDAPSettings: zPortainereeLdapSettings.optional(),
});

export const zLdapGroupsPayload = z.object({
  LDAPSettings: zPortainereeLdapSettings.optional(),
});

export const zLdapTestLoginPayload = z.object({
  LDAPSettings: zPortainereeLdapSettings.optional(),
  Password: z.string().optional(),
  Username: z.string().optional(),
});

export const zLdapUsersPayload = z.object({
  LDAPSettings: zPortainereeLdapSettings.optional(),
});

export const zPortainereeLocalBackupSettings = z.object({
  cronRule: z.string().optional(),
  retentionDays: z.int().optional(),
});

export const zPortainereeMtlsSettings = z.object({
  CaCertFile: z.string().optional(),
  CertFile: z.string().optional(),
  KeyFile: z.string().optional(),
  UseSeparateCert: z.boolean().optional(),
});

export const zPortainereeEdge = z.object({
  AsyncMode: z.boolean().optional(),
  CommandInterval: z.int().optional(),
  MTLS: zPortainereeMtlsSettings.optional(),
  PingInterval: z.int().optional(),
  SnapshotInterval: z.int().optional(),
  TunnelServerAddress: z.string().optional(),
});

export const zPortainereeMtlsStatus = z.object({
  enabled: z.boolean(),
  ok: z.boolean(),
});

export const zPortainereeOAuthClaimMappings = z.object({
  ClaimValRegex: z.string().optional(),
  Team: z.int().optional(),
});

export const zPortainereeOmniClusterPatchAnnotations = z.object({
  name: z.string().optional(),
});

export const zPortainereeOmniClusterPatch = z.object({
  annotations: zPortainereeOmniClusterPatchAnnotations.optional(),
  idOverride: z.string().optional(),
  inline: z.record(z.string(), z.unknown()).optional(),
});

export const zPortainereeOmniCluster = z.object({
  kind: z.string().optional(),
  kubernetes: z
    .object({
      version: z.string().optional(),
    })
    .optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  patches: z.array(zPortainereeOmniClusterPatch).optional(),
  talos: z
    .object({
      version: z.string().optional(),
    })
    .optional(),
});

export const zPortainereeOmniInterfaceRoute = z.object({
  gateway: z.string().optional(),
  network: z.string().optional(),
});

export const zPortainereeOmniInterface = z.object({
  addresses: z.array(z.string()).optional(),
  dhcp: z.boolean().optional(),
  interface: z.string().optional(),
  routes: z.array(zPortainereeOmniInterfaceRoute).optional(),
});

export const zPortainereeOmniMachineInstall = z.object({
  disk: z.string().optional(),
});

export const zPortainereeOmniMachinePatchRoute = z.object({
  gateway: z.string().optional(),
  network: z.string().optional(),
});

export const zPortainereeOmniMachinePatchInterface = z.object({
  addresses: z.array(z.string()).optional(),
  dhcp: z.boolean().optional(),
  interface: z.string().optional(),
  routes: z.array(zPortainereeOmniMachinePatchRoute).optional(),
});

export const zPortainereeOmniMachinePatchNetwork = z.object({
  hostname: z.string().optional(),
  interfaces: z.array(zPortainereeOmniMachinePatchInterface).optional(),
  nameservers: z.array(z.string()).optional(),
});

export const zPortainereeOmniMachinePatchMachine = z.object({
  network: zPortainereeOmniMachinePatchNetwork.optional(),
});

export const zPortainereeOmniMachinePatchInline = z.object({
  machine: zPortainereeOmniMachinePatchMachine.optional(),
});

export const zPortainereeOmniMachinePatch = z.object({
  idOverride: z.string().optional(),
  inline: zPortainereeOmniMachinePatchInline.optional(),
});

export const zPortainereeOmniUserDisk = z.object({
  size: z.int().optional(),
  volumeName: z.string().optional(),
});

export const zPortainereeOmniMachine = z.object({
  hostname: z.string().optional(),
  install: zPortainereeOmniMachineInstall.optional(),
  interfaces: z.array(zPortainereeOmniInterface).optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  nameservers: z.array(z.string()).optional(),
  patches: z.array(zPortainereeOmniMachinePatch).optional(),
  systemDiskSize: z.int().optional(),
  userDisk: zPortainereeOmniUserDisk.optional(),
});

export const zPortainereeOmniControlPlane = z.object({
  kind: z.string().optional(),
  machines: z.array(zPortainereeOmniMachine).optional(),
});

export const zPortainereeOmniWorker = z.object({
  kind: z.string().optional(),
  machines: z.array(zPortainereeOmniMachine).optional(),
  name: z.string().optional(),
});

export const zOmniCreateClusterPayload = z.object({
  cluster: zPortainereeOmniCluster.optional(),
  clusterConfig: z.string().optional(),
  controlPlane: zPortainereeOmniControlPlane.optional(),
  portainerUrl: z.string().optional(),
  tunnelServerAddr: z.string().optional(),
  worker: zPortainereeOmniWorker.optional(),
});

export const zOmniUpdateClusterPayload = z.object({
  cluster: zPortainereeOmniCluster.optional(),
  controlPlanesToAdd: zPortainereeOmniControlPlane.optional(),
  controlPlanesToRemove: z.array(z.string()).optional(),
  workersToAdd: zPortainereeOmniWorker.optional(),
  workersToRemove: z.array(z.string()).optional(),
});

export const zOmniValidateClusterPayload = z.object({
  cluster: zPortainereeOmniCluster.optional(),
  clusterConfig: z.string().optional(),
  controlPlane: zPortainereeOmniControlPlane.optional(),
  worker: zPortainereeOmniWorker.optional(),
});

export const zPortainereePolicyStatusType = z.enum([
  'applied',
  'failed',
  'in_progress',
  'warning',
  'not_supported',
]);

export const zPortainereePolicyStatus = z.object({
  LastAttemptTime: z.int().optional(),
  Message: z.string().optional(),
  Status: zPortainereePolicyStatusType.optional(),
});

export const zPortainereeAppliedPolicy = z.object({
  policyID: z.int().optional(),
  policyName: z.string().optional(),
  policyStatus: zPortainereePolicyStatus.optional(),
});

export const zPortainereeEndpointPolicies = z.object({
  changeConfirmationPolicy: zPortainereeAppliedPolicy.optional(),
  dockerCleanupPolicy: zPortainereeAppliedPolicy.optional(),
  dockerRBACPolicy: zPortainereeAppliedPolicy.optional(),
  dockerRegistryPolicy: zPortainereeAppliedPolicy.optional(),
  dockerSecurityPolicy: zPortainereeAppliedPolicy.optional(),
  dockerSetupPolicy: zPortainereeAppliedPolicy.optional(),
  k8sNetworkSecurityPolicy: zPortainereeAppliedPolicy.optional(),
  k8sObservabilityPolicy: zPortainereeAppliedPolicy.optional(),
  k8sPodSecurityStandardsPolicy: zPortainereeAppliedPolicy.optional(),
  k8sRBACPolicy: zPortainereeAppliedPolicy.optional(),
  k8sRegistryPolicy: zPortainereeAppliedPolicy.optional(),
  k8sSecurityPolicy: zPortainereeAppliedPolicy.optional(),
  k8sSetupPolicy: zPortainereeAppliedPolicy.optional(),
});

export const zEndpointsEndpointResponse = z.object({
  Agent: zEndpointsAgentResponse,
  AzureCredentials: zPortainerAzureCredentials.optional(),
  ChangeWindow: zPortainereeEndpointChangeWindow,
  CloudProvider: zPortainereeCloudProvider.optional(),
  ComposeSyntaxMaxVersion: z.string(),
  ContainerEngine: z.string(),
  DeploymentOptions: zPortainereeDeploymentOptions.optional(),
  Edge: zPortainerEnvironmentEdgeSettings,
  EdgeCheckinInterval: z.int(),
  EdgeID: z.string().optional(),
  EdgeKey: z.string(),
  EnableGPUManagement: z.boolean().optional(),
  EnableImageNotification: z.boolean(),
  Gpus: z.array(zPortainerPair).optional(),
  GroupId: z.int(),
  Heartbeat: z.boolean().optional(),
  Id: z.int(),
  Kubernetes: zPortainereeKubernetesData,
  LastCheckInDate: z.int(),
  LocalTimeZone: z.string(),
  MTLSStatus: zPortainereeMtlsStatus.optional(),
  Name: z.string(),
  Policies: zPortainereeEndpointPolicies.optional(),
  PublicURL: z.string(),
  SecuritySettings: zPortainerEndpointSecuritySettings,
  Snapshots: z.array(zPortainerDockerSnapshot).optional(),
  Status: z
    .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
    .optional(),
  StatusMessage: zPortainereeEndpointStatusMessage,
  TLSConfig: zPortainerTlsConfiguration,
  TagIds: z.array(z.int()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  Type: zPortainerEndpointType,
  URL: z.string(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
  UserTrusted: z.boolean().optional(),
});

export const zPortainereeEndpoint = z.object({
  Agent: zPortainereeEnvironmentAgentData,
  AzureCredentials: zPortainerAzureCredentials.optional(),
  ChangeWindow: zPortainereeEndpointChangeWindow,
  CloudProvider: zPortainereeCloudProvider.optional(),
  ComposeSyntaxMaxVersion: z.string(),
  ContainerEngine: z.string(),
  DeploymentOptions: zPortainereeDeploymentOptions.optional(),
  Edge: zPortainerEnvironmentEdgeSettings,
  EdgeCheckinInterval: z.int(),
  EdgeID: z.string().optional(),
  EdgeKey: z.string(),
  EnableGPUManagement: z.boolean().optional(),
  EnableImageNotification: z.boolean(),
  Gpus: z.array(zPortainerPair).optional(),
  GroupId: z.int(),
  Heartbeat: z.boolean().optional(),
  Id: z.int(),
  Kubernetes: zPortainereeKubernetesData,
  LastCheckInDate: z.int(),
  LocalTimeZone: z.string(),
  MTLSStatus: zPortainereeMtlsStatus.optional(),
  Name: z.string(),
  Policies: zPortainereeEndpointPolicies.optional(),
  PublicURL: z.string(),
  SecuritySettings: zPortainerEndpointSecuritySettings,
  Snapshots: z.array(zPortainerDockerSnapshot).optional(),
  Status: z
    .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
    .optional(),
  StatusMessage: zPortainereeEndpointStatusMessage,
  TLSConfig: zPortainerTlsConfiguration,
  TagIds: z.array(z.int()).optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  Type: zPortainerEndpointType,
  URL: z.string(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
  UserTrusted: z.boolean().optional(),
});

export const zPortainereeRecommendationCategory = z.enum([
  'governance',
  'security',
  'operations',
]);

export const zPortainereeRecommendationSeverity = z.enum([
  'error',
  'warning',
  'info',
]);

export const zPortainereeRegistry = z.object({
  AccessToken: z.string().optional(),
  AccessTokenExpiry: z.int().optional(),
  Authentication: z.boolean().optional(),
  AuthorizedTeams: z.array(z.int()).optional(),
  AuthorizedUsers: z.array(z.int()).optional(),
  BaseURL: z.string().optional(),
  Ecr: zPortainerEcrData.optional(),
  Github: zPortainerGithubRegistryData.optional(),
  Gitlab: zPortainerGitlabRegistryData.optional(),
  Id: z.int().optional(),
  ManagementConfiguration: zPortainerRegistryManagementConfiguration.optional(),
  Name: z.string().optional(),
  Password: z.string().optional(),
  Quay: zPortainerQuayRegistryData.optional(),
  RegistryAccesses: zPortainerRegistryAccesses.optional(),
  TeamAccessPolicies: zPortainerTeamAccessPolicies.optional(),
  Type: z
    .union([
      z.literal(1),
      z.literal(2),
      z.literal(3),
      z.literal(4),
      z.literal(5),
      z.literal(6),
      z.literal(7),
    ])
    .optional(),
  URL: z.string().optional(),
  UserAccessPolicies: zPortainerUserAccessPolicies.optional(),
  Username: z.string().optional(),
});

export const zPortainereeRole = z.object({
  Authorizations: zPortainerAuthorizations,
  Description: z.string(),
  Id: z.int(),
  Name: z.string(),
  Priority: z.int(),
  Scope: z.record(z.string(), z.array(z.string())),
});

export const zPortainereeS3BackupSettings = z.object({
  accessKeyID: z.string().optional(),
  bucketName: z.string().optional(),
  cronRule: z.string().optional(),
  password: z.string().optional(),
  region: z.string().optional(),
  s3CompatibleHost: z.string().optional(),
  secretAccessKey: z.string().optional(),
});

export const zPortainereeSslSettings = z.object({
  caCertPath: z.string().optional(),
  certPath: z.string().optional(),
  httpEnabled: z.boolean().optional(),
  keyPath: z.string().optional(),
  selfSigned: z.boolean().optional(),
});

export const zPortainereeStack = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  CreatedBy: z.string().optional(),
  CreatedByUserId: z.string().optional(),
  CreationDate: z.int().optional(),
  CurrentDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  DeploymentStartStatus: zPortainerStackStatus.optional(),
  DeploymentStatus: z.array(zPortainerStackDeploymentStatus).optional(),
  EndpointId: z.int().optional(),
  EntryPoint: z.string().optional(),
  Env: z.array(zPortainerPair).optional(),
  FilesystemPath: z.string().optional(),
  FromAppTemplate: z.boolean().optional(),
  GitConfig: zGithubComPortainerPortainerEeApiGitTypesRepoConfig.optional(),
  HelmChartPath: z.string().optional(),
  HelmValuesFiles: z.array(z.string()).optional(),
  Id: z.int().optional(),
  IsDetachedFromGit: z.boolean().optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Option: zPortainerStackOption.optional(),
  PreviousDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  ProjectPath: z.string().optional(),
  Registries: z.array(z.int()).optional(),
  ResourceControl: zPortainerResourceControl.optional(),
  StackFileVersion: z.int().optional(),
  Status: zPortainerStackStatus.optional(),
  SupportRelativePath: z.boolean().optional(),
  SwarmId: z.string().optional(),
  Type: zPortainerStackType.optional(),
  UpdateDate: z.int().optional(),
  UpdatedBy: z.string().optional(),
  Webhook: z.string().optional(),
  WorkflowID: z.int().optional(),
});

export const zPortainereeTalosVersions = z.record(
  z.string(),
  z.array(z.string())
);

export const zPortainereeTeamMemberships = z.object({
  AdminAutoPopulate: z.boolean().optional(),
  AdminGroupClaimsRegexList: z.array(z.string()).optional(),
  OAuthClaimMappings: z.array(zPortainereeOAuthClaimMappings).optional(),
  OAuthClaimName: z.string().optional(),
});

export const zPortainereeOAuthSettings = z.object({
  AccessTokenURI: z.string().optional(),
  AuthStyle: zOauth2AuthStyle.optional(),
  AuthorizationURI: z.string().optional(),
  ClientID: z.string().optional(),
  ClientSecret: z.string().optional(),
  DefaultTeamID: z.int().optional(),
  HideInternalAuth: z.boolean().optional(),
  KubeSecretKey: z.array(z.int()).optional(),
  LogoutURI: z.string().optional(),
  MicrosoftTenantID: z.string().optional(),
  OAuthAutoCreateUsers: z.boolean().optional(),
  OAuthAutoMapTeamMemberships: z.boolean().optional(),
  RedirectURI: z.string().optional(),
  ResourceURI: z.string().optional(),
  SSO: z.boolean().optional(),
  Scopes: z.string().optional(),
  TeamMemberships: zPortainereeTeamMemberships.optional(),
  UserIdentifier: z.string().optional(),
});

export const zPortainereeSettings = z.object({
  AdditionalFunctionality: zPortainereeAdditionalFunctionality.optional(),
  AddonsCatalogURL: z.string().optional(),
  AgentSecret: z.string().optional(),
  AllowBindMountsForRegularUsers: z.boolean().optional(),
  AllowContainerCapabilitiesForRegularUsers: z.boolean().optional(),
  AllowDeviceMappingForRegularUsers: z.boolean().optional(),
  AllowHostNamespaceForRegularUsers: z.boolean().optional(),
  AllowPrivilegedModeForRegularUsers: z.boolean().optional(),
  AllowStackManagementForRegularUsers: z.boolean().optional(),
  AllowVolumeBrowserForRegularUsers: z.boolean().optional(),
  AuthenticationMethod: zPortainerAuthenticationMethod.optional(),
  AutoPatchSettings: zPortainereeAutoPatchSettings.optional(),
  BlackListedLabels: z.array(zPortainerPair).optional(),
  CloudApiKeys: zPortainereeCloudApiKeys.optional(),
  CustomLoginBanner: z.string().optional(),
  DefaultRegistry: z
    .object({
      Hide: z.boolean().optional(),
    })
    .optional(),
  DisableKubeRolesSync: z.boolean().optional(),
  DisableKubeShell: z.boolean().optional(),
  DisableKubeconfigDownload: z.boolean().optional(),
  DisplayDonationHeader: z.boolean().optional(),
  DisplayExternalContributors: z.boolean().optional(),
  Edge: zPortainereeEdge.optional(),
  EdgeAgentCheckinInterval: z.int().optional(),
  EdgePortainerUrl: z.string().optional(),
  EnableEdgeComputeFeatures: z.boolean().optional(),
  EnableHostManagementFeatures: z.boolean().optional(),
  EnforceEdgeID: z.boolean().optional(),
  ExperimentalFeatures: zPortainereeExperimentalFeatures.optional(),
  FeatureFlagSettings: z.record(z.string(), z.boolean()).optional(),
  ForceSecureCookies: z.boolean().optional(),
  GlobalDeploymentOptions: zPortainereeGlobalDeploymentOptions.optional(),
  HelmRepositoryURL: z.string().optional(),
  InternalAuthSettings: zPortainerInternalAuthSettings.optional(),
  IsDockerDesktopExtension: z.boolean().optional(),
  KubeconfigExpiry: z.string().optional(),
  KubectlShellImage: z.string().optional(),
  LDAPSettings: zPortainereeLdapSettings.optional(),
  LogoURL: z.string().optional(),
  OAuthSettings: zPortainereeOAuthSettings.optional(),
  SnapshotInterval: z.string().optional(),
  TemplatesURL: z.string().optional(),
  TrustOnFirstConnect: z.boolean().optional(),
  UserSessionTimeout: z.string().optional(),
});

export const zPortainereeUserActivityLog = z.object({
  action: z.string().optional(),
  context: z.string().optional(),
  id: z.int().optional(),
  payload: z.array(z.int()).optional(),
  timestamp: z.int().optional(),
  username: z.string().optional(),
});

export const zPortainereeUserThemeSettings = z.object({
  color: z.enum(['dark', 'light', 'highcontrast', 'auto', '']).optional(),
  subtleUpgradeButton: z.boolean().optional(),
});

export const zPortainereeUser = z.object({
  Id: z.int(),
  PortainerAuthorizations: zPortainerAuthorizations.optional(),
  Role: zPortainerUserRole,
  ThemeSettings: zPortainereeUserThemeSettings.optional(),
  TokenIssueAt: z.int().optional(),
  UseCache: z.boolean().optional(),
  Username: z.string(),
});

export const zRecommendationsRecommendationResponse = z.object({
  actionLabel: z.string().optional(),
  actionUrl: z.string().optional(),
  category: zPortainereeRecommendationCategory.optional(),
  description: z.string().optional(),
  severity: zPortainereeRecommendationSeverity.optional(),
  title: z.string().optional(),
  typeId: z.string().optional(),
});

export const zRecommendationsSummaryResponse = z.object({
  categoryCounts: z.record(z.string(), z.int()).optional(),
  severityCounts: z.record(z.string(), z.int()).optional(),
  total: z.int().optional(),
  totalTypes: z.int().optional(),
});

export const zRegistriesDeleteTagsPayload = z.object({
  Tags: z.array(z.string()).optional(),
});

export const zRegistriesRegistryConfigurePayload = z.object({
  Authentication: z.boolean(),
  Password: z.string().optional(),
  Region: z.string().optional(),
  TLS: z.boolean().optional(),
  TLSCACertFile: z
    .array(
      z
        .int()
        .min(-2147483648, {
          error: 'Invalid value: Expected int32 to be >= -2147483648',
        })
        .max(2147483647, {
          error: 'Invalid value: Expected int32 to be <= 2147483647',
        })
    )
    .optional(),
  TLSCertFile: z
    .array(
      z
        .int()
        .min(-2147483648, {
          error: 'Invalid value: Expected int32 to be >= -2147483648',
        })
        .max(2147483647, {
          error: 'Invalid value: Expected int32 to be <= 2147483647',
        })
    )
    .optional(),
  TLSKeyFile: z
    .array(
      z
        .int()
        .min(-2147483648, {
          error: 'Invalid value: Expected int32 to be >= -2147483648',
        })
        .max(2147483647, {
          error: 'Invalid value: Expected int32 to be <= 2147483647',
        })
    )
    .optional(),
  TLSSkipVerify: z.boolean().optional(),
  Username: z.string().optional(),
});

export const zRegistriesRegistryCreatePayload = z.object({
  Authentication: z.boolean(),
  BaseURL: z.string().optional(),
  Ecr: zPortainerEcrData.optional(),
  Github: zPortainerGithubRegistryData.optional(),
  Gitlab: zPortainerGitlabRegistryData.optional(),
  Name: z.string(),
  Password: z.string().optional(),
  Quay: zPortainerQuayRegistryData.optional(),
  TLS: z.boolean().optional(),
  Type: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
  ]),
  URL: z.string(),
  Username: z.string().optional(),
});

export const zRegistriesRegistryPingPayload = z.object({
  Password: z.string().optional(),
  TLS: z.boolean().optional(),
  Type: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
  ]),
  URL: z.string(),
  Username: z.string().optional(),
});

export const zRegistriesRegistryPingResponse = z.object({
  message: z.string().optional(),
  success: z.boolean().optional(),
});

export const zRegistriesRegistryUpdatePayload = z.object({
  Authentication: z.boolean(),
  BaseURL: z.string().optional(),
  Ecr: zPortainerEcrData.optional(),
  Github: zPortainerGithubRegistryData.optional(),
  Name: z.string(),
  Password: z.string().optional(),
  Quay: zPortainerQuayRegistryData.optional(),
  RegistryAccesses: zPortainerRegistryAccesses.optional(),
  URL: z.string(),
  Username: z.string().optional(),
});

export const zRegistriesRepositoryTagsDeletePayload = z.object({
  tags: z.array(z.string()).optional(),
});

export const zReleaseChartReference = z.object({
  chartPath: z.string().optional(),
  registryID: z.int().optional(),
  repoURL: z.string().optional(),
});

export const zReleaseDependency = z.object({
  alias: z.string().optional(),
  condition: z.string().optional(),
  enabled: z.boolean().optional(),
  'import-values': z.array(z.unknown()).optional(),
  name: z.string().optional(),
  repository: z.string().optional(),
  tags: z.array(z.string()).optional(),
  version: z.string().optional(),
});

export const zReleaseFile = z.object({
  data: z.array(z.int()).optional(),
  name: z.string().optional(),
});

export const zReleaseHookExecution = z.object({
  completed_at: z.string().optional(),
  phase: z.string().optional(),
  started_at: z.string().optional(),
});

export const zGithubComPortainerPortainerPkgLibhelmReleaseHook = z.object({
  delete_policies: z.array(z.string()).optional(),
  events: z.array(z.string()).optional(),
  kind: z.string().optional(),
  last_run: zReleaseHookExecution.optional(),
  manifest: z.string().optional(),
  name: z.string().optional(),
  path: z.string().optional(),
  weight: z.int().optional(),
});

export const zReleaseLock = z.object({
  dependencies: z.array(zReleaseDependency).optional(),
  digest: z.string().optional(),
  generated: z.string().optional(),
});

export const zReleaseMaintainer = z.object({
  email: z.string().optional(),
  name: z.string().optional(),
  url: z.string().optional(),
});

export const zReleaseMetadata = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  apiVersion: z.string().optional(),
  appVersion: z.string().optional(),
  condition: z.string().optional(),
  dependencies: z.array(zReleaseDependency).optional(),
  deprecated: z.boolean().optional(),
  description: z.string().optional(),
  home: z.string().optional(),
  icon: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  kubeVersion: z.string().optional(),
  maintainers: z.array(zReleaseMaintainer).optional(),
  name: z.string().optional(),
  sources: z.array(z.string()).optional(),
  tags: z.string().optional(),
  type: z.string().optional(),
  version: z.string().optional(),
});

export const zReleaseChart = z.object({
  files: z.array(zReleaseFile).optional(),
  lock: zReleaseLock.optional(),
  metadata: zReleaseMetadata.optional(),
  schema: z.array(z.int()).optional(),
  templates: z.array(zReleaseFile).optional(),
  values: z.record(z.string(), z.unknown()).optional(),
});

export const zReleaseReleaseElement = z.object({
  appVersion: z.string().optional(),
  chart: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  revision: z.string().optional(),
  status: z.string().optional(),
  updated: z.string().optional(),
});

export const zReleaseValues = z.object({
  computedValues: z.string().optional(),
  userSuppliedValues: z.string().optional(),
});

export const zResourceQuantity = z.object({
  Format: z.enum(['DecimalExponent', 'BinarySI', 'DecimalSI']).optional(),
});

export const zResourcecontrolsResourceControlCreatePayload = z.object({
  AdministratorsOnly: z.boolean().optional(),
  Public: z.boolean().optional(),
  ResourceID: z.string(),
  SubResourceIDs: z.array(z.string()).optional(),
  Teams: z.array(z.int()).optional(),
  Type: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
  ]),
  Users: z.array(z.int()).optional(),
});

export const zResourcecontrolsResourceControlUpdatePayload = z.object({
  AdministratorsOnly: z.boolean().optional(),
  Public: z.boolean().optional(),
  Teams: z.array(z.int()).optional(),
  Users: z.array(z.int()).optional(),
});

export const zRoarRoarPortainerEndpointId = z.record(z.string(), z.unknown());

export const zPortainereeEdgeGroup = z.object({
  Dynamic: z.boolean().optional(),
  EdgeUpdateID: z.int().optional(),
  EndpointIds: zRoarRoarPortainerEndpointId.optional(),
  Endpoints: z.array(z.int()).optional(),
  Id: z.int().optional(),
  Name: z.string().optional(),
  PartialMatch: z.boolean().optional(),
  TagIds: z.array(z.int()).optional(),
});

export const zSettingsAutoPatchResponse = z.object({
  Enabled: z.boolean().optional(),
  PatchCron: z.string().optional(),
});

export const zSettingsAutoPatchSettingsPayload = z.object({
  Enabled: z.boolean().optional(),
  PatchCron: z.string().optional(),
  PortainerRepository: z.string().optional(),
  RegistryID: z.int().optional(),
  UpdaterRepository: z.string().optional(),
});

export const zSettingsDefaultRegistryUpdatePayload = z.object({
  Hide: z.boolean().optional(),
});

export const zSettingsMTlsPayload = z.object({
  CaCert: z.string().optional(),
  Cert: z.string().optional(),
  Key: z.string().optional(),
  UseSeparateCert: z.boolean().optional(),
});

export const zSettingsPublicSettingsResponse = z.object({
  AuthenticationMethod: zPortainerAuthenticationMethod.optional(),
  AutoPatchSettings: zSettingsAutoPatchResponse.optional(),
  CustomLoginBanner: z.string().optional(),
  DefaultRegistry: z
    .object({
      Hide: z.boolean().optional(),
    })
    .optional(),
  DisableKubeShell: z.boolean().optional(),
  DisableKubeconfigDownload: z.boolean().optional(),
  Edge: z
    .object({
      CheckinInterval: z.int().optional(),
      CommandInterval: z.int().optional(),
      MTLS: zPortainereeMtlsSettings.optional(),
      PingInterval: z.int().optional(),
      SnapshotInterval: z.int().optional(),
    })
    .optional(),
  EnableEdgeComputeFeatures: z.boolean().optional(),
  FIPSMode: z.boolean().optional(),
  Features: z.record(z.string(), z.boolean()).optional(),
  GlobalDeploymentOptions: zPortainereeGlobalDeploymentOptions.optional(),
  KubeconfigExpiry: z.string().optional().default('0'),
  LogoURL: z.string().optional(),
  OAuthHideInternalAuth: z.boolean().optional(),
  OAuthLoginURI: z.string().optional(),
  OAuthLogoutURI: z.string().optional(),
  RequiredPasswordLength: z.int().optional(),
  RequiresSetupToken: z.boolean().optional(),
  TeamSync: z.boolean().optional(),
  Whitelabel: z.string().optional(),
});

export const zSettingsSettingsAdditionalFunctionalityInspectResponse = z.object(
  {
    additionalFunctionality: zPortainereeAdditionalFunctionality.optional(),
  }
);

export const zSettingsSettingsAdditionalFunctionalityUpdatePayload = z.object({
  Policies: z.boolean(),
});

export const zSettingsSettingsExperimentalInspectResponse = z.object({
  experimentalFeatures: zPortainereeExperimentalFeatures.optional(),
});

export const zSettingsSettingsExperimentalUpdatePayload = z.object({
  fleetManagement: z.boolean().optional(),
});

export const zSettingsSettingsUpdatePayload = z.object({
  AddonsCatalogURL: z.string().optional(),
  AuthenticationMethod: z.int().optional(),
  AutoPatchSettings: zSettingsAutoPatchSettingsPayload.optional(),
  BlackListedLabels: z.array(zPortainerPair).optional(),
  CustomLoginBanner: z.string().optional(),
  DisableKubeRolesSync: z.boolean().optional(),
  DisableKubeShell: z.boolean().optional(),
  DisableKubeconfigDownload: z.boolean().optional(),
  Edge: z
    .object({
      AsyncMode: z.boolean().optional(),
      CommandInterval: z.int().optional(),
      MTLS: zSettingsMTlsPayload.optional(),
      PingInterval: z.int().optional(),
      SnapshotInterval: z.int().optional(),
      TunnelServerAddress: z.string().optional(),
    })
    .optional(),
  EdgeAgentCheckinInterval: z.int().optional(),
  EdgePortainerURL: z.string().optional(),
  EnableEdgeComputeFeatures: z.boolean().optional(),
  EnforceEdgeID: z.boolean().optional(),
  ForceSecureCookies: z.boolean().optional(),
  GlobalDeploymentOptions: zPortainereeGlobalDeploymentOptions.optional(),
  HelmRepositoryURL: z.string().optional(),
  InternalAuthSettings: zPortainerInternalAuthSettings.optional(),
  KubeconfigExpiry: z.string().optional().default('0'),
  KubectlShellImage: z.string().optional(),
  LDAPSettings: zPortainereeLdapSettings.optional(),
  LogoURL: z.string().optional(),
  OAuthSettings: zPortainereeOAuthSettings.optional(),
  SnapshotInterval: z.string().optional(),
  TemplatesURL: z.string().optional(),
  TrustOnFirstConnect: z.boolean().optional(),
  UserSessionTimeout: z.string().optional(),
});

export const zSourcesAuthType = z.enum(['basic', 'token']);

export const zSourcesConnectionTestResult = z.object({
  error: z.string().optional(),
  success: z.boolean().optional(),
});

export const zSourcesProvider = z.enum([
  'custom',
  'github',
  'gitlab',
  'bitbucket-cloud',
  'bitbucket-datacenter',
  'azure-devops',
  'gitea-forgejo',
]);

export const zSourcesGitAuthenticationPayload = z.object({
  password: z.string().optional(),
  provider: zSourcesProvider.optional(),
  sharedCredentialId: z.int().optional(),
  type: zSourcesAuthType.optional(),
  username: z.string().optional(),
});

export const zSourcesGitAuthenticationUpdatePayload = z.object({
  password: z.string().optional(),
  provider: zSourcesProvider.optional(),
  sharedCredentialId: z.int().optional(),
  type: zSourcesAuthType.optional(),
  username: z.string().optional(),
});

export const zSourcesGitSourceCreatePayload = z.object({
  administratorsOnly: z.boolean().optional(),
  authentication: zSourcesGitAuthenticationPayload.optional(),
  interval: z.string().optional(),
  name: z.string().optional(),
  public: z.boolean().optional(),
  teamAccesses: z.array(z.int()).optional(),
  tlsSkipVerify: z.boolean().optional(),
  url: z.string(),
  userAccesses: z.array(z.int()).optional(),
});

export const zSourcesGitSourceUpdatePayload = z.object({
  authentication: zSourcesGitAuthenticationUpdatePayload.optional(),
  interval: z.string().optional(),
  name: z.string().optional(),
  tlsSkipVerify: z.boolean().optional(),
  url: z.string().optional(),
});

export const zSourcesSourceAccess = z.object({
  public: z.boolean().optional(),
  teams: z.array(z.int()).optional(),
  users: z.array(z.int()).optional(),
});

export const zSourcesSourceAccessUpdatePayload = z.object({
  public: z.boolean().optional(),
  teams: z.array(z.int()).optional(),
  users: z.array(z.int()).optional(),
});

export const zSourcesSourceType = z.enum(['git', 'helm', 'oci']);

export const zSourcesSource = z.object({
  environments: z.int().optional(),
  error: z.string().optional(),
  id: z.int(),
  interval: z.string().optional(),
  lastSync: z.int().optional(),
  name: z.string(),
  provider: zSourcesProvider.optional(),
  status: zGithubComPortainerPortainerApiGitopsWorkflowsStatus,
  type: zSourcesSourceType,
  url: z.string(),
  usedBy: z.int().optional(),
});

export const zSourcesStatus = z.enum(['unknown', 'healthy', 'error']);

export const zSourcesGitAuthInfo = z.object({
  sharedCredentialId: z.int().optional(),
  type: zSourcesAuthType.optional(),
  username: z.string().optional(),
});

export const zSourcesConnectionInfo = z.object({
  authentication: zSourcesGitAuthInfo.optional(),
  tlsSkipVerify: z.boolean().optional(),
});

export const zSourcesSourceDetail = z.object({
  access: zSourcesSourceAccess.optional(),
  connection: zSourcesConnectionInfo,
  error: z.string().optional(),
  id: z.int(),
  interval: z.string().optional(),
  lastSync: z.int().optional(),
  name: z.string(),
  provider: zSourcesProvider.optional(),
  status: zGithubComPortainerPortainerApiGitopsWorkflowsStatus,
  type: zSourcesSourceType,
  url: z.string(),
});

export const zSslName = z.object({
  CommonName: z.string().optional(),
  Country: z.array(z.string()).optional(),
  Locality: z.array(z.string()).optional(),
  Organization: z.array(z.string()).optional(),
  OrganizationalUnit: z.array(z.string()).optional(),
  PostalCode: z.array(z.string()).optional(),
  Province: z.array(z.string()).optional(),
  SerialNumber: z.string().optional(),
  StreetAddress: z.array(z.string()).optional(),
});

export const zSslPublicKey = z.object({
  Algorithm: z.string().optional(),
  Exponent: z.string().optional(),
  Modulus: z.string().optional(),
  Size: z.int().optional(),
  Value: z.string().optional(),
});

export const zSslCertificate = z.object({
  AuthorityKeyId: z.string().optional(),
  CRLDistributionPoints: z.array(z.string()).optional(),
  ExtendedKeyUsages: z.array(z.string()).optional(),
  IsCertificateAuthority: z.boolean().optional(),
  Issuer: zSslName.optional(),
  IssuingCertificateURLs: z.array(z.string()).optional(),
  KeyUsages: z.array(z.string()).optional(),
  OCSPServers: z.array(z.string()).optional(),
  Policies: z.array(z.string()).optional(),
  PublicKey: zSslPublicKey.optional(),
  SHA256Fingerprint: z.string().optional(),
  SerialNumber: z.string().optional(),
  SignatureAlgorithm: z.string().optional(),
  Subject: zSslName.optional(),
  SubjectAltDNSNames: z.array(z.string()).optional(),
  SubjectAltEmailAddresses: z.array(z.string()).optional(),
  SubjectAltIpAddresses: z.array(z.string()).optional(),
  SubjectAltURIs: z.array(z.string()).optional(),
  SubjectKeyId: z.string().optional(),
  ValidNotAfter: z.string().optional(),
  ValidNotBefore: z.string().optional(),
  Version: z.int().optional(),
});

export const zEndpointsEndpointMtlsCertResponse = z.object({
  MTLSCertificate: zSslCertificate.optional(),
});

export const zSettingsSettingsCaCertResponse = z.object({
  MTLSCACertificate: zSslCertificate.optional(),
});

export const zSettingsSettingsCertResponse = z.object({
  MTLSCertificate: zSslCertificate.optional(),
});

export const zSslSslUpdatePayload = z.object({
  Cert: z.string().optional(),
  HTTPEnabled: z.boolean().optional(),
  Key: z.string().optional(),
  clientCert: z.string().optional(),
});

export const zStacksComposeStackFromFileContentPayload = z.object({
  Env: z.array(zPortainerPair).optional(),
  FromAppTemplate: z.boolean().optional(),
  Name: z.string(),
  Registries: z.array(z.int()).optional(),
  StackFileContent: z.string(),
  Webhook: z.string().optional(),
});

export const zStacksComposeStackFromGitRepositoryPayload = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  ComposeFile: z.string().optional().default('docker-compose.yml'),
  Env: z.array(zPortainerPair).optional(),
  FilesystemPath: z.string().optional(),
  FromAppTemplate: z.boolean().optional(),
  Name: z.string(),
  Registries: z.array(z.int()).optional(),
  RepositoryAuthentication: z.boolean().optional(),
  RepositoryAuthorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  RepositoryPassword: z.string().optional(),
  RepositoryProvider:
    zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  RepositoryReferenceName: z.string().optional(),
  RepositoryURL: z.string().optional(),
  RepositoryUsername: z.string().optional(),
  SourceID: z.int().optional(),
  SupportRelativePath: z.boolean().optional(),
  TLSSkipVerify: z.boolean().optional(),
});

export const zStacksCreateKubernetesStackResponse = z.object({
  Output: z.string().optional(),
});

export const zStacksKubernetesGitDeploymentPayload = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  ComposeFormat: z.boolean().optional(),
  HelmChartPath: z.string().optional(),
  HelmValuesFiles: z.array(z.string()).optional(),
  ManifestFile: z.string().optional(),
  Namespace: z.string().optional(),
  RepositoryAuthentication: z.boolean().optional(),
  RepositoryAuthorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  RepositoryPassword: z.string().optional(),
  RepositoryProvider:
    zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  RepositoryReferenceName: z.string().optional(),
  RepositoryURL: z.string().optional(),
  RepositoryUsername: z.string().optional(),
  SourceID: z.int().optional(),
  StackName: z.string().optional(),
  TLSSkipVerify: z.boolean().optional(),
});

export const zStacksKubernetesManifestUrlDeploymentPayload = z.object({
  ComposeFormat: z.boolean().optional(),
  ManifestURL: z.string().optional(),
  Namespace: z.string().optional(),
  StackName: z.string().optional(),
});

export const zStacksKubernetesStringDeploymentPayload = z.object({
  ComposeFormat: z.boolean().optional(),
  FromAppTemplate: z.boolean().optional(),
  Namespace: z.string().optional(),
  StackFileContent: z.string().optional(),
  StackName: z.string().optional(),
});

export const zStacksStackConvertPayload = z.object({
  namespace: z.string().optional(),
  targetFormat: z.string(),
});

export const zStacksStackConvertResponse = z.object({
  files: z.record(z.string(), z.string()).optional(),
});

export const zStacksStackFileResponse = z.object({
  StackFileContent: z.string().optional(),
});

export const zStacksStackGitRedeployPayload = z.object({
  Env: z.array(zPortainerPair).optional(),
  Prune: z.boolean().optional(),
  PullImage: z.boolean().optional(),
  RepositoryAuthentication: z.boolean().optional(),
  RepositoryAuthorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  RepositoryPassword: z.string().optional(),
  RepositoryProvider:
    zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  RepositoryReferenceName: z.string().optional(),
  RepositoryUsername: z.string().optional(),
  RepullImageAndRedeploy: z.boolean().optional(),
  StackName: z.string().optional(),
});

export const zStacksStackGitUpdatePayload = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  Atomic: z.boolean().optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  ConfigFilePath: z.string().optional(),
  Env: z.array(zPortainerPair).optional(),
  HelmChartPath: z.string().optional(),
  HelmValuesFiles: z.array(z.string()).optional(),
  Prune: z.boolean().optional(),
  Registries: z.array(z.int()).optional(),
  RepositoryAuthentication: z.boolean().optional(),
  RepositoryAuthorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  RepositoryPassword: z.string().optional(),
  RepositoryProvider:
    zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  RepositoryReferenceName: z.string().optional(),
  RepositoryURL: z.string().optional(),
  RepositoryUsername: z.string().optional(),
  SourceID: z.int().optional(),
  TLSSkipVerify: z.boolean().optional(),
});

export const zStacksStackMigratePayload = z.object({
  EndpointID: z.int(),
  IsHelm: z.boolean().optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  SwarmID: z.string().optional(),
});

export const zStacksStackResponse = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  CreatedBy: z.string().optional(),
  CreatedByUserId: z.string().optional(),
  CreationDate: z.int().optional(),
  CurrentDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  DeploymentStartStatus: zPortainerStackStatus.optional(),
  DeploymentStatus: z.array(zPortainerStackDeploymentStatus).optional(),
  EndpointId: z.int().optional(),
  EntryPoint: z.string().optional(),
  Env: z.array(zPortainerPair).optional(),
  FilesystemPath: z.string().optional(),
  FromAppTemplate: z.boolean().optional(),
  GitConfig: zGithubComPortainerPortainerEeApiGitTypesRepoConfig.optional(),
  GitSourceId: z.int().optional(),
  HelmChartPath: z.string().optional(),
  HelmValuesFiles: z.array(z.string()).optional(),
  Id: z.int().optional(),
  IsDetachedFromGit: z.boolean().optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Option: zPortainerStackOption.optional(),
  PreviousDeploymentInfo: zPortainerStackDeploymentInfo.optional(),
  ProjectPath: z.string().optional(),
  Registries: z.array(z.int()).optional(),
  ResourceControl: zPortainerResourceControl.optional(),
  StackFileVersion: z.int().optional(),
  Status: zPortainerStackStatus.optional(),
  SupportRelativePath: z.boolean().optional(),
  SwarmId: z.string().optional(),
  Type: zPortainerStackType.optional(),
  UpdateDate: z.int().optional(),
  UpdatedBy: z.string().optional(),
  Webhook: z.string().optional(),
  WorkflowID: z.int().optional(),
});

export const zStacksSwarmStackFromFileContentPayload = z.object({
  Env: z.array(zPortainerPair).optional(),
  FromAppTemplate: z.boolean().optional(),
  Name: z.string(),
  Registries: z.array(z.int()).optional(),
  StackFileContent: z.string(),
  SwarmID: z.string(),
  Webhook: z.string().optional(),
});

export const zStacksSwarmStackFromGitRepositoryPayload = z.object({
  AdditionalFiles: z.array(z.string()).optional(),
  AutoUpdate: zPortainerAutoUpdateSettings.optional(),
  ComposeFile: z.string().optional().default('docker-compose.yml'),
  Env: z.array(zPortainerPair).optional(),
  FilesystemPath: z.string().optional(),
  FromAppTemplate: z.boolean().optional(),
  Name: z.string(),
  Registries: z.array(z.int()).optional(),
  RepositoryAuthentication: z.boolean().optional(),
  RepositoryAuthorizationType:
    zGithubComPortainerPortainerEeApiGitTypesGitCredentialAuthType.optional(),
  RepositoryPassword: z.string().optional(),
  RepositoryProvider:
    zGithubComPortainerPortainerEeApiGitTypesGitProvider.optional(),
  RepositoryReferenceName: z.string().optional(),
  RepositoryURL: z.string().optional(),
  RepositoryUsername: z.string().optional(),
  SourceID: z.int().optional(),
  SupportRelativePath: z.boolean().optional(),
  SwarmID: z.string(),
  TLSSkipVerify: z.boolean().optional(),
});

export const zStacksUpdateStackPayload = z.object({
  Env: z.array(zPortainerPair).optional(),
  Prune: z.boolean().optional(),
  PullImage: z.boolean().optional(),
  Registries: z.array(z.int()).optional(),
  RepullImageAndRedeploy: z.boolean().optional(),
  RollbackTo: z.int().optional(),
  StackFileContent: z.string().optional(),
  Webhook: z.string().optional(),
});

export const zStatsContainerStats = z.object({
  healthy: z.int().optional(),
  running: z.int().optional(),
  stopped: z.int().optional(),
  total: z.int().optional(),
  unhealthy: z.int().optional(),
});

export const zDockerDashboardData = z.object({
  containers: zStatsContainerStats.optional(),
  images: zDockerImagesCounters.optional(),
  networks: z.int().optional(),
  services: z.int().optional(),
  stacks: z.int().optional(),
  volumes: z.int().optional(),
});

export const zSupportDebugLogPayload = z.object({
  debugLogEnabled: z.boolean().optional(),
});

export const zSwarmServiceUpdateResponse = z.object({
  Warnings: z.array(z.string()).optional(),
});

export const zTagsTagCreatePayload = z.object({
  Name: z.string(),
});

export const zTeammembershipsTeamMembershipCreatePayload = z.object({
  Role: z.union([z.literal(1), z.literal(2)]),
  TeamID: z.int(),
  UserID: z.int(),
});

export const zTeammembershipsTeamMembershipUpdatePayload = z.object({
  Role: z.union([z.literal(1), z.literal(2)]),
  TeamID: z.int(),
  UserID: z.int(),
});

export const zTeamsTeamCreatePayload = z.object({
  DenyPortainerAccess: z.boolean().optional(),
  Name: z.string(),
  TeamLeaders: z.array(z.int()).optional(),
});

export const zTeamsTeamUpdatePayload = z.object({
  DenyPortainerAccess: z.boolean().optional(),
  Name: z.string().optional(),
});

export const zTemplatesFileResponse = z.object({
  FileContent: z.string().optional(),
});

export const zTemplatesListResponse = z.object({
  templates: z.array(zPortainerTemplate).optional(),
  version: z.string().optional(),
});

export const zTypesEndpointUpdateScheduleRelation = z.object({
  edgeStackId: z.int().optional(),
  environmentId: z.int().optional(),
  scheduleId: z.int().optional(),
  targetVersion: z.string().optional(),
});

export const zTypesUpdateSchedule = z.object({
  agentImage: z.string().optional(),
  created: z.int().optional(),
  createdBy: z.int().optional(),
  edgeGroupIds: z.array(z.int()).optional(),
  edgeStackId: z.int().optional(),
  environmentsPreviousVersions: z.record(z.string(), z.string()).optional(),
  id: z.int().optional(),
  name: z.string().optional(),
  registryId: z.int().optional(),
  type: z.union([z.literal(1), z.literal(2)]).optional(),
  updated: z.int().optional(),
  updaterImage: z.string().optional(),
  version: z.string().optional(),
});

export const zTypesUpdateScheduleStatusType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
]);

export const zEdgeupdateschedulesDecoratedUpdateSchedule = z.object({
  agentImage: z.string().optional(),
  created: z.int().optional(),
  createdBy: z.int().optional(),
  edgeGroupIds: z.array(z.int()).optional(),
  edgeStackId: z.int().optional(),
  environmentsPreviousVersions: z.record(z.string(), z.string()).optional(),
  id: z.int().optional(),
  name: z.string().optional(),
  registryId: z.int().optional(),
  scheduledTime: z.string().optional(),
  status: zTypesUpdateScheduleStatusType.optional(),
  statusMessage: z.string().optional(),
  type: z.union([z.literal(1), z.literal(2)]).optional(),
  updated: z.int().optional(),
  updaterImage: z.string().optional(),
  version: z.string().optional(),
});

export const zTypesUpdateScheduleType = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
]);

export const zEdgeupdateschedulesCreatePayload = z.object({
  AgentImage: z.string().optional(),
  GroupIDs: z.array(z.int()).optional(),
  Name: z.string().optional(),
  RegistryID: z.int().optional(),
  ScheduledTime: z.string().optional(),
  Type: zTypesUpdateScheduleType.optional(),
  UpdaterImage: z.string().optional(),
});

export const zEdgeupdateschedulesUpdatePayload = z.object({
  AgentImage: z.string().optional(),
  GroupIDs: z.array(z.int()).optional(),
  Name: z.string().optional(),
  RegistryID: z.int().optional(),
  ScheduledTime: z.string().optional(),
  Type: zTypesUpdateScheduleType.optional(),
  UpdaterImage: z.string().optional(),
});

export const zUnstructuredUnstructured = z.object({
  Object: z.record(z.string(), z.unknown()).optional(),
});

export const zReleaseInfo = z.object({
  deleted: z.string().optional(),
  description: z.string().optional(),
  first_deployed: z.string().optional(),
  last_deployed: z.string().optional(),
  notes: z.string().optional(),
  resources: z.array(zUnstructuredUnstructured).optional(),
  status: z.string().optional(),
});

export const zReleaseRelease = z.object({
  appVersion: z.string().optional(),
  chart: zReleaseChart.optional(),
  chartReference: zReleaseChartReference.optional(),
  config: z.record(z.string(), z.unknown()).optional(),
  hooks: z.array(zGithubComPortainerPortainerPkgLibhelmReleaseHook).optional(),
  info: zReleaseInfo.optional(),
  manifest: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  stackID: z.int().optional(),
  values: zReleaseValues.optional(),
  version: z.int().optional(),
});

export const zUseractivityLogsListResponse = z.object({
  logs: z.array(zPortainereeUserActivityLog).optional(),
  totalCount: z.int().optional(),
});

export const zUsersAccessLocation = z.enum([
  'environment',
  'environmentGroup',
  'policy',
]);

export const zUsersCurrentUserEndpointAuthResponse = z.object({
  Authorizations: zPortainerAuthorizations.optional(),
});

export const zUsersCurrentUserEndpointNamespaceAuthResponse = z.object({
  namespaceAuthorizations: z
    .record(z.string(), zPortainerAuthorizations)
    .optional(),
});

export const zUsersCurrentUserInspectResponse = z.object({
  Id: z.int(),
  PortainerAccessDenied: z.boolean().optional(),
  PortainerAuthorizations: zPortainerAuthorizations.optional(),
  Role: zPortainerUserRole,
  ThemeSettings: zPortainereeUserThemeSettings.optional(),
  TokenIssueAt: z.int().optional(),
  UseCache: z.boolean().optional(),
  Username: z.string(),
  forceChangePassword: z.boolean().optional(),
});

export const zUsersEffectiveAccessEntry = z.object({
  accessLocation: zUsersAccessLocation.optional(),
  endpointId: z.int().optional(),
  endpointName: z.string().optional(),
  groupId: z.int().optional(),
  groupName: z.string().optional(),
  policyId: z.int().optional(),
  policyName: z.string().optional(),
  roleId: z.int().optional(),
  roleName: z.string().optional(),
  rolePriority: z.int().optional(),
  teamId: z.int().optional(),
  teamName: z.string().optional(),
});

export const zUsersUser = z.object({
  Id: z.int().optional(),
  Role: zPortainerUserRole.optional(),
  Username: z.string().optional(),
});

export const zUsersAccessTokenResponse = z.object({
  apiKey: zPortainerApiKey.optional(),
  rawAPIKey: z.string().optional(),
});

export const zUsersAddHelmRepoUrlPayload = z.object({
  url: z.string().optional(),
});

export const zUsersAdminInitPayload = z.object({
  Password: z.string(),
  Username: z.string(),
});

export const zUsersHelmUserRepositoryResponse = z.object({
  GlobalRepository: z.string().optional(),
  UserRepositories: z.array(zPortainerHelmUserRepository).optional(),
});

export const zUsersNamespaceMapping = z.record(
  z.string(),
  z.record(z.string(), zPortainerAuthorizations)
);

export const zUsersThemePayload = z.object({
  color: z.enum(['dark', 'light', 'highcontrast', 'auto']).optional(),
  subtleUpgradeButton: z.boolean().optional(),
});

export const zUsersUserAccessTokenCreatePayload = z.object({
  description: z.string(),
  password: z.string(),
});

export const zUsersUserCreatePayload = z.object({
  Password: z.string(),
  Role: z.union([z.literal(1), z.literal(2)]),
  Username: z.string(),
});

export const zUsersUserUpdatePasswordPayload = z.object({
  NewPassword: z.string(),
  Password: z.string(),
});

export const zUsersUserUpdatePayload = z.object({
  NewPassword: z.string(),
  Password: z.string(),
  Role: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  Theme: zUsersThemePayload.optional(),
  UseCache: z.boolean(),
  Username: z.string(),
});

export const zV1AwsElasticBlockStoreVolumeSource = z.object({
  fsType: z.string().optional(),
  partition: z.int().optional(),
  readOnly: z.boolean().optional(),
  volumeID: z.string().optional(),
});

export const zV1AppArmorProfileType = z.enum([
  'Unconfined',
  'RuntimeDefault',
  'Localhost',
]);

export const zV1AppArmorProfile = z.object({
  localhostProfile: z.string().optional(),
  type: zV1AppArmorProfileType.optional(),
});

export const zV1AttachedVolume = z.object({
  devicePath: z.string().optional(),
  name: z.string().optional(),
});

export const zV1AzureDataDiskCachingMode = z.enum([
  'None',
  'ReadOnly',
  'ReadWrite',
]);

export const zV1AzureDataDiskKind = z.enum(['Shared', 'Dedicated', 'Managed']);

export const zV1AzureDiskVolumeSource = z.object({
  cachingMode: zV1AzureDataDiskCachingMode.optional(),
  diskName: z.string().optional(),
  diskURI: z.string().optional(),
  fsType: z.string().optional(),
  kind: zV1AzureDataDiskKind.optional(),
  readOnly: z.boolean().optional(),
});

export const zV1AzureFileVolumeSource = z.object({
  readOnly: z.boolean().optional(),
  secretName: z.string().optional(),
  shareName: z.string().optional(),
});

export const zV1CsiVolumeSource = z.object({
  driver: z.string().optional(),
  fsType: z.string().optional(),
  nodePublishSecretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  readOnly: z.boolean().optional(),
  volumeAttributes: z.record(z.string(), z.string()).optional(),
});

export const zV1Capabilities = z.object({
  add: z.array(z.string()).optional(),
  drop: z.array(z.string()).optional(),
});

export const zV1CephFsVolumeSource = z.object({
  monitors: z.array(z.string()).optional(),
  path: z.string().optional(),
  readOnly: z.boolean().optional(),
  secretFile: z.string().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  user: z.string().optional(),
});

export const zV1CinderVolumeSource = z.object({
  fsType: z.string().optional(),
  readOnly: z.boolean().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  volumeID: z.string().optional(),
});

export const zV1ConfigMapEnvSource = z.object({
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1ConfigMapKeySelector = z.object({
  key: z.string().optional(),
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1ConfigMapNodeConfigSource = z.object({
  kubeletConfigKey: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  resourceVersion: z.string().optional(),
  uid: z.string().optional(),
});

export const zV1ContainerExtendedResourceRequest = z.object({
  containerName: z.string().optional(),
  requestName: z.string().optional(),
  resourceName: z.string().optional(),
});

export const zV1ContainerImage = z.object({
  names: z.array(z.string()).optional(),
  sizeBytes: z.int().optional(),
});

export const zV1ContainerRestartPolicy = z.enum([
  'Always',
  'Never',
  'OnFailure',
]);

export const zV1ContainerRestartRuleAction = z.enum([
  'Restart',
  'RestartAllContainers',
]);

export const zV1ContainerRestartRuleOnExitCodesOperator = z.enum([
  'In',
  'NotIn',
]);

export const zV1ContainerRestartRuleOnExitCodes = z.object({
  operator: zV1ContainerRestartRuleOnExitCodesOperator.optional(),
  values: z.array(z.int()).optional(),
});

export const zV1ContainerRestartRule = z.object({
  action: zV1ContainerRestartRuleAction.optional(),
  exitCodes: zV1ContainerRestartRuleOnExitCodes.optional(),
});

export const zV1ContainerStateRunning = z.object({
  startedAt: z.string().optional(),
});

export const zV1ContainerStateTerminated = z.object({
  containerID: z.string().optional(),
  exitCode: z.int().optional(),
  finishedAt: z.string().optional(),
  message: z.string().optional(),
  reason: z.string().optional(),
  signal: z.int().optional(),
  startedAt: z.string().optional(),
});

export const zV1ContainerStateWaiting = z.object({
  message: z.string().optional(),
  reason: z.string().optional(),
});

export const zV1ContainerState = z.object({
  running: zV1ContainerStateRunning.optional(),
  terminated: zV1ContainerStateTerminated.optional(),
  waiting: zV1ContainerStateWaiting.optional(),
});

export const zV1DnsPolicy = z.enum([
  'ClusterFirstWithHostNet',
  'ClusterFirst',
  'Default',
  'None',
]);

export const zV1DaemonEndpoint = z.object({
  Port: z.int().optional(),
});

export const zV1DeploymentStatus = z.object({
  availableReplicas: z.int().optional(),
  collisionCount: z.int().optional(),
  conditions: z.array(zK8sIoApiAppsV1DeploymentCondition).optional(),
  observedGeneration: z.int().optional(),
  readyReplicas: z.int().optional(),
  replicas: z.int().optional(),
  terminatingReplicas: z.int().optional(),
  unavailableReplicas: z.int().optional(),
  updatedReplicas: z.int().optional(),
});

export const zV1ExecAction = z.object({
  command: z.array(z.string()).optional(),
});

export const zV1FcVolumeSource = z.object({
  fsType: z.string().optional(),
  lun: z.int().optional(),
  readOnly: z.boolean().optional(),
  targetWWNs: z.array(z.string()).optional(),
  wwids: z.array(z.string()).optional(),
});

export const zV1FieldsV1 = z.record(z.string(), z.unknown());

export const zV1FileKeySelector = z.object({
  key: z.string().optional(),
  optional: z.boolean().optional(),
  path: z.string().optional(),
  volumeName: z.string().optional(),
});

export const zV1FinalizerName = z.enum(['kubernetes']);

export const zV1FlexVolumeSource = z.object({
  driver: z.string().optional(),
  fsType: z.string().optional(),
  options: z.record(z.string(), z.string()).optional(),
  readOnly: z.boolean().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
});

export const zV1FlockerVolumeSource = z.object({
  datasetName: z.string().optional(),
  datasetUUID: z.string().optional(),
});

export const zV1GcePersistentDiskVolumeSource = z.object({
  fsType: z.string().optional(),
  partition: z.int().optional(),
  pdName: z.string().optional(),
  readOnly: z.boolean().optional(),
});

export const zV1GrpcAction = z.object({
  port: z.int().optional(),
  service: z.string().optional(),
});

export const zV1GitRepoVolumeSource = z.object({
  directory: z.string().optional(),
  repository: z.string().optional(),
  revision: z.string().optional(),
});

export const zV1GlusterfsVolumeSource = z.object({
  endpoints: z.string().optional(),
  path: z.string().optional(),
  readOnly: z.boolean().optional(),
});

export const zV1HostAlias = z.object({
  hostnames: z.array(z.string()).optional(),
  ip: z.string().optional(),
});

export const zV1HostIp = z.object({
  ip: z.string().optional(),
});

export const zV1HostPathType = z.enum([
  '',
  'DirectoryOrCreate',
  'Directory',
  'FileOrCreate',
  'File',
  'Socket',
  'CharDevice',
  'BlockDevice',
]);

export const zV1HostPathVolumeSource = z.object({
  path: z.string().optional(),
  type: zV1HostPathType.optional(),
});

export const zV1IscsiVolumeSource = z.object({
  chapAuthDiscovery: z.boolean().optional(),
  chapAuthSession: z.boolean().optional(),
  fsType: z.string().optional(),
  initiatorName: z.string().optional(),
  iqn: z.string().optional(),
  iscsiInterface: z.string().optional(),
  lun: z.int().optional(),
  portals: z.array(z.string()).optional(),
  readOnly: z.boolean().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  targetPortal: z.string().optional(),
});

export const zV1KeyToPath = z.object({
  key: z.string().optional(),
  mode: z.int().optional(),
  path: z.string().optional(),
});

export const zV1ConfigMapProjection = z.object({
  items: z.array(zV1KeyToPath).optional(),
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1ConfigMapVolumeSource = z.object({
  defaultMode: z.int().optional(),
  items: z.array(zV1KeyToPath).optional(),
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1LabelSelectorOperator = z.enum([
  'In',
  'NotIn',
  'Exists',
  'DoesNotExist',
]);

export const zV1LabelSelectorRequirement = z.object({
  key: z.string().optional(),
  operator: zV1LabelSelectorOperator.optional(),
  values: z.array(z.string()).optional(),
});

export const zV1LabelSelector = z.object({
  matchExpressions: z.array(zV1LabelSelectorRequirement).optional(),
  matchLabels: z.record(z.string(), z.string()).optional(),
});

export const zV1ClusterTrustBundleProjection = z.object({
  labelSelector: zV1LabelSelector.optional(),
  name: z.string().optional(),
  optional: z.boolean().optional(),
  path: z.string().optional(),
  signerName: z.string().optional(),
});

export const zV1LinuxContainerUser = z.object({
  gid: z.int().optional(),
  supplementalGroups: z.array(z.int()).optional(),
  uid: z.int().optional(),
});

export const zV1ContainerUser = z.object({
  linux: zV1LinuxContainerUser.optional(),
});

export const zV1ListMeta = z.object({
  continue: z.string().optional(),
  remainingItemCount: z.int().optional(),
  resourceVersion: z.string().optional(),
  selfLink: z.string().optional(),
});

export const zV1ManagedFieldsOperationType = z.enum(['Apply', 'Update']);

export const zV1ManagedFieldsEntry = z.object({
  apiVersion: z.string().optional(),
  fieldsType: z.string().optional(),
  fieldsV1: zV1FieldsV1.optional(),
  manager: z.string().optional(),
  operation: zV1ManagedFieldsOperationType.optional(),
  subresource: z.string().optional(),
  time: z.string().optional(),
});

export const zV1MountPropagationMode = z.enum([
  'None',
  'HostToContainer',
  'Bidirectional',
]);

export const zV1NfsVolumeSource = z.object({
  path: z.string().optional(),
  readOnly: z.boolean().optional(),
  server: z.string().optional(),
});

export const zV1NamespaceConditionType = z.enum([
  'NamespaceDeletionDiscoveryFailure',
  'NamespaceDeletionContentFailure',
  'NamespaceDeletionGroupVersionParsingFailure',
  'NamespaceContentRemaining',
  'NamespaceFinalizersRemaining',
]);

export const zV1NamespaceCondition = z.object({
  lastTransitionTime: z.string().optional(),
  message: z.string().optional(),
  reason: z.string().optional(),
  status: zK8sIoApiCoreV1ConditionStatus.optional(),
  type: zV1NamespaceConditionType.optional(),
});

export const zV1NamespacePhase = z.enum(['Active', 'Terminating']);

export const zV1NamespaceSpec = z.object({
  finalizers: z.array(zV1FinalizerName).optional(),
});

export const zV1NamespaceStatus = z.object({
  conditions: z.array(zV1NamespaceCondition).optional(),
  phase: zV1NamespacePhase.optional(),
});

export const zV1NodeAddressType = z.enum([
  'Hostname',
  'InternalIP',
  'ExternalIP',
  'InternalDNS',
  'ExternalDNS',
]);

export const zV1NodeAddress = z.object({
  address: z.string().optional(),
  type: zV1NodeAddressType.optional(),
});

export const zV1NodeConditionType = z.enum([
  'Ready',
  'MemoryPressure',
  'DiskPressure',
  'PIDPressure',
  'NetworkUnavailable',
]);

export const zV1NodeCondition = z.object({
  lastHeartbeatTime: z.string().optional(),
  lastTransitionTime: z.string().optional(),
  message: z.string().optional(),
  reason: z.string().optional(),
  status: zK8sIoApiCoreV1ConditionStatus.optional(),
  type: zV1NodeConditionType.optional(),
});

export const zV1NodeConfigSource = z.object({
  configMap: zV1ConfigMapNodeConfigSource.optional(),
});

export const zV1NodeConfigStatus = z.object({
  active: zV1NodeConfigSource.optional(),
  assigned: zV1NodeConfigSource.optional(),
  error: z.string().optional(),
  lastKnownGood: zV1NodeConfigSource.optional(),
});

export const zV1NodeDaemonEndpoints = z.object({
  kubeletEndpoint: zV1DaemonEndpoint.optional(),
});

export const zV1NodeFeatures = z.object({
  supplementalGroupsPolicy: z.boolean().optional(),
});

export const zV1NodeInclusionPolicy = z.enum(['Ignore', 'Honor']);

export const zV1NodePhase = z.enum(['Pending', 'Running', 'Terminated']);

export const zV1NodeRuntimeHandlerFeatures = z.object({
  recursiveReadOnlyMounts: z.boolean().optional(),
  userNamespaces: z.boolean().optional(),
});

export const zV1NodeRuntimeHandler = z.object({
  features: zV1NodeRuntimeHandlerFeatures.optional(),
  name: z.string().optional(),
});

export const zV1NodeSelectorOperator = z.enum([
  'In',
  'NotIn',
  'Exists',
  'DoesNotExist',
  'Gt',
  'Lt',
]);

export const zV1NodeSelectorRequirement = z.object({
  key: z.string().optional(),
  operator: zV1NodeSelectorOperator.optional(),
  values: z.array(z.string()).optional(),
});

export const zV1NodeSelectorTerm = z.object({
  matchExpressions: z.array(zV1NodeSelectorRequirement).optional(),
  matchFields: z.array(zV1NodeSelectorRequirement).optional(),
});

export const zV1NodeSelector = z.object({
  nodeSelectorTerms: z.array(zV1NodeSelectorTerm).optional(),
});

export const zV1NodeSwapStatus = z.object({
  capacity: z.int().optional(),
});

export const zV1NodeSystemInfo = z.object({
  architecture: z.string().optional(),
  bootID: z.string().optional(),
  containerRuntimeVersion: z.string().optional(),
  kernelVersion: z.string().optional(),
  kubeProxyVersion: z.string().optional(),
  kubeletVersion: z.string().optional(),
  machineID: z.string().optional(),
  operatingSystem: z.string().optional(),
  osImage: z.string().optional(),
  swap: zV1NodeSwapStatus.optional(),
  systemUUID: z.string().optional(),
});

export const zV1OsName = z.enum(['linux', 'windows']);

export const zV1ObjectFieldSelector = z.object({
  apiVersion: z.string().optional(),
  fieldPath: z.string().optional(),
});

export const zV1OwnerReference = z.object({
  apiVersion: z.string().optional(),
  blockOwnerDeletion: z.boolean().optional(),
  controller: z.boolean().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  uid: z.string().optional(),
});

export const zV1ObjectMeta = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  creationTimestamp: z.string().optional(),
  deletionGracePeriodSeconds: z.int().optional(),
  deletionTimestamp: z.string().optional(),
  finalizers: z.array(z.string()).optional(),
  generateName: z.string().optional(),
  generation: z.int().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  managedFields: z.array(zV1ManagedFieldsEntry).optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  ownerReferences: z.array(zV1OwnerReference).optional(),
  resourceVersion: z.string().optional(),
  selfLink: z.string().optional(),
  uid: z.string().optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesCreateNamespaceResponse =
  z.object({
    apiVersion: z.string().optional(),
    kind: z.string().optional(),
    metadata: zV1ObjectMeta.optional(),
    spec: zV1NamespaceSpec.optional(),
    status: zV1NamespaceStatus.optional(),
  });

export const zV1PersistentVolumeAccessMode = z.enum([
  'ReadWriteOnce',
  'ReadOnlyMany',
  'ReadWriteMany',
  'ReadWriteOncePod',
]);

export const zV1PersistentVolumeClaimPhase = z.enum([
  'Pending',
  'Bound',
  'Lost',
]);

export const zV1PersistentVolumeClaimVolumeSource = z.object({
  claimName: z.string().optional(),
  readOnly: z.boolean().optional(),
});

export const zV1PersistentVolumeMode = z.enum(['Block', 'Filesystem']);

export const zKubernetesK8sPersistentVolumeClaimCreateRequest = z.object({
  accessModes: z.array(zV1PersistentVolumeAccessMode).optional(),
  annotations: z.record(z.string(), z.string()).optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  storage: z.string().optional(),
  storageClass: z.string().optional(),
  volumeMode: zV1PersistentVolumeMode.optional(),
});

export const zV1PersistentVolumePhase = z.enum([
  'Pending',
  'Available',
  'Bound',
  'Released',
  'Failed',
]);

export const zV1PersistentVolumeReclaimPolicy = z.enum([
  'Recycle',
  'Delete',
  'Retain',
]);

export const zKubernetesK8sStorageClass = z.object({
  allowVolumeExpansion: z.boolean().optional(),
  annotations: z.record(z.string(), z.string()).optional(),
  creationDate: z.string().optional(),
  isDefault: z.boolean().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  mountOptions: z.array(z.string()).optional(),
  name: z.string().optional(),
  parameters: z.record(z.string(), z.string()).optional(),
  provisioner: z.string().optional(),
  reclaimPolicy: zV1PersistentVolumeReclaimPolicy.optional(),
});

export const zModelsK8sPvReclaimPolicyRequest = z.object({
  name: z.string().optional(),
  reclaimPolicy: zV1PersistentVolumeReclaimPolicy.optional(),
});

export const zModelsK8sStorageClass = z.object({
  allowVolumeExpansion: z.boolean().optional(),
  annotations: z.record(z.string(), z.string()).optional(),
  creationDate: z.string().optional(),
  isDefault: z.boolean().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  mountOptions: z.array(z.string()).optional(),
  name: z.string().optional(),
  parameters: z.record(z.string(), z.string()).optional(),
  provisioner: z.string().optional(),
  reclaimPolicy: zV1PersistentVolumeReclaimPolicy.optional(),
});

export const zV1PhotonPersistentDiskVolumeSource = z.object({
  fsType: z.string().optional(),
  pdID: z.string().optional(),
});

export const zV1Platform = z.object({
  architecture: z.string().optional(),
  os: z.string().optional(),
  'os.features': z.array(z.string()).optional(),
  'os.version': z.string().optional(),
  variant: z.string().optional(),
});

export const zV1Descriptor = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  artifactType: z.string().optional(),
  data: z.array(z.int()).optional(),
  digest: z.string().optional(),
  mediaType: z.string().optional(),
  platform: zV1Platform.optional(),
  size: z.int().optional(),
  urls: z.array(z.string()).optional(),
});

export const zPortainerDockerContainerSnapshot = z.object({
  Command: z.string().optional(),
  Created: z.coerce
    .bigint()
    .min(BigInt('-9223372036854775808'), {
      error: 'Invalid value: Expected int64 to be >= -9223372036854775808',
    })
    .max(BigInt('9223372036854775807'), {
      error: 'Invalid value: Expected int64 to be <= 9223372036854775807',
    })
    .optional(),
  Env: z.array(z.string()).optional(),
  HostConfig: z
    .object({
      Annotations: z.record(z.string(), z.string()).optional(),
      NetworkMode: z.string().optional(),
    })
    .optional(),
  Id: z.string().optional(),
  Image: z.string().optional(),
  ImageID: z.string().optional(),
  ImageManifestDescriptor: zV1Descriptor.optional(),
  Labels: z.record(z.string(), z.string()).optional(),
  Mounts: z.array(zContainerMountPoint).optional(),
  Names: z.array(z.string()).optional(),
  NetworkSettings: zContainerNetworkSettingsSummary.optional(),
  Ports: z.array(zContainerPort).optional(),
  SizeRootFs: z.int().optional(),
  SizeRw: z.int().optional(),
  State: zContainerContainerState.optional(),
  Status: z.string().optional(),
});

export const zV1PodAffinityTerm = z.object({
  labelSelector: zV1LabelSelector.optional(),
  matchLabelKeys: z.array(z.string()).optional(),
  mismatchLabelKeys: z.array(z.string()).optional(),
  namespaceSelector: zV1LabelSelector.optional(),
  namespaces: z.array(z.string()).optional(),
  topologyKey: z.string().optional(),
});

export const zV1PodCertificateProjection = z.object({
  certificateChainPath: z.string().optional(),
  credentialBundlePath: z.string().optional(),
  keyPath: z.string().optional(),
  keyType: z.string().optional(),
  maxExpirationSeconds: z.int().optional(),
  signerName: z.string().optional(),
  userAnnotations: z.record(z.string(), z.string()).optional(),
});

export const zV1PodConditionType = z.enum([
  'ContainersReady',
  'Initialized',
  'Ready',
  'PodScheduled',
  'DisruptionTarget',
  'PodReadyToStartContainers',
  'PodResizePending',
  'PodResizeInProgress',
  'AllContainersRestarting',
]);

export const zV1PodCondition = z.object({
  lastProbeTime: z.string().optional(),
  lastTransitionTime: z.string().optional(),
  message: z.string().optional(),
  observedGeneration: z.int().optional(),
  reason: z.string().optional(),
  status: zK8sIoApiCoreV1ConditionStatus.optional(),
  type: zV1PodConditionType.optional(),
});

export const zV1PodDnsConfigOption = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
});

export const zV1PodDnsConfig = z.object({
  nameservers: z.array(z.string()).optional(),
  options: z.array(zV1PodDnsConfigOption).optional(),
  searches: z.array(z.string()).optional(),
});

export const zV1PodExtendedResourceClaimStatus = z.object({
  requestMappings: z.array(zV1ContainerExtendedResourceRequest).optional(),
  resourceClaimName: z.string().optional(),
});

export const zV1PodFsGroupChangePolicy = z.enum(['OnRootMismatch', 'Always']);

export const zV1PodIp = z.object({
  ip: z.string().optional(),
});

export const zV1PodOs = z.object({
  name: zV1OsName.optional(),
});

export const zV1PodPhase = z.enum([
  'Pending',
  'Running',
  'Succeeded',
  'Failed',
  'Unknown',
]);

export const zV1PodQosClass = z.enum(['Guaranteed', 'Burstable', 'BestEffort']);

export const zV1PodReadinessGate = z.object({
  conditionType: zV1PodConditionType.optional(),
});

export const zV1PodResizeStatus = z.enum([
  'InProgress',
  'Deferred',
  'Infeasible',
]);

export const zV1PodResourceClaim = z.object({
  name: z.string().optional(),
  resourceClaimName: z.string().optional(),
  resourceClaimTemplateName: z.string().optional(),
});

export const zV1PodResourceClaimStatus = z.object({
  name: z.string().optional(),
  resourceClaimName: z.string().optional(),
});

export const zV1PodSeLinuxChangePolicy = z.enum(['Recursive', 'MountOption']);

export const zV1PodSchedulingGate = z.object({
  name: z.string().optional(),
});

export const zV1PolicyRule = z.object({
  apiGroups: z.array(z.string()).optional(),
  nonResourceURLs: z.array(z.string()).optional(),
  resourceNames: z.array(z.string()).optional(),
  resources: z.array(z.string()).optional(),
  verbs: z.array(z.string()).optional(),
});

export const zModelsK8sRole = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  creationDate: z.string().optional(),
  isSystem: z.boolean().optional(),
  isUnused: z.boolean().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  resourceVersion: z.string().optional(),
  rules: z.array(zV1PolicyRule).optional(),
  uid: z.string().optional(),
});

export const zV1PortworxVolumeSource = z.object({
  fsType: z.string().optional(),
  readOnly: z.boolean().optional(),
  volumeID: z.string().optional(),
});

export const zV1PreemptionPolicy = z.enum(['PreemptLowerPriority', 'Never']);

export const zV1PreferredSchedulingTerm = z.object({
  preference: zV1NodeSelectorTerm.optional(),
  weight: z.int().optional(),
});

export const zV1NodeAffinity = z.object({
  preferredDuringSchedulingIgnoredDuringExecution: z
    .array(zV1PreferredSchedulingTerm)
    .optional(),
  requiredDuringSchedulingIgnoredDuringExecution: zV1NodeSelector.optional(),
});

export const zV1ProcMountType = z.enum(['Default', 'Unmasked']);

export const zV1Protocol = z.enum(['TCP', 'UDP', 'SCTP']);

export const zV1ContainerPort = z.object({
  containerPort: z.int().optional(),
  hostIP: z.string().optional(),
  hostPort: z.int().optional(),
  name: z.string().optional(),
  protocol: zV1Protocol.optional(),
});

export const zV1PullPolicy = z.enum(['Always', 'Never', 'IfNotPresent']);

export const zV1ImageVolumeSource = z.object({
  pullPolicy: zV1PullPolicy.optional(),
  reference: z.string().optional(),
});

export const zV1QuobyteVolumeSource = z.object({
  group: z.string().optional(),
  readOnly: z.boolean().optional(),
  registry: z.string().optional(),
  tenant: z.string().optional(),
  user: z.string().optional(),
  volume: z.string().optional(),
});

export const zV1RbdVolumeSource = z.object({
  fsType: z.string().optional(),
  image: z.string().optional(),
  keyring: z.string().optional(),
  monitors: z.array(z.string()).optional(),
  pool: z.string().optional(),
  readOnly: z.boolean().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  user: z.string().optional(),
});

export const zV1RecursiveReadOnlyMode = z.enum([
  'Disabled',
  'IfPossible',
  'Enabled',
]);

export const zV1ReplicaSetConditionType = z.enum(['ReplicaFailure']);

export const zV1ReplicaSetCondition = z.object({
  lastTransitionTime: z.string().optional(),
  message: z.string().optional(),
  reason: z.string().optional(),
  status: zK8sIoApiCoreV1ConditionStatus.optional(),
  type: zV1ReplicaSetConditionType.optional(),
});

export const zV1ReplicaSetStatus = z.object({
  availableReplicas: z.int().optional(),
  conditions: z.array(zV1ReplicaSetCondition).optional(),
  fullyLabeledReplicas: z.int().optional(),
  observedGeneration: z.int().optional(),
  readyReplicas: z.int().optional(),
  replicas: z.int().optional(),
  terminatingReplicas: z.int().optional(),
});

export const zV1ResourceFieldSelector = z.object({
  containerName: z.string().optional(),
  divisor: zResourceQuantity.optional(),
  resource: z.string().optional(),
});

export const zV1DownwardApiVolumeFile = z.object({
  fieldRef: zV1ObjectFieldSelector.optional(),
  mode: z.int().optional(),
  path: z.string().optional(),
  resourceFieldRef: zV1ResourceFieldSelector.optional(),
});

export const zV1DownwardApiProjection = z.object({
  items: z.array(zV1DownwardApiVolumeFile).optional(),
});

export const zV1DownwardApiVolumeSource = z.object({
  defaultMode: z.int().optional(),
  items: z.array(zV1DownwardApiVolumeFile).optional(),
});

export const zV1ResourceHealthStatus = z.enum([
  'Healthy',
  'Unhealthy',
  'Unknown',
]);

export const zV1ResourceHealth = z.object({
  health: zV1ResourceHealthStatus.optional(),
  resourceID: z.string().optional(),
});

export const zV1ResourceList = z.record(z.string(), zResourceQuantity);

export const zKubernetesK8sPersistentVolumeClaim = z.object({
  accessModes: z.array(z.string()).optional(),
  allowVolumeExpansion: z.boolean().optional(),
  creationDate: z.string().optional(),
  humanReadableAccessModes: z.array(zV1PersistentVolumeAccessMode).optional(),
  id: z.string().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  owningApplications: z.array(zKubernetesK8sApplication).optional(),
  phase: zV1PersistentVolumeClaimPhase.optional(),
  resourcesRequests: zV1ResourceList.optional(),
  storage: z.int().optional(),
  storageClass: z.string().optional(),
  storageRequest: z.string().optional(),
  volumeMode: zV1PersistentVolumeMode.optional(),
  volumeName: z.string().optional(),
});

export const zModelsK8sPersistentVolumeClaim = z.object({
  accessModes: z.array(z.string()).optional(),
  creationDate: z.string().optional(),
  humanReadableAccessModes: z.array(zV1PersistentVolumeAccessMode).optional(),
  id: z.string().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  owningApplications: z.array(zModelsK8sApplication).optional(),
  phase: zV1PersistentVolumeClaimPhase.optional(),
  resourcesRequests: zV1ResourceList.optional(),
  storage: z.int().optional(),
  storageClass: z.string().optional(),
  storageRequest: z.string().optional(),
  volumeMode: zV1PersistentVolumeMode.optional(),
  volumeName: z.string().optional(),
});

export const zV1NodeStatus = z.object({
  addresses: z.array(zV1NodeAddress).optional(),
  allocatable: zV1ResourceList.optional(),
  capacity: zV1ResourceList.optional(),
  conditions: z.array(zV1NodeCondition).optional(),
  config: zV1NodeConfigStatus.optional(),
  daemonEndpoints: zV1NodeDaemonEndpoints.optional(),
  declaredFeatures: z.array(z.string()).optional(),
  features: zV1NodeFeatures.optional(),
  images: z.array(zV1ContainerImage).optional(),
  nodeInfo: zV1NodeSystemInfo.optional(),
  phase: zV1NodePhase.optional(),
  runtimeHandlers: z.array(zV1NodeRuntimeHandler).optional(),
  volumesAttached: z.array(zV1AttachedVolume).optional(),
  volumesInUse: z.array(z.string()).optional(),
});

export const zV1ResourceName = z.enum([
  'cpu',
  'memory',
  'storage',
  'ephemeral-storage',
  'pods',
  'services',
  'replicationcontrollers',
  'resourcequotas',
  'secrets',
  'configmaps',
  'persistentvolumeclaims',
  'services.nodeports',
  'services.loadbalancers',
  'requests.cpu',
  'requests.memory',
  'requests.storage',
  'requests.ephemeral-storage',
  'limits.cpu',
  'limits.memory',
  'limits.ephemeral-storage',
]);

export const zV1ResourceQuotaScope = z.enum([
  'Terminating',
  'NotTerminating',
  'BestEffort',
  'NotBestEffort',
  'PriorityClass',
  'CrossNamespacePodAffinity',
  'VolumeAttributesClass',
]);

export const zV1ResourceQuotaStatus = z.object({
  hard: zV1ResourceList.optional(),
  used: zV1ResourceList.optional(),
});

export const zV1ResourceRequirements = z.object({
  claims: z.array(zK8sIoApiCoreV1ResourceClaim).optional(),
  limits: zV1ResourceList.optional(),
  requests: zV1ResourceList.optional(),
});

export const zV1ResourceResizeRestartPolicy = z.enum([
  'NotRequired',
  'RestartContainer',
]);

export const zV1ContainerResizePolicy = z.object({
  resourceName: zV1ResourceName.optional(),
  restartPolicy: zV1ResourceResizeRestartPolicy.optional(),
});

export const zV1ResourceStatus = z.object({
  name: zV1ResourceName.optional(),
  resources: z.array(zV1ResourceHealth).optional(),
});

export const zV1RestartPolicy = z.enum(['Always', 'OnFailure', 'Never']);

export const zV1RoleRef = z.object({
  apiGroup: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
});

export const zKubernetesK8sClusterRoleBinding = z.object({
  creationDate: z.string().optional(),
  isSystem: z.boolean().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  roleRef: zV1RoleRef.optional(),
  subjects: z.array(zK8sIoApiRbacV1Subject).optional(),
  uid: z.string().optional(),
});

export const zModelsK8sRoleBinding = z.object({
  annotations: z.record(z.string(), z.string()).optional(),
  creationDate: z.string().optional(),
  isSystem: z.boolean().optional(),
  isUnused: z.boolean().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
  resourceVersion: z.string().optional(),
  roleRef: zV1RoleRef.optional(),
  subjects: z.array(zK8sIoApiRbacV1Subject).optional(),
  uid: z.string().optional(),
});

export const zV1RollingUpdateDeployment = z.object({
  maxSurge: zIntstrIntOrString.optional(),
  maxUnavailable: zIntstrIntOrString.optional(),
});

export const zK8sIoApiAppsV1DeploymentStrategy = z.object({
  rollingUpdate: zV1RollingUpdateDeployment.optional(),
  type: zK8sIoApiAppsV1DeploymentStrategyType.optional(),
});

export const zV1SeLinuxOptions = z.object({
  level: z.string().optional(),
  role: z.string().optional(),
  type: z.string().optional(),
  user: z.string().optional(),
});

export const zV1ScaleIoVolumeSource = z.object({
  fsType: z.string().optional(),
  gateway: z.string().optional(),
  protectionDomain: z.string().optional(),
  readOnly: z.boolean().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  sslEnabled: z.boolean().optional(),
  storageMode: z.string().optional(),
  storagePool: z.string().optional(),
  system: z.string().optional(),
  volumeName: z.string().optional(),
});

export const zV1ScopeSelectorOperator = z.enum([
  'In',
  'NotIn',
  'Exists',
  'DoesNotExist',
]);

export const zV1ScopedResourceSelectorRequirement = z.object({
  operator: zV1ScopeSelectorOperator.optional(),
  scopeName: zV1ResourceQuotaScope.optional(),
  values: z.array(z.string()).optional(),
});

export const zV1ScopeSelector = z.object({
  matchExpressions: z.array(zV1ScopedResourceSelectorRequirement).optional(),
});

export const zV1ResourceQuotaSpec = z.object({
  hard: zV1ResourceList.optional(),
  scopeSelector: zV1ScopeSelector.optional(),
  scopes: z.array(zV1ResourceQuotaScope).optional(),
});

export const zV1ResourceQuota = z.object({
  apiVersion: z.string().optional(),
  kind: z.string().optional(),
  metadata: zV1ObjectMeta.optional(),
  spec: zV1ResourceQuotaSpec.optional(),
  status: zV1ResourceQuotaStatus.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesResourceQuotaListResponse =
  z.object({
    apiVersion: z.string().optional(),
    items: z.array(zV1ResourceQuota).optional(),
    kind: z.string().optional(),
    metadata: zV1ListMeta.optional(),
  });

export const zPortainerK8sNamespaceInfo = z.object({
  Annotations: z.record(z.string(), z.string()).optional(),
  CreationDate: z.string().optional(),
  Id: z.string().optional(),
  IsDefault: z.boolean().optional(),
  IsSystem: z.boolean().optional(),
  Name: z.string().optional(),
  NamespaceOwner: z.string().optional(),
  ResourceQuota: zV1ResourceQuota.optional(),
  Status: zV1NamespaceStatus.optional(),
  UnhealthyEventCount: z.int().optional(),
});

export const zV1SeccompProfileType = z.enum([
  'Unconfined',
  'RuntimeDefault',
  'Localhost',
]);

export const zV1SeccompProfile = z.object({
  localhostProfile: z.string().optional(),
  type: zV1SeccompProfileType.optional(),
});

export const zV1SecretEnvSource = z.object({
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1EnvFromSource = z.object({
  configMapRef: zV1ConfigMapEnvSource.optional(),
  prefix: z.string().optional(),
  secretRef: zV1SecretEnvSource.optional(),
});

export const zV1SecretKeySelector = z.object({
  key: z.string().optional(),
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1EnvVarSource = z.object({
  configMapKeyRef: zV1ConfigMapKeySelector.optional(),
  fieldRef: zV1ObjectFieldSelector.optional(),
  fileKeyRef: zV1FileKeySelector.optional(),
  resourceFieldRef: zV1ResourceFieldSelector.optional(),
  secretKeyRef: zV1SecretKeySelector.optional(),
});

export const zV1EnvVar = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
  valueFrom: zV1EnvVarSource.optional(),
});

export const zV1SecretProjection = z.object({
  items: z.array(zV1KeyToPath).optional(),
  name: z.string().optional(),
  optional: z.boolean().optional(),
});

export const zV1SecretReference = z.object({
  name: z.string().optional(),
  namespace: z.string().optional(),
});

export const zV1CsiPersistentVolumeSource = z.object({
  controllerExpandSecretRef: zV1SecretReference.optional(),
  controllerPublishSecretRef: zV1SecretReference.optional(),
  driver: z.string().optional(),
  fsType: z.string().optional(),
  nodeExpandSecretRef: zV1SecretReference.optional(),
  nodePublishSecretRef: zV1SecretReference.optional(),
  nodeStageSecretRef: zV1SecretReference.optional(),
  readOnly: z.boolean().optional(),
  volumeAttributes: z.record(z.string(), z.string()).optional(),
  volumeHandle: z.string().optional(),
});

export const zKubernetesK8sPersistentVolume = z.object({
  accessModes: z.array(z.string()).optional(),
  annotations: z.record(z.string(), z.string()).optional(),
  capacity: zV1ResourceList.optional(),
  claimRef: zK8sIoApiCoreV1ObjectReference.optional(),
  creationDate: z.string().optional(),
  csi: zV1CsiPersistentVolumeSource.optional(),
  humanReadableAccessModes: z.array(zV1PersistentVolumeAccessMode).optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  persistentVolumeReclaimPolicy: zV1PersistentVolumeReclaimPolicy.optional(),
  status: zV1PersistentVolumePhase.optional(),
  storageClassName: z.string().optional(),
  volumeMode: zV1PersistentVolumeMode.optional(),
});

export const zKubernetesK8sVolumeInfo = z.object({
  persistentVolume: zKubernetesK8sPersistentVolume.optional(),
  persistentVolumeClaim: zKubernetesK8sPersistentVolumeClaim.optional(),
  storageClass: zKubernetesK8sStorageClass.optional(),
});

export const zModelsK8sPersistentVolume = z.object({
  accessModes: z.array(z.string()).optional(),
  annotations: z.record(z.string(), z.string()).optional(),
  capacity: zV1ResourceList.optional(),
  claimRef: zK8sIoApiCoreV1ObjectReference.optional(),
  creationDate: z.string().optional(),
  csi: zV1CsiPersistentVolumeSource.optional(),
  humanReadableAccessModes: z.array(zV1PersistentVolumeAccessMode).optional(),
  labels: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  persistentVolumeReclaimPolicy: zV1PersistentVolumeReclaimPolicy.optional(),
  status: zV1PersistentVolumePhase.optional(),
  storageClassName: z.string().optional(),
  volumeMode: zV1PersistentVolumeMode.optional(),
});

export const zV1SecretVolumeSource = z.object({
  defaultMode: z.int().optional(),
  items: z.array(zV1KeyToPath).optional(),
  optional: z.boolean().optional(),
  secretName: z.string().optional(),
});

export const zV1ServiceAccountTokenProjection = z.object({
  audience: z.string().optional(),
  expirationSeconds: z.int().optional(),
  path: z.string().optional(),
});

export const zV1Signal = z.enum([
  'SIGABRT',
  'SIGALRM',
  'SIGBUS',
  'SIGCHLD',
  'SIGCLD',
  'SIGCONT',
  'SIGFPE',
  'SIGHUP',
  'SIGILL',
  'SIGINT',
  'SIGIO',
  'SIGIOT',
  'SIGKILL',
  'SIGPIPE',
  'SIGPOLL',
  'SIGPROF',
  'SIGPWR',
  'SIGQUIT',
  'SIGSEGV',
  'SIGSTKFLT',
  'SIGSTOP',
  'SIGSYS',
  'SIGTERM',
  'SIGTRAP',
  'SIGTSTP',
  'SIGTTIN',
  'SIGTTOU',
  'SIGURG',
  'SIGUSR1',
  'SIGUSR2',
  'SIGVTALRM',
  'SIGWINCH',
  'SIGXCPU',
  'SIGXFSZ',
  'SIGRTMIN',
  'SIGRTMIN+1',
  'SIGRTMIN+2',
  'SIGRTMIN+3',
  'SIGRTMIN+4',
  'SIGRTMIN+5',
  'SIGRTMIN+6',
  'SIGRTMIN+7',
  'SIGRTMIN+8',
  'SIGRTMIN+9',
  'SIGRTMIN+10',
  'SIGRTMIN+11',
  'SIGRTMIN+12',
  'SIGRTMIN+13',
  'SIGRTMIN+14',
  'SIGRTMIN+15',
  'SIGRTMAX-14',
  'SIGRTMAX-13',
  'SIGRTMAX-12',
  'SIGRTMAX-11',
  'SIGRTMAX-10',
  'SIGRTMAX-9',
  'SIGRTMAX-8',
  'SIGRTMAX-7',
  'SIGRTMAX-6',
  'SIGRTMAX-5',
  'SIGRTMAX-4',
  'SIGRTMAX-3',
  'SIGRTMAX-2',
  'SIGRTMAX-1',
  'SIGRTMAX',
]);

export const zV1SleepAction = z.object({
  seconds: z.int().optional(),
});

export const zV1StorageMedium = z.enum([
  '',
  'Memory',
  'HugePages',
  'HugePages-',
]);

export const zV1EmptyDirVolumeSource = z.object({
  medium: zV1StorageMedium.optional(),
  sizeLimit: zResourceQuantity.optional(),
});

export const zV1StorageOsVolumeSource = z.object({
  fsType: z.string().optional(),
  readOnly: z.boolean().optional(),
  secretRef: zK8sIoApiCoreV1LocalObjectReference.optional(),
  volumeName: z.string().optional(),
  volumeNamespace: z.string().optional(),
});

export const zV1SupplementalGroupsPolicy = z.enum(['Merge', 'Strict']);

export const zV1Sysctl = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
});

export const zV1TcpSocketAction = z.object({
  host: z.string().optional(),
  port: zIntstrIntOrString.optional(),
});

export const zV1TaintEffect = z.enum([
  'NoSchedule',
  'PreferNoSchedule',
  'NoExecute',
]);

export const zV1Taint = z.object({
  effect: zV1TaintEffect.optional(),
  key: z.string().optional(),
  timeAdded: z.string().optional(),
  value: z.string().optional(),
});

export const zV1NodeSpec = z.object({
  configSource: zV1NodeConfigSource.optional(),
  externalID: z.string().optional(),
  podCIDR: z.string().optional(),
  podCIDRs: z.array(z.string()).optional(),
  providerID: z.string().optional(),
  taints: z.array(zV1Taint).optional(),
  unschedulable: z.boolean().optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesNodeResponse =
  z.object({
    apiVersion: z.string().optional(),
    kind: z.string().optional(),
    metadata: zV1ObjectMeta.optional(),
    spec: zV1NodeSpec.optional(),
    status: zV1NodeStatus.optional(),
  });

export const zV1TerminationMessagePolicy = z.enum([
  'File',
  'FallbackToLogsOnError',
]);

export const zV1TolerationOperator = z.enum(['Exists', 'Equal', 'Lt', 'Gt']);

export const zV1Toleration = z.object({
  effect: zV1TaintEffect.optional(),
  key: z.string().optional(),
  operator: zV1TolerationOperator.optional(),
  tolerationSeconds: z.int().optional(),
  value: z.string().optional(),
});

export const zV1TypedLocalObjectReference = z.object({
  apiGroup: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
});

export const zV1TypedObjectReference = z.object({
  apiGroup: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  namespace: z.string().optional(),
});

export const zV1UriScheme = z.enum(['HTTP', 'HTTPS']);

export const zV1HttpGetAction = z.object({
  host: z.string().optional(),
  httpHeaders: z.array(zK8sIoApiCoreV1HttpHeader).optional(),
  path: z.string().optional(),
  port: zIntstrIntOrString.optional(),
  scheme: zV1UriScheme.optional(),
});

export const zV1LifecycleHandler = z.object({
  exec: zV1ExecAction.optional(),
  httpGet: zV1HttpGetAction.optional(),
  sleep: zV1SleepAction.optional(),
  tcpSocket: zV1TcpSocketAction.optional(),
});

export const zV1Lifecycle = z.object({
  postStart: zV1LifecycleHandler.optional(),
  preStop: zV1LifecycleHandler.optional(),
  stopSignal: zV1Signal.optional(),
});

export const zV1Probe = z.object({
  exec: zV1ExecAction.optional(),
  failureThreshold: z.int().optional(),
  grpc: zV1GrpcAction.optional(),
  httpGet: zV1HttpGetAction.optional(),
  initialDelaySeconds: z.int().optional(),
  periodSeconds: z.int().optional(),
  successThreshold: z.int().optional(),
  tcpSocket: zV1TcpSocketAction.optional(),
  terminationGracePeriodSeconds: z.int().optional(),
  timeoutSeconds: z.int().optional(),
});

export const zV1UnsatisfiableConstraintAction = z.enum([
  'DoNotSchedule',
  'ScheduleAnyway',
]);

export const zV1TopologySpreadConstraint = z.object({
  labelSelector: zV1LabelSelector.optional(),
  matchLabelKeys: z.array(z.string()).optional(),
  maxSkew: z.int().optional(),
  minDomains: z.int().optional(),
  nodeAffinityPolicy: zV1NodeInclusionPolicy.optional(),
  nodeTaintsPolicy: zV1NodeInclusionPolicy.optional(),
  topologyKey: z.string().optional(),
  whenUnsatisfiable: zV1UnsatisfiableConstraintAction.optional(),
});

export const zV1VolumeDevice = z.object({
  devicePath: z.string().optional(),
  name: z.string().optional(),
});

export const zV1VolumeMount = z.object({
  mountPath: z.string().optional(),
  mountPropagation: zV1MountPropagationMode.optional(),
  name: z.string().optional(),
  readOnly: z.boolean().optional(),
  recursiveReadOnly: zV1RecursiveReadOnlyMode.optional(),
  subPath: z.string().optional(),
  subPathExpr: z.string().optional(),
});

export const zV1VolumeMountStatus = z.object({
  mountPath: z.string().optional(),
  name: z.string().optional(),
  readOnly: z.boolean().optional(),
  recursiveReadOnly: zV1RecursiveReadOnlyMode.optional(),
});

export const zV1ContainerStatus = z.object({
  allocatedResources: zV1ResourceList.optional(),
  allocatedResourcesStatus: z.array(zV1ResourceStatus).optional(),
  containerID: z.string().optional(),
  image: z.string().optional(),
  imageID: z.string().optional(),
  lastState: zV1ContainerState.optional(),
  name: z.string().optional(),
  ready: z.boolean().optional(),
  resources: zV1ResourceRequirements.optional(),
  restartCount: z.int().optional(),
  started: z.boolean().optional(),
  state: zV1ContainerState.optional(),
  stopSignal: zV1Signal.optional(),
  user: zV1ContainerUser.optional(),
  volumeMounts: z.array(zV1VolumeMountStatus).optional(),
});

export const zV1PodStatus = z.object({
  allocatedResources: zV1ResourceList.optional(),
  conditions: z.array(zV1PodCondition).optional(),
  containerStatuses: z.array(zV1ContainerStatus).optional(),
  ephemeralContainerStatuses: z.array(zV1ContainerStatus).optional(),
  extendedResourceClaimStatus: zV1PodExtendedResourceClaimStatus.optional(),
  hostIP: z.string().optional(),
  hostIPs: z.array(zV1HostIp).optional(),
  initContainerStatuses: z.array(zV1ContainerStatus).optional(),
  message: z.string().optional(),
  nominatedNodeName: z.string().optional(),
  observedGeneration: z.int().optional(),
  phase: zV1PodPhase.optional(),
  podIP: z.string().optional(),
  podIPs: z.array(zV1PodIp).optional(),
  qosClass: zV1PodQosClass.optional(),
  reason: z.string().optional(),
  resize: zV1PodResizeStatus.optional(),
  resourceClaimStatuses: z.array(zV1PodResourceClaimStatus).optional(),
  resources: zV1ResourceRequirements.optional(),
  startTime: z.string().optional(),
});

export const zV1VolumeProjection = z.object({
  clusterTrustBundle: zV1ClusterTrustBundleProjection.optional(),
  configMap: zV1ConfigMapProjection.optional(),
  downwardAPI: zV1DownwardApiProjection.optional(),
  podCertificate: zV1PodCertificateProjection.optional(),
  secret: zV1SecretProjection.optional(),
  serviceAccountToken: zV1ServiceAccountTokenProjection.optional(),
});

export const zV1ProjectedVolumeSource = z.object({
  defaultMode: z.int().optional(),
  sources: z.array(zV1VolumeProjection).optional(),
});

export const zV1VolumeResourceRequirements = z.object({
  limits: zV1ResourceList.optional(),
  requests: zV1ResourceList.optional(),
});

export const zV1PersistentVolumeClaimSpec = z.object({
  accessModes: z.array(zV1PersistentVolumeAccessMode).optional(),
  dataSource: zV1TypedLocalObjectReference.optional(),
  dataSourceRef: zV1TypedObjectReference.optional(),
  resources: zV1VolumeResourceRequirements.optional(),
  selector: zV1LabelSelector.optional(),
  storageClassName: z.string().optional(),
  volumeAttributesClassName: z.string().optional(),
  volumeMode: zV1PersistentVolumeMode.optional(),
  volumeName: z.string().optional(),
});

export const zV1PersistentVolumeClaimTemplate = z.object({
  metadata: zV1ObjectMeta.optional(),
  spec: zV1PersistentVolumeClaimSpec.optional(),
});

export const zV1EphemeralVolumeSource = z.object({
  volumeClaimTemplate: zV1PersistentVolumeClaimTemplate.optional(),
});

export const zV1VsphereVirtualDiskVolumeSource = z.object({
  fsType: z.string().optional(),
  storagePolicyID: z.string().optional(),
  storagePolicyName: z.string().optional(),
  volumePath: z.string().optional(),
});

export const zV1Volume = z.object({
  awsElasticBlockStore: zV1AwsElasticBlockStoreVolumeSource.optional(),
  azureDisk: zV1AzureDiskVolumeSource.optional(),
  azureFile: zV1AzureFileVolumeSource.optional(),
  cephfs: zV1CephFsVolumeSource.optional(),
  cinder: zV1CinderVolumeSource.optional(),
  configMap: zV1ConfigMapVolumeSource.optional(),
  csi: zV1CsiVolumeSource.optional(),
  downwardAPI: zV1DownwardApiVolumeSource.optional(),
  emptyDir: zV1EmptyDirVolumeSource.optional(),
  ephemeral: zV1EphemeralVolumeSource.optional(),
  fc: zV1FcVolumeSource.optional(),
  flexVolume: zV1FlexVolumeSource.optional(),
  flocker: zV1FlockerVolumeSource.optional(),
  gcePersistentDisk: zV1GcePersistentDiskVolumeSource.optional(),
  gitRepo: zV1GitRepoVolumeSource.optional(),
  glusterfs: zV1GlusterfsVolumeSource.optional(),
  hostPath: zV1HostPathVolumeSource.optional(),
  image: zV1ImageVolumeSource.optional(),
  iscsi: zV1IscsiVolumeSource.optional(),
  name: z.string().optional(),
  nfs: zV1NfsVolumeSource.optional(),
  persistentVolumeClaim: zV1PersistentVolumeClaimVolumeSource.optional(),
  photonPersistentDisk: zV1PhotonPersistentDiskVolumeSource.optional(),
  portworxVolume: zV1PortworxVolumeSource.optional(),
  projected: zV1ProjectedVolumeSource.optional(),
  quobyte: zV1QuobyteVolumeSource.optional(),
  rbd: zV1RbdVolumeSource.optional(),
  scaleIO: zV1ScaleIoVolumeSource.optional(),
  secret: zV1SecretVolumeSource.optional(),
  storageos: zV1StorageOsVolumeSource.optional(),
  vsphereVolume: zV1VsphereVirtualDiskVolumeSource.optional(),
});

export const zV1WeightedPodAffinityTerm = z.object({
  podAffinityTerm: zV1PodAffinityTerm.optional(),
  weight: z.int().optional(),
});

export const zV1PodAffinity = z.object({
  preferredDuringSchedulingIgnoredDuringExecution: z
    .array(zV1WeightedPodAffinityTerm)
    .optional(),
  requiredDuringSchedulingIgnoredDuringExecution: z
    .array(zV1PodAffinityTerm)
    .optional(),
});

export const zV1PodAntiAffinity = z.object({
  preferredDuringSchedulingIgnoredDuringExecution: z
    .array(zV1WeightedPodAffinityTerm)
    .optional(),
  requiredDuringSchedulingIgnoredDuringExecution: z
    .array(zV1PodAffinityTerm)
    .optional(),
});

export const zV1Affinity = z.object({
  nodeAffinity: zV1NodeAffinity.optional(),
  podAffinity: zV1PodAffinity.optional(),
  podAntiAffinity: zV1PodAntiAffinity.optional(),
});

export const zV1WindowsSecurityContextOptions = z.object({
  gmsaCredentialSpec: z.string().optional(),
  gmsaCredentialSpecName: z.string().optional(),
  hostProcess: z.boolean().optional(),
  runAsUserName: z.string().optional(),
});

export const zV1PodSecurityContext = z.object({
  appArmorProfile: zV1AppArmorProfile.optional(),
  fsGroup: z.int().optional(),
  fsGroupChangePolicy: zV1PodFsGroupChangePolicy.optional(),
  runAsGroup: z.int().optional(),
  runAsNonRoot: z.boolean().optional(),
  runAsUser: z.int().optional(),
  seLinuxChangePolicy: zV1PodSeLinuxChangePolicy.optional(),
  seLinuxOptions: zV1SeLinuxOptions.optional(),
  seccompProfile: zV1SeccompProfile.optional(),
  supplementalGroups: z.array(z.int()).optional(),
  supplementalGroupsPolicy: zV1SupplementalGroupsPolicy.optional(),
  sysctls: z.array(zV1Sysctl).optional(),
  windowsOptions: zV1WindowsSecurityContextOptions.optional(),
});

export const zV1SecurityContext = z.object({
  allowPrivilegeEscalation: z.boolean().optional(),
  appArmorProfile: zV1AppArmorProfile.optional(),
  capabilities: zV1Capabilities.optional(),
  privileged: z.boolean().optional(),
  procMount: zV1ProcMountType.optional(),
  readOnlyRootFilesystem: z.boolean().optional(),
  runAsGroup: z.int().optional(),
  runAsNonRoot: z.boolean().optional(),
  runAsUser: z.int().optional(),
  seLinuxOptions: zV1SeLinuxOptions.optional(),
  seccompProfile: zV1SeccompProfile.optional(),
  windowsOptions: zV1WindowsSecurityContextOptions.optional(),
});

export const zV1Container = z.object({
  args: z.array(z.string()).optional(),
  command: z.array(z.string()).optional(),
  env: z.array(zV1EnvVar).optional(),
  envFrom: z.array(zV1EnvFromSource).optional(),
  image: z.string().optional(),
  imagePullPolicy: zV1PullPolicy.optional(),
  lifecycle: zV1Lifecycle.optional(),
  livenessProbe: zV1Probe.optional(),
  name: z.string().optional(),
  ports: z.array(zV1ContainerPort).optional(),
  readinessProbe: zV1Probe.optional(),
  resizePolicy: z.array(zV1ContainerResizePolicy).optional(),
  resources: zV1ResourceRequirements.optional(),
  restartPolicy: zV1ContainerRestartPolicy.optional(),
  restartPolicyRules: z.array(zV1ContainerRestartRule).optional(),
  securityContext: zV1SecurityContext.optional(),
  startupProbe: zV1Probe.optional(),
  stdin: z.boolean().optional(),
  stdinOnce: z.boolean().optional(),
  terminationMessagePath: z.string().optional(),
  terminationMessagePolicy: zV1TerminationMessagePolicy.optional(),
  tty: z.boolean().optional(),
  volumeDevices: z.array(zV1VolumeDevice).optional(),
  volumeMounts: z.array(zV1VolumeMount).optional(),
  workingDir: z.string().optional(),
});

export const zKubernetesK8sJob = z.object({
  BackoffLimit: z.int().optional(),
  Command: z.string().optional(),
  Completions: z.int().optional(),
  Container: zV1Container.optional(),
  Duration: z.string().optional(),
  FailedReason: z.string().optional(),
  FinishTime: z.string().optional(),
  Id: z.string().optional(),
  IsSystem: z.boolean().optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  PodName: z.string().optional(),
  StartTime: z.string().optional(),
  Status: z.string().optional(),
});

export const zKubernetesK8sCronJob = z.object({
  Command: z.string().optional(),
  Id: z.string().optional(),
  IsSystem: z.boolean().optional(),
  Jobs: z.array(zKubernetesK8sJob).optional(),
  Name: z.string().optional(),
  Namespace: z.string().optional(),
  Schedule: z.string().optional(),
  Suspend: z.boolean().optional(),
  Timezone: z.string().optional(),
});

export const zV1EphemeralContainer = z.object({
  args: z.array(z.string()).optional(),
  command: z.array(z.string()).optional(),
  env: z.array(zV1EnvVar).optional(),
  envFrom: z.array(zV1EnvFromSource).optional(),
  image: z.string().optional(),
  imagePullPolicy: zV1PullPolicy.optional(),
  lifecycle: zV1Lifecycle.optional(),
  livenessProbe: zV1Probe.optional(),
  name: z.string().optional(),
  ports: z.array(zV1ContainerPort).optional(),
  readinessProbe: zV1Probe.optional(),
  resizePolicy: z.array(zV1ContainerResizePolicy).optional(),
  resources: zV1ResourceRequirements.optional(),
  restartPolicy: zV1ContainerRestartPolicy.optional(),
  restartPolicyRules: z.array(zV1ContainerRestartRule).optional(),
  securityContext: zV1SecurityContext.optional(),
  startupProbe: zV1Probe.optional(),
  stdin: z.boolean().optional(),
  stdinOnce: z.boolean().optional(),
  targetContainerName: z.string().optional(),
  terminationMessagePath: z.string().optional(),
  terminationMessagePolicy: zV1TerminationMessagePolicy.optional(),
  tty: z.boolean().optional(),
  volumeDevices: z.array(zV1VolumeDevice).optional(),
  volumeMounts: z.array(zV1VolumeMount).optional(),
  workingDir: z.string().optional(),
});

export const zV1WorkloadReference = z.object({
  name: z.string().optional(),
  podGroup: z.string().optional(),
  podGroupReplicaKey: z.string().optional(),
});

export const zV1PodSpec = z.object({
  activeDeadlineSeconds: z.int().optional(),
  affinity: zV1Affinity.optional(),
  automountServiceAccountToken: z.boolean().optional(),
  containers: z.array(zV1Container).optional(),
  dnsConfig: zV1PodDnsConfig.optional(),
  dnsPolicy: zV1DnsPolicy.optional(),
  enableServiceLinks: z.boolean().optional(),
  ephemeralContainers: z.array(zV1EphemeralContainer).optional(),
  hostAliases: z.array(zV1HostAlias).optional(),
  hostIPC: z.boolean().optional(),
  hostNetwork: z.boolean().optional(),
  hostPID: z.boolean().optional(),
  hostUsers: z.boolean().optional(),
  hostname: z.string().optional(),
  hostnameOverride: z.string().optional(),
  imagePullSecrets: z.array(zK8sIoApiCoreV1LocalObjectReference).optional(),
  initContainers: z.array(zV1Container).optional(),
  nodeName: z.string().optional(),
  nodeSelector: z.record(z.string(), z.string()).optional(),
  os: zV1PodOs.optional(),
  overhead: zV1ResourceList.optional(),
  preemptionPolicy: zV1PreemptionPolicy.optional(),
  priority: z.int().optional(),
  priorityClassName: z.string().optional(),
  readinessGates: z.array(zV1PodReadinessGate).optional(),
  resourceClaims: z.array(zV1PodResourceClaim).optional(),
  resources: zV1ResourceRequirements.optional(),
  restartPolicy: zV1RestartPolicy.optional(),
  runtimeClassName: z.string().optional(),
  schedulerName: z.string().optional(),
  schedulingGates: z.array(zV1PodSchedulingGate).optional(),
  securityContext: zV1PodSecurityContext.optional(),
  serviceAccount: z.string().optional(),
  serviceAccountName: z.string().optional(),
  setHostnameAsFQDN: z.boolean().optional(),
  shareProcessNamespace: z.boolean().optional(),
  subdomain: z.string().optional(),
  terminationGracePeriodSeconds: z.int().optional(),
  tolerations: z.array(zV1Toleration).optional(),
  topologySpreadConstraints: z.array(zV1TopologySpreadConstraint).optional(),
  volumes: z.array(zV1Volume).optional(),
  workloadRef: zV1WorkloadReference.optional(),
});

export const zV1Pod = z.object({
  apiVersion: z.string().optional(),
  kind: z.string().optional(),
  metadata: zV1ObjectMeta.optional(),
  spec: zV1PodSpec.optional(),
  status: zV1PodStatus.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesPodListResponse =
  z.object({
    apiVersion: z.string().optional(),
    items: z.array(zV1Pod).optional(),
    kind: z.string().optional(),
    metadata: zV1ListMeta.optional(),
  });

export const zV1PodTemplateSpec = z.object({
  metadata: zV1ObjectMeta.optional(),
  spec: zV1PodSpec.optional(),
});

export const zV1DeploymentSpec = z.object({
  minReadySeconds: z.int().optional(),
  paused: z.boolean().optional(),
  progressDeadlineSeconds: z.int().optional(),
  replicas: z.int().optional(),
  revisionHistoryLimit: z.int().optional(),
  selector: zV1LabelSelector.optional(),
  strategy: zK8sIoApiAppsV1DeploymentStrategy.optional(),
  template: zV1PodTemplateSpec.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse =
  z.object({
    apiVersion: z.string().optional(),
    kind: z.string().optional(),
    metadata: zV1ObjectMeta.optional(),
    spec: zV1DeploymentSpec.optional(),
    status: zV1DeploymentStatus.optional(),
  });

export const zV1Deployment = z.object({
  apiVersion: z.string().optional(),
  kind: z.string().optional(),
  metadata: zV1ObjectMeta.optional(),
  spec: zV1DeploymentSpec.optional(),
  status: zV1DeploymentStatus.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentListResponse =
  z.object({
    apiVersion: z.string().optional(),
    items: z.array(zV1Deployment).optional(),
    kind: z.string().optional(),
    metadata: zV1ListMeta.optional(),
  });

export const zV1ReplicaSetSpec = z.object({
  minReadySeconds: z.int().optional(),
  replicas: z.int().optional(),
  selector: zV1LabelSelector.optional(),
  template: zV1PodTemplateSpec.optional(),
});

export const zV1ReplicaSet = z.object({
  apiVersion: z.string().optional(),
  kind: z.string().optional(),
  metadata: zV1ObjectMeta.optional(),
  spec: zV1ReplicaSetSpec.optional(),
  status: zV1ReplicaSetStatus.optional(),
});

export const zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesReplicaSetListResponse =
  z.object({
    apiVersion: z.string().optional(),
    items: z.array(zV1ReplicaSet).optional(),
    kind: z.string().optional(),
    metadata: zV1ListMeta.optional(),
  });

export const zV1Beta1ContainerMetrics = z.object({
  name: z.string().optional(),
  usage: zV1ResourceList.optional(),
});

export const zV1Beta1NodeMetrics = z.object({
  apiVersion: z.string().optional(),
  kind: z.string().optional(),
  metadata: zV1ObjectMeta.optional(),
  timestamp: z.string().optional(),
  usage: zV1ResourceList.optional(),
  window: z.string().optional(),
});

export const zV1Beta1NodeMetricsList = z.object({
  apiVersion: z.string().optional(),
  items: z.array(zV1Beta1NodeMetrics).optional(),
  kind: z.string().optional(),
  metadata: zV1ListMeta.optional(),
});

export const zV1Beta1PodMetrics = z.object({
  apiVersion: z.string().optional(),
  containers: z.array(zV1Beta1ContainerMetrics).optional(),
  kind: z.string().optional(),
  metadata: zV1ObjectMeta.optional(),
  timestamp: z.string().optional(),
  window: z.string().optional(),
});

export const zV1Beta1PodMetricsList = z.object({
  apiVersion: z.string().optional(),
  items: z.array(zV1Beta1PodMetrics).optional(),
  kind: z.string().optional(),
  metadata: zV1ListMeta.optional(),
});

export const zWebhooksWebhookCreatePayload = z.object({
  EndpointID: z.int().optional(),
  RegistryID: z.int().optional(),
  ResourceID: z.string().optional(),
  WebhookType: zPortainerWebhookType.optional(),
});

export const zWebhooksWebhookReassignPayload = z.object({
  ResourceID: z.string().optional(),
  WebhookType: zPortainerWebhookType.optional(),
});

export const zWebhooksWebhookUpdatePayload = z.object({
  RegistryID: z.int().optional(),
});

export const zWorkflowsArtifactFileDetail = z.object({
  hash: z.string().optional(),
  path: z.string().optional(),
  pathError: z.string().optional(),
  pathStatus: zSourcesStatus.optional(),
  ref: z.string().optional(),
  refError: z.string().optional(),
  refStatus: zSourcesStatus.optional(),
  sourceId: z.int().optional(),
});

export const zWorkflowsDeploymentPlatform = z.enum([
  'dockerStandalone',
  'dockerSwarm',
  'kubernetes',
]);

export const zWorkflowsStatusSummary = z.object({
  error: z.int().optional(),
  healthy: z.int().optional(),
  paused: z.int().optional(),
  syncing: z.int().optional(),
  unknown: z.int().optional(),
});

export const zWorkflowsTarget = z.object({
  edgeGroupIds: z.array(z.int()).optional(),
  endpointId: z.int().optional(),
  groupStatus: z
    .record(z.string(), zGithubComPortainerPortainerApiGitopsWorkflowsStatus)
    .optional(),
  namespace: z.string().optional(),
  resolvedEndpointIds: z.array(z.int()).optional(),
});

export const zWorkflowsType = z.enum(['stack', 'edgeStack']);

export const zWorkflowsWorkflowPhaseStatus = z.object({
  error: z.string().optional(),
  status: zGithubComPortainerPortainerApiGitopsWorkflowsStatus.optional(),
});

export const zWorkflowsWorkflowStatusObject = z.object({
  artifact: zWorkflowsWorkflowPhaseStatus.optional(),
  source: zWorkflowsWorkflowPhaseStatus.optional(),
  target: zWorkflowsWorkflowPhaseStatus.optional(),
});

export const zSourcesWorkflow = z.object({
  creationDate: z.int().optional(),
  gitConfig: zGithubComPortainerPortainerApiGitTypesRepoConfig.optional(),
  id: z.int(),
  lastSyncDate: z.int().optional(),
  name: z.string(),
  platform: zWorkflowsDeploymentPlatform,
  sourceId: z.int().optional(),
  status: zWorkflowsWorkflowStatusObject,
  target: zWorkflowsTarget,
  type: zWorkflowsType,
});

export const zWorkflowsArtifactDetail = z.object({
  autoUpdate: zPortainerAutoUpdateSettings.optional(),
  creationDate: z.int().optional(),
  files: z.array(zWorkflowsArtifactFileDetail).optional(),
  id: z.int(),
  lastSyncDate: z.int().optional(),
  name: z.string(),
  platform: zWorkflowsDeploymentPlatform.optional(),
  status: zWorkflowsWorkflowStatusObject.optional(),
  target: zWorkflowsTarget.optional(),
  type: zWorkflowsType,
});

export const zWorkflowsWorkflow = z.object({
  artifacts: z.array(zWorkflowsArtifactDetail).optional(),
  creationDate: z.int().optional(),
  id: z.int(),
  lastSyncDate: z.int().optional(),
  name: z.string(),
  status: zWorkflowsWorkflowStatusObject,
});

export const zWorkflowsCreatePayloadArtifactParallelConfig = z.object({
  batchCount: z.int().optional(),
  batchIncrementBy: z.int().optional(),
  delay: z.string().optional(),
  failureAction: z.string().optional(),
  timeout: z.string().optional(),
});

export const zWorkflowsCreatePayloadArtifactConfig = z.object({
  alwaysCloneGitRepoForRelativePath: z.boolean().optional(),
  envVars: z.array(zPortainerPair).optional(),
  localFilesystemPath: z.string().optional(),
  parallelConfig: zWorkflowsCreatePayloadArtifactParallelConfig.optional(),
  perDeviceConfigsGroupMatchType: z.enum(['file', 'dir']).optional(),
  perDeviceConfigsMatchType: z.enum(['file', 'dir']).optional(),
  perDeviceConfigsPath: z.string().optional(),
  prePullImage: z.boolean().optional(),
  registries: z.array(z.int()).optional(),
  retryPeriod: z.int().optional(),
  useManifestNamespaces: z.boolean().optional(),
});

export const zWorkflowsCreatePayloadArtifactTargets = z.object({
  edgeGroups: z.array(z.int()),
});

export const zWorkflowsCreatePayloadFile = z.object({
  path: z.string(),
  ref: z.string(),
  sourceId: z.int(),
});

export const zWorkflowsCreatePayloadArtifact = z.object({
  config: zWorkflowsCreatePayloadArtifactConfig.optional(),
  deploymentType: z.string(),
  files: z.array(zWorkflowsCreatePayloadFile),
  name: z.string(),
  targets: zWorkflowsCreatePayloadArtifactTargets,
});

export const zWorkflowsCreatePayload = z.object({
  artifacts: z.array(zWorkflowsCreatePayloadArtifact),
  name: z.string(),
});

export const zWorkflowsUpdateArtifactConfigPayload = z.object({
  envVars: z.array(zPortainerPair).optional(),
  parallelConfig: zWorkflowsCreatePayloadArtifactParallelConfig.optional(),
  prePullImage: z.boolean().optional(),
  registries: z.array(z.int()).optional(),
  retryPeriod: z.int().optional(),
});

export const zWorkflowsUpdateArtifactPayload = z.object({
  config: zWorkflowsUpdateArtifactConfigPayload.optional(),
  deploymentType: z.string().optional(),
  files: z.array(zWorkflowsCreatePayloadFile).optional(),
  id: z.int(),
  targets: zWorkflowsCreatePayloadArtifactTargets.optional(),
  type: zWorkflowsType,
});

export const zWorkflowsUpdatePayload = z.object({
  artifacts: z.array(zWorkflowsUpdateArtifactPayload).optional(),
  name: z.string().optional(),
});

export const zModelsK8sServiceInfo2 = zModelsK8sServiceInfo;

export const zAddonsConfigEntryUpdatePayload2 = zAddonsConfigEntryUpdatePayload;

/**
 * Ingress controllers
 */
export const zModelsK8sIngressControllerArray = z.array(
  zModelsK8sIngressController
);

export const zKubernetesK8sDeploymentWriteRequest2 =
  zKubernetesK8sDeploymentWriteRequest;

export const zCreate = z.object({
  provider: z.string(),
  name: z.string(),
  credentials: z.string(),
});

export const zModelsK8sNamespaceDetails2 = zModelsK8sNamespaceDetails;

export const zAddonsConfigUpdatePayload2 = zAddonsConfigUpdatePayload;

export const zEndpointsEndpointDeleteBatchPayload2 =
  zEndpointsEndpointDeleteBatchPayload;

export const zKubernetesK8sConfigMapWriteRequest2 =
  zKubernetesK8sConfigMapWriteRequest;

export const zModelsK8sIngressInfo2 = zModelsK8sIngressInfo;

export const zKubernetesK8sSecretWriteRequest2 =
  zKubernetesK8sSecretWriteRequest;

/**
 * Capabilities of this Portainer
 */
export const zAddonStoreCapabilitiesResponse = zAddonsCapabilitiesResponse;

/**
 * Stored configuration
 */
export const zAddonStoreConfigListResponse = zAddonsConfigResponse;

/**
 * Configuration entries
 */
export const zAddonStoreConfigUpdateBody = zAddonsConfigUpdatePayload2;

/**
 * Stored configuration
 */
export const zAddonStoreConfigUpdateResponse = zAddonsConfigMutationResponse;

export const zAddonStoreConfigEntryDeletePath = z.object({
  key: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonStoreConfigEntryDeleteResponse =
  zAddonsConfigMutationResponse;

/**
 * Configuration value
 */
export const zAddonStoreConfigEntryUpdateBody =
  zAddonsConfigEntryUpdatePayload2;

export const zAddonStoreConfigEntryUpdatePath = z.object({
  key: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonStoreConfigEntryUpdateResponse =
  zAddonsConfigMutationResponse;

export const zAddonListQuery = z.object({
  view: z.enum(['switcher']).optional(),
});

/**
 * Success
 */
export const zAddonListResponse = zAddonsAddonListResponse;

export const zAddonUninstallPath = z.object({
  id: z.string(),
});

export const zAddonUninstallQuery = z.object({
  force: z.boolean().optional(),
  pruneConfig: z.boolean().optional(),
});

export const zAddonUninstallResponse = z.union([
  zAddonsAddonLifecycleResponse,
  z.void(),
]);

export const zAddonDetailPath = z.object({
  id: z.string(),
});

/**
 * Success
 */
export const zAddonDetailResponse = zAddonsAddonListItem;

/**
 * Install options
 */
export const zAddonInstallBody = zAddonsInstallPayload;

export const zAddonInstallPath = z.object({
  id: z.string(),
});

/**
 * Upgrade of an already-installed addon accepted
 */
export const zAddonInstallResponse = zAddonsAddonLifecycleResponse;

/**
 * Addon access configuration
 */
export const zAddonAccessUpdateBody = zAddonsAddonAccessUpdatePayload;

export const zAddonAccessUpdatePath = z.object({
  id: z.string(),
});

/**
 * Success
 */
export const zAddonAccessUpdateResponse = zAddonsAddonAccessResponse;

export const zAddonChartSourcePath = z.object({
  id: z.string(),
});

export const zAddonChartSourceQuery = z.object({
  registryId: z.int().optional(),
  chart: z.string().optional(),
});

/**
 * Success
 */
export const zAddonChartSourceResponse = zAddonsChartSourceStatusResponse;

export const zAddonConfigDeletePath = z.object({
  id: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonConfigDeleteResponse = zAddonsConfigMutationResponse;

export const zAddonConfigListPath = z.object({
  id: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonConfigListResponse = zAddonsConfigResponse;

/**
 * Configuration entries
 */
export const zAddonConfigUpdateBody = zAddonsConfigUpdatePayload2;

export const zAddonConfigUpdatePath = z.object({
  id: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonConfigUpdateResponse = zAddonsConfigMutationResponse;

export const zAddonConfigEntryDeletePath = z.object({
  id: z.string(),
  key: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonConfigEntryDeleteResponse = zAddonsConfigMutationResponse;

/**
 * Configuration value
 */
export const zAddonConfigEntryUpdateBody = zAddonsConfigEntryUpdatePayload2;

export const zAddonConfigEntryUpdatePath = z.object({
  id: z.string(),
  key: z.string(),
});

/**
 * Stored configuration
 */
export const zAddonConfigEntryUpdateResponse = zAddonsConfigMutationResponse;

export const zAddonRepairPath = z.object({
  id: z.string(),
});

/**
 * Credential repaired
 */
export const zAddonRepairResponse = zAddonsAddonLifecycleResponse;

/**
 * Success
 */
export const zAddonCatalogResponse = zAddonproxyCatalog;

/**
 * Success
 */
export const zAddonCatalogRefreshResponse = z.void();

/**
 * Success
 */
export const zAddonEnvironmentResponse = zAddonsAddonEnvironmentResponse;

export const zAllowListInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zAllowListInspectResponse = zPortainerAllowList;

/**
 * URL allow list
 */
export const zAllowListUpdateBody = zAllowlistAllowListUpdatePayload;

export const zAllowListUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zAllowListUpdateResponse = zPortainerAllowList;

/**
 * Credentials used for authentication
 */
export const zAuthenticateUserBody = zAuthAuthenticatePayload;

/**
 * Success
 */
export const zAuthenticateUserResponse = zAuthAuthenticateResponse;

/**
 * Success
 */
export const zLogoutResponse = z.void();

/**
 * OAuth Credentials used for authentication
 */
export const zValidateOAuthBody = zAuthOauthPayload;

/**
 * Success
 */
export const zValidateOAuthResponse = zAuthAuthenticateResponse;

/**
 * OK
 */
export const zAutoUpdateListResponse = zAutoupdatesListResponse;

/**
 * An object contains the password to encrypt the backup with
 */
export const zBackupBody = zBackupBackupPayload;

/**
 * Azure Blob backup settings
 */
export const zBackupToAzureBlobBody = zPortainereeAzureBlobBackupSettings;

/**
 * Success
 */
export const zBackupToAzureBlobResponse = z.void();

/**
 * Azure Blob location and credentials
 */
export const zRestoreFromAzureBlobBody = zBackupRestoreAzureSettings;

export const zRestoreFromAzureBlobHeaders = z.object({
  'X-Setup-Token': z.string().optional(),
});

/**
 * Success
 */
export const zAzureBlobBackupSettingsFetchResponse =
  zPortainereeAzureBlobBackupSettings;

/**
 * Azure Blob backup settings
 */
export const zUpdateAzureBlobSettingsBody = zPortainereeAzureBlobBackupSettings;

/**
 * Success
 */
export const zAzureBlobBackupStatusFetchResponse = zBackupAzureBackupStatus;

/**
 * Azure Blob connection settings
 */
export const zAzureBlobTestConnectionBody = zPortainereeAzureBlobBackupSettings;

/**
 * Connection successful
 */
export const zAzureBlobTestConnectionResponse = z.void();

/**
 * Success
 */
export const zRunLocalBackupNowResponse = z.void();

/**
 * Success
 */
export const zLocalBackupSettingsFetchResponse =
  zPortainereeLocalBackupSettings;

/**
 * Local backup settings
 */
export const zUpdateLocalBackupSettingsBody = zPortainereeLocalBackupSettings;

/**
 * Success
 */
export const zLocalBackupStatusFetchResponse = zBackupLocalBackupStatus;

/**
 * S3 backup settings
 */
export const zBackupToS3Body = zBackupS3BackupPayload;

/**
 * Success
 */
export const zBackupToS3Response = z.void();

/**
 * S3 Location Payload
 */
export const zRestoreFromS3Body = zBackupRestoreS3Settings;

export const zRestoreFromS3Headers = z.object({
  'X-Setup-Token': z.string().optional(),
});

/**
 * Success
 */
export const zBackupSettingsFetchResponse = zPortainereeS3BackupSettings;

/**
 * S3 backup settings
 */
export const zUpdateS3SettingsBody = zPortainereeS3BackupSettings;

/**
 * Success
 */
export const zBackupStatusFetchResponse = zBackupBackupStatus;

/**
 * OK
 */
export const zGetAllResponse = zModelsCloudCredential;

export const zCreateBody = zCreate;

/**
 * OK
 */
export const zCreateResponse = zModelsCloudCredential;

export const zCloudCredsDeletePath = z.object({
  id: z.string(),
});

/**
 * OK
 */
export const zCloudCredsDeleteResponse = zModelsCloudCredential;

export const zCloudCredsGetByIdPath = z.object({
  id: z.string(),
});

/**
 * OK
 */
export const zCloudCredsGetByIdResponse = zModelsCloudCredential;

export const zCloudCredsUpdateBody = zCreate;

export const zCloudCredsUpdatePath = z.object({
  id: z.string(),
});

/**
 * OK
 */
export const zCloudCredsUpdateResponse = zModelsCloudCredential;

export const zUpgradePath = z.object({
  environmentId: z.int(),
});

/**
 * Success
 */
export const zSharedGitGetAllResponse = z.array(zGitShadowedGitCredential);

/**
 * Git credential details
 */
export const zSharedGitCreateBody = zGitGitCredentialCreatePayload;

export const zSharedGitDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zSharedGitDeleteResponse = z.void();

export const zSharedGitGetPath = z.object({
  id: z.int(),
});

/**
 * Git credential details
 */
export const zSharedGitUpdateBody = zGitGitCredentialUpdatePayload;

export const zSharedGitUpdatePath = z.object({
  id: z.int(),
});

export const zCustomTemplateListQuery = z.object({
  type: z.array(z.union([z.literal(1), z.literal(2), z.literal(3)])),
  edge: z.boolean().optional(),
});

/**
 * Success
 */
export const zCustomTemplateListResponse = z.array(zPortainereeCustomTemplate);

export const zCustomTemplateDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCustomTemplateDeleteResponse = z.void();

export const zCustomTemplateInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCustomTemplateInspectResponse = zPortainereeCustomTemplate;

/**
 * Template details
 */
export const zCustomTemplateUpdateBody =
  zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesCustomTemplateUpdatePayload;

export const zCustomTemplateUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCustomTemplateUpdateResponse = zPortainereeCustomTemplate;

export const zCustomTemplateFilePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCustomTemplateFileResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesFileResponse;

export const zCustomTemplateGitFetchPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCustomTemplateGitFetchResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesFileResponse;

export const zCustomTemplateCreateFileBody = z.object({
  Title: z.string(),
  Description: z.string(),
  Note: z.string(),
  Platform: z.union([z.literal(1), z.literal(2)]),
  Type: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  File: z.union([z.instanceof(Blob), z.instanceof(File)]),
  Logo: z.string().optional(),
  Variables: z.string().optional(),
  EdgeTemplate: z.boolean().optional(),
  EdgeSettings: z.string().optional(),
});

/**
 * OK
 */
export const zCustomTemplateCreateFileResponse = zPortainereeCustomTemplate;

/**
 * Required when using method=repository
 */
export const zCustomTemplateCreateRepositoryBody =
  zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesCustomTemplateFromGitRepositoryPayload;

/**
 * OK
 */
export const zCustomTemplateCreateRepositoryResponse =
  zPortainereeCustomTemplate;

/**
 * body
 */
export const zCustomTemplateCreateStringBody =
  zGithubComPortainerPortainerEeApiHttpHandlerCustomtemplatesCustomTemplateFromFileContentPayload;

/**
 * OK
 */
export const zCustomTemplateCreateStringResponse = zPortainereeCustomTemplate;

export const zDockerContainerGpusInspectPath = z.object({
  environmentId: z.int(),
  containerId: z.int(),
});

/**
 * Success
 */
export const zDockerContainerGpusInspectResponse =
  zContainersContainerGpusResponse;

export const zContainerImageStatusPath = z.object({
  environmentId: z.int(),
  containerId: z.int(),
});

export const zContainerImageStatusQuery = z.object({
  refresh: z.boolean().optional(),
});

/**
 * Success
 */
export const zContainerImageStatusResponse = zImagesStatusResponse;

export const zContainersImageStatusClearPath = z.object({
  environmentId: z.int(),
});

/**
 * Success
 */
export const zContainersImageStatusClearResponse = z.void();

export const zDockerDashboardPath = z.object({
  environmentId: z.int(),
});

/**
 * Success
 */
export const zDockerDashboardResponse = zDockerDashboardData;

export const zDockerImagesListPath = z.object({
  environmentId: z.int(),
});

export const zDockerImagesListQuery = z.object({
  withUsage: z.boolean().optional(),
});

/**
 * Success
 */
export const zDockerImagesListResponse = z.array(zImagesImageResponse);

export const zServiceImageStatusPath = z.object({
  environmentId: z.int(),
  serviceId: z.int(),
});

export const zServiceImageStatusQuery = z.object({
  refresh: z.boolean().optional(),
});

/**
 * Success
 */
export const zServiceImageStatusResponse = zImagesStatusResponse;

export const zServiceImageStatusClearPath = z.object({
  environmentId: z.int(),
});

/**
 * Success
 */
export const zServiceImageStatusClearResponse = z.void();

export const zSnapshotInspectPath = z.object({
  environmentId: z.int(),
});

/**
 * Success
 */
export const zSnapshotInspectResponse = zPortainerDockerSnapshotRaw;

export const zSnapshotContainersListPath = z.object({
  environmentId: z.int(),
});

export const zSnapshotContainersListQuery = z.object({
  edgeStackId: z.int().optional(),
});

/**
 * Success
 */
export const zSnapshotContainersListResponse =
  zPortainerDockerContainerSnapshot;

export const zSnapshotContainerInspectPath = z.object({
  environmentId: z.int(),
  containerId: z.int(),
});

/**
 * Success
 */
export const zSnapshotContainerInspectResponse =
  zPortainerDockerContainerSnapshot;

/**
 * body
 */
export const zEdgeConfigListBody = zEdgeconfigsEdgeConfigCreatePayload;

/**
 * Success
 */
export const zEdgeConfigListResponse = z.array(zPortainereeEdgeConfig);

export const zEdgeConfigCreateBody = z.object({
  BaseDir: z.string().optional(),
  Category: z.enum(['configuration', 'secret']).optional(),
  EdgeGroupIDs: z.array(z.int()).optional(),
  Name: z.string().optional(),
  Type: z.string().optional(),
  File: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

/**
 * No Content
 */
export const zEdgeConfigCreateResponse = z.void();

export const zEdgeConfigDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEdgeConfigDeleteResponse = z.void();

export const zEdgeConfigInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEdgeConfigInspectResponse = zPortainereeEdgeConfig;

export const zEdgeConfigUpdateBody = z.object({
  EdgeGroupIDs: z.array(z.int()).optional(),
  Type: z.string().optional(),
  File: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

export const zEdgeConfigUpdatePath = z.object({
  id: z.int(),
});

/**
 * No Content
 */
export const zEdgeConfigUpdateResponse = z.void();

export const zEdgeConfigStatePath = z.object({
  id: z.int(),
  state: z.int(),
});

/**
 * Success
 */
export const zEdgeConfigStateResponse = z.void();

export const zEdgeConfigFilesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEdgeConfigFilesResponse = z.string();

export const zEdgeGroupListQuery = z.object({
  summarize: z.boolean().optional(),
});

/**
 * EdgeGroups
 */
export const zEdgeGroupListResponse = z.array(zEdgegroupsDecoratedEdgeGroup);

/**
 * EdgeGroup data
 */
export const zEdgeGroupCreateBody = zEdgegroupsEdgeGroupCreatePayload;

/**
 * OK
 */
export const zEdgeGroupCreateResponse = zPortainereeEdgeGroup;

export const zEdgeGroupDeletePath = z.object({
  id: z.int(),
});

/**
 * No Content
 */
export const zEdgeGroupDeleteResponse = z.void();

export const zEdgeGroupInspectPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeGroupInspectResponse = zPortainereeEdgeGroup;

/**
 * EdgeGroup data
 */
export const zEdgeGroupUpdateBody = zEdgegroupsEdgeGroupUpdatePayload;

export const zEdgeGroupUpdatePath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeGroupUpdateResponse = zPortainereeEdgeGroup;

/**
 * OK
 */
export const zEdgeJobListResponse = z.array(zPortainerEdgeJob);

export const zEdgeJobDeletePath = z.object({
  id: z.int(),
});

/**
 * No Content
 */
export const zEdgeJobDeleteResponse = z.void();

export const zEdgeJobInspectPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeJobInspectResponse = zPortainerEdgeJob;

/**
 * EdgeGroup data
 */
export const zEdgeJobUpdateBody = zEdgejobsEdgeJobUpdatePayload;

export const zEdgeJobUpdatePath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeJobUpdateResponse = zPortainerEdgeJob;

export const zEdgeJobFilePath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeJobFileResponse = zEdgejobsEdgeJobFileResponse;

export const zEdgeJobTasksListPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeJobTasksListResponse = z.array(zEdgejobsTaskContainer);

export const zEdgeJobTasksClearPath = z.object({
  id: z.int(),
  taskID: z.int(),
});

/**
 * No Content
 */
export const zEdgeJobTasksClearResponse = z.void();

export const zEdgeJobTaskLogsInspectPath = z.object({
  id: z.int(),
  taskID: z.int(),
});

/**
 * OK
 */
export const zEdgeJobTaskLogsInspectResponse = zEdgejobsFileResponse;

export const zEdgeJobTasksCollectPath = z.object({
  id: z.int(),
  taskID: z.int(),
});

/**
 * No Content
 */
export const zEdgeJobTasksCollectResponse = z.void();

export const zEdgeJobCreateFileBody = z.object({
  file: z.union([z.instanceof(Blob), z.instanceof(File)]),
  Name: z.string(),
  CronExpression: z.string(),
  EdgeGroups: z.string(),
  Endpoints: z.string(),
  Recurring: z.boolean().optional(),
});

/**
 * OK
 */
export const zEdgeJobCreateFileResponse = zPortainereeEdgeGroup;

/**
 * EdgeGroup data when method is string
 */
export const zEdgeJobCreateStringBody =
  zEdgejobsEdgeJobCreateFromFileContentPayload;

/**
 * OK
 */
export const zEdgeJobCreateStringResponse = zPortainereeEdgeGroup;

export const zEdgeStackListQuery = z.object({
  summarizeStatuses: z.boolean().optional(),
});

/**
 * OK
 */
export const zEdgeStackListResponse = z.array(
  zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackListResponseItem
);

export const zEdgeStackDeletePath = z.object({
  id: z.int(),
});

/**
 * No Content
 */
export const zEdgeStackDeleteResponse = z.void();

export const zEdgeStackInspectPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeStackInspectResponse = zPortainereeEdgeStack;

/**
 * EdgeStack data
 */
export const zEdgeStackUpdateBody =
  zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksUpdateEdgeStackPayload;

export const zEdgeStackUpdatePath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeStackUpdateResponse = zPortainereeEdgeStack;

export const zEdgeStackFilePath = z.object({
  id: z.int(),
});

export const zEdgeStackFileQuery = z.object({
  version: z.int().optional(),
  commitHash: z.string().optional(),
});

/**
 * OK
 */
export const zEdgeStackFileResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksStackFileResponse;

/**
 * Git configurations
 */
export const zEdgeStackUpdateFromGitBody = zEdgestacksStackGitUpdatePayload;

export const zEdgeStackUpdateFromGitPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEdgeStackUpdateFromGitResponse = z.void();

/**
 * Helm repository update configuration
 */
export const zEdgeStackUpdateHelmRepositoryBody =
  zEdgestacksUpdateEdgeStackHelmRepositoryPayload;

export const zEdgeStackUpdateHelmRepositoryPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeStackUpdateHelmRepositoryResponse = zPortainereeEdgeStack;

export const zEdgeStackLogsDeletePath = z.object({
  id: z.int(),
  endpoint_id: z.int(),
});

/**
 * No Content
 */
export const zEdgeStackLogsDeleteResponse = z.void();

export const zEdgeStackLogsStatusGetPath = z.object({
  id: z.int(),
  endpoint_id: z.int(),
});

export const zEdgeStackLogsCollectPath = z.object({
  id: z.int(),
  endpoint_id: z.int(),
});

export const zEdgeStackLogsCollectQuery = z.object({
  tail: z.int().optional(),
  container_id: z.string().optional(),
  since: z.string().optional(),
  until: z.string().optional(),
});

/**
 * No Content
 */
export const zEdgeStackLogsCollectResponse = z.void();

export const zEdgeStackLogsDownloadPath = z.object({
  id: z.int(),
  endpoint_id: z.int(),
});

export const zEdgeStackStaggerStatusInspectPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeStackStaggerStatusInspectResponse =
  zEdgestacksEdgeStackStaggerStatusResponse;

/**
 * EdgeStack status payload
 */
export const zEdgeStackStatusUpdateBody =
  zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksUpdateStatusPayload;

export const zEdgeStackStatusUpdatePath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeStackStatusUpdateResponse = zPortainereeEdgeStack;

export const zEdgeStackCreateFileBody = z.object({
  Name: z.string(),
  file: z.union([z.instanceof(Blob), z.instanceof(File)]),
  EdgeGroups: z.string(),
  DeploymentType: z.int(),
  Registries: z.string().optional(),
  UseManifestNamespaces: z.boolean().optional(),
  PrePullImage: z.boolean().optional(),
  RetryDeploy: z.boolean().optional(),
  RetryPeriod: z.int().optional(),
  Webhook: z.string(),
  EnvVars: z.string().optional(),
  StaggerConfig: z.string().optional(),
});

export const zEdgeStackCreateFileQuery = z.object({
  dryrun: z.string().optional(),
});

/**
 * OK
 */
export const zEdgeStackCreateFileResponse = zPortainereeEdgeStack;

/**
 * stack config
 */
export const zEdgeStackCreateHelmRepositoryBody =
  zEdgestacksEdgeStackFromHelmRepositoryPayload;

export const zEdgeStackCreateHelmRepositoryQuery = z.object({
  dryrun: z.string().optional(),
});

/**
 * OK
 */
export const zEdgeStackCreateHelmRepositoryResponse = zPortainereeEdgeStack;

/**
 * stack config
 */
export const zEdgeStackCreateRepositoryBody =
  zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackFromGitRepositoryPayload;

export const zEdgeStackCreateRepositoryQuery = z.object({
  dryrun: z.string().optional(),
});

/**
 * OK
 */
export const zEdgeStackCreateRepositoryResponse = zPortainereeEdgeStack;

/**
 * stack config
 */
export const zEdgeStackCreateStringBody =
  zGithubComPortainerPortainerEeApiHttpHandlerEdgestacksEdgeStackFromStringPayload;

export const zEdgeStackCreateStringQuery = z.object({
  dryrun: z.string().optional(),
});

/**
 * OK
 */
export const zEdgeStackCreateStringResponse = zPortainereeEdgeStack;

export const zEdgeStackParseRegistriesBody = z.object({
  file: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

/**
 * List of registries IDs
 */
export const zEdgeStackParseRegistriesResponse = z.array(z.int());

export const zEdgeStackWebhookInvokePath = z.object({
  webhookID: z.string(),
});

export const zEdgeUpdateScheduleListQuery = z.object({
  includeEdgeStacks: z.boolean().optional(),
});

/**
 * OK
 */
export const zEdgeUpdateScheduleListResponse = z.array(
  zEdgeupdateschedulesDecoratedUpdateSchedule
);

/**
 * Schedule details
 */
export const zEdgeUpdateScheduleCreateBody = zEdgeupdateschedulesCreatePayload;

/**
 * Remote update procedure successfully created
 */
export const zEdgeUpdateScheduleCreateResponse = zTypesUpdateSchedule;

export const zEdgeUpdateScheduleDeletePath = z.object({
  id: z.int(),
});

/**
 * No Content
 */
export const zEdgeUpdateScheduleDeleteResponse = z.void();

export const zEdgeUpdateScheduleInspectPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zEdgeUpdateScheduleInspectResponse =
  zEdgeupdateschedulesInspectResponse;

/**
 * Schedule details
 */
export const zEdgeUpdateScheduleUpdateBody = zEdgeupdateschedulesUpdatePayload;

export const zEdgeUpdateScheduleUpdatePath = z.object({
  id: z.int(),
});

/**
 * Remote update procedure successfully updated
 */
export const zEdgeUpdateScheduleUpdateResponse = zTypesUpdateSchedule;

/**
 * Active schedule query
 */
export const zEdgeUpdateScheduleActiveSchedulesListBody =
  zEdgeupdateschedulesActiveSchedulePayload;

/**
 * OK
 */
export const zEdgeUpdateScheduleActiveSchedulesListResponse = z.array(
  zTypesEndpointUpdateScheduleRelation
);

/**
 * OK
 */
export const zRemoteUpdatesAgentVersionsResponse = z.array(z.string());

/**
 * OK
 */
export const zEdgeUpdateScheduleInfoResponse = zEdgeupdateschedulesInfoResponse;

export const zEdgeUpdatePreviousVersionsQuery = z.object({
  environmentIds: z.array(z.int()).optional(),
  edgeGroupIds: z.array(z.int()).optional(),
});

/**
 * OK
 */
export const zEdgeUpdatePreviousVersionsResponse = z.record(
  z.string(),
  z.string()
);

export const zEndpointGroupListQuery = z.object({
  size: z.boolean().optional(),
});

/**
 * Environment(Endpoint) group
 */
export const zEndpointGroupListResponse = z.array(
  zEndpointgroupsEndpointGroupResponse
);

/**
 * Environment(Endpoint) Group details
 */
export const zEndpointGroupCreateBody =
  zGithubComPortainerPortainerEeApiHttpHandlerEndpointgroupsEndpointGroupCreatePayload;

/**
 * Success
 */
export const zEndpointGroupCreateResponse = zPortainerEndpointGroup;

export const zEndpointGroupDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointGroupDeleteResponse = z.void();

export const zGetEndpointGroupsByIdPath = z.object({
  id: z.int(),
});

export const zGetEndpointGroupsByIdQuery = z.object({
  size: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetEndpointGroupsByIdResponse =
  zEndpointgroupsEndpointGroupResponse;

/**
 * EndpointGroup details
 */
export const zEndpointGroupUpdateBody =
  zGithubComPortainerPortainerEeApiHttpHandlerEndpointgroupsEndpointGroupUpdatePayload;

export const zEndpointGroupUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointGroupUpdateResponse = zPortainerEndpointGroup;

export const zEndpointGroupDeleteEndpointPath = z.object({
  id: z.int(),
  endpointId: z.int(),
});

/**
 * Success
 */
export const zEndpointGroupDeleteEndpointResponse = z.void();

export const zEndpointGroupAddEndpointPath = z.object({
  id: z.int(),
  endpointId: z.int(),
});

/**
 * Success
 */
export const zEndpointGroupAddEndpointResponse = z.void();

export const zEndpointListQuery = z.object({
  start: z.int().optional(),
  limit: z.int().optional(),
  sort: z
    .enum([
      'Name',
      'Group',
      'Status',
      'LastCheckIn',
      'EdgeID',
      'PlatformType',
      'Health',
      'Id',
    ])
    .optional(),
  order: z.string().optional(),
  updateInformation: z.boolean().optional(),
  k8sEnvAdmin: z.boolean().optional(),
  search: z.string().optional(),
  groupIds: z.array(z.int()).optional(),
  status: z.array(z.int()).optional(),
  types: z
    .array(
      z.union([
        z.literal(0),
        z.literal(1),
        z.literal(2),
        z.literal(3),
        z.literal(4),
        z.literal(5),
        z.literal(6),
        z.literal(7),
      ])
    )
    .optional(),
  platformTypes: z
    .array(
      z.union([
        z.literal(0),
        z.literal(1),
        z.literal(2),
        z.literal(3),
        z.literal(4),
      ])
    )
    .optional(),
  outdated: z.boolean().optional(),
  excludeGroupIds: z.array(z.int()).optional(),
  tagIds: z.array(z.int()).optional(),
  tagsPartialMatch: z.boolean().optional(),
  endpointIds: z.array(z.int()).optional(),
  excludeIds: z.array(z.int()).optional(),
  provisioned: z.boolean().optional(),
  agentVersions: z.array(z.string()).optional(),
  edgeAsync: z.boolean().optional(),
  edgeDeviceUntrusted: z.boolean().optional(),
  edgeCheckInPassedSeconds: z.number().optional(),
  excludeSnapshots: z.boolean().optional(),
  name: z.string().optional(),
  nameFilter: z.string().optional(),
  edgeStackId: z.int().optional(),
  edgeStackStatus: z
    .union([
      z.literal(0),
      z.literal(1),
      z.literal(2),
      z.literal(3),
      z.literal(4),
      z.literal(5),
      z.literal(6),
      z.literal(7),
      z.literal(8),
      z.literal(9),
      z.literal(10),
      z.literal(11),
      z.literal(12),
      z.literal(13),
    ])
    .optional(),
  edgeGroupIds: z.array(z.int()).optional(),
  excludeEdgeGroupIds: z.array(z.int()).optional(),
  policy: z.boolean().optional(),
  policyIds: z.array(z.int()).optional(),
  policyStatus: z
    .array(
      z.enum(['applied', 'failed', 'in_progress', 'warning', 'not_supported'])
    )
    .optional(),
});

/**
 * Endpoints
 */
export const zEndpointListResponse = z.array(zEndpointsEndpointResponse);

export const zEndpointCreateBody = z.object({
  Name: z.string(),
  EndpointCreationType: z.union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
  ]),
  ContainerEngine: z.string().optional(),
  URL: z.string().optional(),
  PublicURL: z.string().optional(),
  GroupID: z.int().optional(),
  TLS: z.boolean().optional(),
  TLSSkipVerify: z.boolean().optional(),
  TLSSkipClientVerify: z.boolean().optional(),
  TLSCACertFile: z.union([z.instanceof(Blob), z.instanceof(File)]).optional(),
  TLSCertFile: z.union([z.instanceof(Blob), z.instanceof(File)]).optional(),
  TLSKeyFile: z.union([z.instanceof(Blob), z.instanceof(File)]).optional(),
  AzureApplicationID: z.string().optional(),
  AzureTenantID: z.string().optional(),
  AzureAuthenticationKey: z.string().optional(),
  TagIds: z.string().optional(),
  EdgeCheckinInterval: z.int().optional(),
  EdgeTunnelServerAddress: z.string().optional(),
  EdgeAsyncMode: z.boolean().optional(),
  EdgePingInterval: z.int().optional(),
  EdgeSnapshotInterval: z.int().optional(),
  EdgeCommandInterval: z.int().optional(),
  CustomTemplateID: z.int().optional(),
  CustomTemplateContent: z.string().optional(),
  StackName: z.string().optional(),
  KubeConfig: z.string().optional(),
  Gpus: z.string().optional(),
});

/**
 * Success
 */
export const zEndpointCreateResponse = zPortainereeEndpoint;

export const zEndpointDeletePath = z.object({
  id: z.int(),
});

/**
 * Environment successfully deleted.
 */
export const zEndpointDeleteResponse = z.void();

export const zEndpointInspectPath = z.object({
  id: z.int(),
});

export const zEndpointInspectQuery = z.object({
  excludeSnapshot: z.boolean().optional(),
});

/**
 * Success
 */
export const zEndpointInspectResponse = zPortainereeEndpoint;

/**
 * Environment(Endpoint) details
 */
export const zEndpointUpdateBody = zEndpointsEndpointUpdatePayload;

export const zEndpointUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointUpdateResponse = zPortainereeEndpoint;

export const zEndpointAssociationDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointAssociationDeleteResponse = zPortainereeEndpoint;

export const zEndpointDockerBrowsePutBody = z.object({
  Path: z.string(),
  file: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

export const zEndpointDockerBrowsePutPath = z.object({
  id: z.int(),
});

export const zEndpointDockerBrowsePutQuery = z.object({
  volumeID: z.string().optional(),
});

/**
 * Success
 */
export const zEndpointDockerBrowsePutResponse = z.void();

export const zEndpointDockerhubStatusPath = z.object({
  id: z.int(),
  registryId: z.int(),
});

/**
 * Success
 */
export const zEndpointDockerhubStatusResponse =
  zEndpointsDockerhubStatusResponse;

/**
 * Per-policy statuses
 */
export const zEndpointSetPolicyStatusesBody =
  zEndpointedgePolicyStatusesPayload;

export const zEndpointSetPolicyStatusesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointSetPolicyStatusesResponse = z.void();

/**
 * details
 */
export const zEndpointForceUpdateServiceBody =
  zEndpointsForceUpdateServicePayload;

export const zEndpointForceUpdateServicePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointForceUpdateServiceResponse = zSwarmServiceUpdateResponse;

export const zHelmListPath = z.object({
  id: z.int(),
});

export const zHelmListQuery = z.object({
  namespace: z.string().optional(),
  filter: z.string().optional(),
  selector: z.string().optional(),
});

/**
 * Success
 */
export const zHelmListResponse = z.array(zReleaseReleaseElement);

/**
 * Chart details
 */
export const zHelmInstallBody = zHelmInstallChartPayload;

export const zHelmInstallPath = z.object({
  id: z.int(),
});

export const zHelmInstallQuery = z.object({
  dryRun: z.boolean().optional(),
});

/**
 * Created
 */
export const zHelmInstallResponse = zReleaseRelease;

export const zHelmDeletePath = z.object({
  id: z.int(),
  release: z.string(),
});

export const zHelmDeleteQuery = z.object({
  namespace: z.string().optional(),
});

/**
 * Success
 */
export const zHelmDeleteResponse = z.void();

export const zHelmGetPath = z.object({
  id: z.int(),
  release: z.string(),
});

export const zHelmGetQuery = z.object({
  namespace: z.string().optional(),
  showResources: z.boolean().optional(),
  revision: z.int().optional(),
});

/**
 * Success
 */
export const zHelmGetResponse = zReleaseRelease;

export const zHelmGetHistoryPath = z.object({
  id: z.int(),
  release: z.string(),
});

export const zHelmGetHistoryQuery = z.object({
  namespace: z.string().optional(),
});

/**
 * Success
 */
export const zHelmGetHistoryResponse = z.array(zReleaseRelease);

export const zHelmRollbackPath = z.object({
  id: z.int(),
  release: z.string(),
});

export const zHelmRollbackQuery = z.object({
  namespace: z.string().optional(),
  revision: z.int().optional(),
  wait: z.boolean().optional(),
  waitForJobs: z.boolean().optional(),
  recreate: z.boolean().optional(),
  force: z.boolean().optional(),
  timeout: z.int().optional(),
});

/**
 * Success
 */
export const zHelmRollbackResponse = zReleaseRelease;

/**
 * Git Helm dry run details
 */
export const zHelmGitDryRunBody = zHelmGitHelmDryRunPayload;

export const zHelmGitDryRunPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zHelmGitDryRunResponse = zReleaseRelease;

export const zEndpointMtlsCertificatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointMtlsCertificateResponse =
  zEndpointsEndpointMtlsCertResponse;

export const zEndpointMtlsAgentCertificateErrorPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointMtlsAgentCertificateErrorResponse =
  zEndpointsEndpointMtlsCertResponse;

/**
 * Payload containing lists of users and teams to add or remove access for
 */
export const zNamespacesAccessUpdateBody = zEndpointsResourcePoolUpdatePayload;

export const zNamespacesAccessUpdatePath = z.object({
  id: z.int(),
  rpn: z.int(),
});

/**
 * Success - Access permissions were successfully updated
 */
export const zNamespacesAccessUpdateResponse = z.void();

export const zEndpointRegistriesListPath = z.object({
  id: z.int(),
});

export const zEndpointRegistriesListQuery = z.object({
  namespace: z.string().optional(),
});

/**
 * Success
 */
export const zEndpointRegistriesListResponse = z.array(zPortainereeRegistry);

/**
 * details
 */
export const zEndpointRegistryAccessBody = zEndpointsRegistryAccessPayload;

export const zEndpointRegistryAccessPath = z.object({
  id: z.int(),
  registryId: z.int(),
});

/**
 * Success
 */
export const zEndpointRegistryAccessResponse = z.void();

/**
 * Environment(Endpoint) details
 */
export const zEndpointSettingsUpdateBody =
  zEndpointsEndpointSettingsUpdatePayload;

export const zEndpointSettingsUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointSettingsUpdateResponse = zPortainereeEndpoint;

export const zEndpointSnapshotPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEndpointSnapshotResponse = z.void();

/**
 * List of available agent versions
 */
export const zAgentVersionsResponse = z.array(z.string());

/**
 * List of environments to delete, with optional deleteCluster flag to clean-up associated resources (cloud environments only)
 */
export const zEndpointDeleteBatchBody = zEndpointsEndpointDeleteBatchPayload2;

export const zEndpointDeleteBatchResponse = z.union([
  z.void(),
  zEndpointsEndpointDeleteBatchPartialResponse,
]);

/**
 * Generate Key Info
 */
export const zEndpointEdgeGenerateKeyBody = zEndpointedgeGenerateKeyResponse;

/**
 * Information about the environments to trust
 */
export const zTrustEdgeEndpointsBody = zEndpointedgeEndpointsTrustPayload;

/**
 * Environment(s) successfully associated.
 */
export const zTrustEdgeEndpointsResponse = z.void();

/**
 * Success
 */
export const zEndpointCreateGlobalKeyResponse =
  zEndpointsEndpointCreateGlobalKeyResponse;

/**
 * Environment relations data
 */
export const zEndpointUpdateRelationsBody =
  zEndpointsEndpointUpdateRelationsPayload;

/**
 * Success
 */
export const zEndpointUpdateRelationsResponse = z.void();

/**
 * Success
 */
export const zEndpointSnapshotsResponse = z.void();

/**
 * Environment summary counts
 */
export const zEndpointSummaryCountsResponse =
  zEndpointsEnvironmentSummaryCountsResponse;

/**
 * Template details
 */
export const zGitOperationRepoFilePreviewBody =
  zGitopsRepositoryFilePreviewPayload;

/**
 * Success
 */
export const zGitOperationRepoFilePreviewResponse = zGitopsFileResponse;

/**
 * details
 */
export const zGitOperationRepoFilesSearchBody =
  zGitopsRepositoryFileSearchPayload;

export const zGitOperationRepoFilesSearchQuery = z.object({
  force: z.boolean().optional(),
});

/**
 * Success
 */
export const zGitOperationRepoFilesSearchResponse = z.array(z.string());

/**
 * Helm values preview request
 */
export const zGitOperationRepoHelmValuesBody = zGitopsHelmValuesPreviewPayload;

/**
 * Success
 */
export const zGitOperationRepoHelmValuesResponse =
  zGitopsHelmValuesPreviewResponse;

/**
 * details
 */
export const zGitOperationRepoRefsBody = zGitopsRepositoryReferenceListPayload;

export const zGitOperationRepoRefsQuery = z.object({
  force: z.boolean().optional(),
});

/**
 * Success
 */
export const zGitOperationRepoRefsResponse = z.array(z.string());

export const zGitOpsSourcesListQuery = z.object({
  search: z.string().optional(),
  sort: z.string().optional(),
  order: z.string().optional(),
  start: z.int().optional(),
  limit: z.int().optional(),
  status: z.string().optional(),
  type: z.enum(['git', 'helm', 'oci']).optional(),
  ids: z.array(z.int()).optional(),
});

/**
 * OK
 */
export const zGitOpsSourcesListResponse = z.array(zSourcesSource);

export const zGitOpsSourcesDeletePath = z.object({
  id: z.int(),
});

/**
 * Source deleted
 */
export const zGitOpsSourcesDeleteResponse = z.void();

export const zGitOpsSourceGetPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zGitOpsSourceGetResponse = zSourcesSourceDetail;

/**
 * Git source details
 */
export const zGitOpsSourcesUpdateGitBody = zSourcesGitSourceUpdatePayload;

export const zGitOpsSourcesUpdateGitPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zGitOpsSourcesUpdateGitResponse = zPortainerSource;

/**
 * Source access control
 */
export const zGitOpsSourcesUpdateAccessBody = zSourcesSourceAccessUpdatePayload;

export const zGitOpsSourcesUpdateAccessPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zGitOpsSourcesUpdateAccessResponse = zPortainerSource;

/**
 * Optional connection overrides; omitted fields fall back to stored values
 */
export const zGitOpsSourcesTestByIdBody = zSourcesGitSourceUpdatePayload;

export const zGitOpsSourcesTestByIdPath = z.object({
  id: z.int(),
});

/**
 * Connection test result
 */
export const zGitOpsSourcesTestByIdResponse = zSourcesConnectionTestResult;

export const zGitOpsSourceWorkflowsListPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zGitOpsSourceWorkflowsListResponse = z.array(zSourcesWorkflow);

/**
 * Git source details
 */
export const zGitOpsSourcesCreateGitBody = zSourcesGitSourceCreatePayload;

/**
 * Created
 */
export const zGitOpsSourcesCreateGitResponse = zPortainerSource;

/**
 * OK
 */
export const zGitOpsSourcesSummaryResponse = zWorkflowsStatusSummary;

/**
 * Git connection details
 */
export const zGitOpsSourcesTestBody = zSourcesGitSourceCreatePayload;

/**
 * Connection test result
 */
export const zGitOpsSourcesTestResponse = zSourcesConnectionTestResult;

export const zGitOpsWorkflowsListQuery = z.object({
  search: z.string().optional(),
  sort: z.enum(['name', 'status', 'creationDate', 'lastSyncDate']).optional(),
  order: z.enum(['asc', 'desc']).optional(),
  start: z.int().optional(),
  limit: z.int().optional(),
  endpointIds: z.array(z.int()).optional(),
  status: z
    .enum(['healthy', 'syncing', 'error', 'paused', 'unknown'])
    .optional(),
  type: z.enum(['stack', 'edgeStack']).optional(),
  platform: z
    .enum(['dockerStandalone', 'dockerSwarm', 'kubernetes'])
    .optional(),
});

/**
 * OK
 */
export const zGitOpsWorkflowsListResponse = z.array(zWorkflowsWorkflow);

/**
 * Workflow details
 */
export const zWorkflowCreateBody = zWorkflowsCreatePayload;

/**
 * Success
 */
export const zWorkflowCreateResponse = zPortainerWorkflow;

export const zGitOpsWorkflowGetPath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zGitOpsWorkflowGetResponse = zWorkflowsWorkflow;

/**
 * Workflow update
 */
export const zWorkflowUpdateBody = zWorkflowsUpdatePayload;

export const zWorkflowUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zWorkflowUpdateResponse = zWorkflowsWorkflow;

export const zGitOpsWorkflowDestroyPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGitOpsWorkflowDestroyResponse = z.void();

export const zGitOpsWorkflowDetachPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGitOpsWorkflowDetachResponse = z.void();

/**
 * OK
 */
export const zGitOpsWorkflowsSummaryResponse = zWorkflowsStatusSummary;

export const zGetKubernetesPodSecurityRulePath = z.object({
  environmentId: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesPodSecurityRuleResponse =
  zPodsecurityPodSecurityRule;

export const zUpdateK8sPodSecurityRulePath = z.object({
  environmentId: z.int(),
});

export const zGetAllKubernetesApplicationsPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesApplicationsQuery = z.object({
  namespace: z.string(),
  nodeName: z.string(),
});

/**
 * Success
 */
export const zGetAllKubernetesApplicationsResponse = z.array(
  zModelsK8sApplication
);

export const zGetAllKubernetesApplicationsCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesApplicationsCountResponse = z.int();

/**
 * A list of cluster role bindings to delete
 */
export const zDeleteClusterRoleBindingsBody = z.array(z.string());

export const zDeleteClusterRoleBindingsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteClusterRoleBindingsResponse = z.void();

/**
 * A list of cluster roles to delete
 */
export const zDeleteClusterRolesBody = z.array(z.string());

export const zDeleteClusterRolesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteClusterRolesResponse = z.void();

export const zGetAllKubernetesClusterRoleBindingsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesClusterRoleBindingsResponse = z.array(
  zKubernetesK8sClusterRoleBinding
);

export const zGetAllKubernetesClusterRolesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesClusterRolesResponse = z.array(
  zKubernetesK8sClusterRole
);

export const zGetAllKubernetesConfigMapsPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesConfigMapsQuery = z.object({
  isUsed: z.boolean(),
});

/**
 * Success
 */
export const zGetAllKubernetesConfigMapsResponse = z.array(zModelsK8sConfigMap);

export const zGetAllKubernetesConfigMapsCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesConfigMapsCountResponse = z.int();

export const zGetKubernetesCronJobsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesCronJobsResponse = z.array(zKubernetesK8sCronJob);

/**
 * A map where the key is the namespace and the value is an array of Cron Jobs to delete
 */
export const zDeleteCronJobsBody = zKubernetesK8sCronJobDeleteRequests;

export const zDeleteCronJobsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteCronJobsResponse = z.void();

export const zGetKubernetesCustomResourceDefinitionsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesCustomResourceDefinitionsResponse = z.array(
  zModelsK8sCustomResourceDefinition
);

export const zDeleteKubernetesCustomResourceDefinitionPath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * No content.
 */
export const zDeleteKubernetesCustomResourceDefinitionResponse = z.void();

export const zGetKubernetesCustomResourceDefinitionPath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesCustomResourceDefinitionResponse =
  zModelsK8sCustomResourceDefinition;

export const zGetKubernetesAllCustomResourcesPath = z.object({
  id: z.int(),
});

export const zGetKubernetesAllCustomResourcesQuery = z.object({
  definition: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesAllCustomResourcesResponse = z.array(
  zModelsK8sCustomResource
);

export const zDeleteKubernetesClusterScopedCustomResourcePath = z.object({
  id: z.int(),
  name: z.string(),
});

export const zDeleteKubernetesClusterScopedCustomResourceQuery = z.object({
  definition: z.string(),
});

/**
 * No Content
 */
export const zDeleteKubernetesClusterScopedCustomResourceResponse = z.void();

export const zGetKubernetesClusterScopedCustomResourcePath = z.object({
  id: z.int(),
  name: z.string(),
});

export const zGetKubernetesClusterScopedCustomResourceQuery = z.object({
  definition: z.string(),
  format: z.string().optional(),
});

/**
 * Success
 */
export const zGetKubernetesClusterScopedCustomResourceResponse =
  zUnstructuredUnstructured;

export const zDeleteKubernetesNamespacedCustomResourcePath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

export const zDeleteKubernetesNamespacedCustomResourceQuery = z.object({
  definition: z.string(),
});

/**
 * No Content
 */
export const zDeleteKubernetesNamespacedCustomResourceResponse = z.void();

export const zGetKubernetesNamespacedCustomResourcePath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

export const zGetKubernetesNamespacedCustomResourceQuery = z.object({
  definition: z.string(),
  format: z.string().optional(),
});

/**
 * Success
 */
export const zGetKubernetesNamespacedCustomResourceResponse = z.array(
  zUnstructuredUnstructured
);

export const zGetKubernetesDashboardPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesDashboardResponse = z.array(zModelsK8sDashboard);

export const zGetAllKubernetesDeploymentsPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesDeploymentsQuery = z.object({
  labelSelector: z.string().optional(),
  fieldSelector: z.string().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesDeploymentsResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentListResponse;

export const zDescribeResourcePath = z.object({
  id: z.int(),
});

export const zDescribeResourceQuery = z.object({
  name: z.string(),
  kind: z.string(),
  namespace: z.string().optional(),
});

/**
 * Success
 */
export const zDescribeResourceResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesDescribeResourceResponse;

export const zGetKubernetesEndpointsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesEndpointsResponse = z.array(zKubernetesK8sEndpoint);

export const zGetAllKubernetesEventsPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesEventsQuery = z.object({
  resourceId: z.string().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesEventsResponse = z.array(zKubernetesK8sEvent);

export const zGetKubernetesGpuInfoPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesGpuInfoResponse = zModelsK8sGpuInfo;

export const zGetKubernetesIngressClassesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesIngressClassesResponse = z.array(
  zKubernetesK8sIngressClass
);

export const zGetAllKubernetesIngressControllersPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesIngressControllersQuery = z.object({
  allowedOnly: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesIngressControllersResponse = z.array(
  zModelsK8sIngressController
);

/**
 * Ingress controllers
 */
export const zUpdateKubernetesIngressControllersBody =
  zModelsK8sIngressControllerArray;

export const zUpdateKubernetesIngressControllersPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUpdateKubernetesIngressControllersResponse = z.void();

export const zGetAllKubernetesClusterIngressesPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesClusterIngressesQuery = z.object({
  withServices: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesClusterIngressesResponse = z.array(
  zModelsK8sIngressInfo
);

export const zGetAllKubernetesClusterIngressesCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesClusterIngressesCountResponse = z.int();

/**
 * Ingress details
 */
export const zDeleteKubernetesIngressesBody = zModelsK8sIngressDeleteRequests;

export const zDeleteKubernetesIngressesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesIngressesResponse = z.void();

export const zGetKubernetesJobsPath = z.object({
  id: z.int(),
});

export const zGetKubernetesJobsQuery = z.object({
  includeCronJobChildren: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetKubernetesJobsResponse = z.array(zKubernetesK8sJob);

/**
 * A map where the key is the namespace and the value is an array of Jobs to delete
 */
export const zDeleteJobsBody = zKubernetesK8sJobDeleteRequests;

export const zDeleteJobsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteJobsResponse = z.void();

/**
 * The manifests to validate
 */
export const zDryRunKubernetesManifestsBody =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesManifestDryRunPayload;

export const zDryRunKubernetesManifestsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDryRunKubernetesManifestsResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesManifestDryRunResponse;

export const zGetKubernetesMaxResourceLimitsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesMaxResourceLimitsResponse = zPortainerK8sNodesLimits;

export const zGetApplicationsResourcesPath = z.object({
  id: z.int(),
});

export const zGetApplicationsResourcesQuery = z.object({
  node: z.string(),
});

/**
 * Success
 */
export const zGetApplicationsResourcesResponse = zModelsK8sApplicationResource;

export const zGetKubernetesMetricsForAllNodesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesMetricsForAllNodesResponse = zV1Beta1NodeMetricsList;

export const zGetKubernetesMetricsForNodePath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesMetricsForNodeResponse = zV1Beta1NodeMetricsList;

export const zGetKubernetesMetricsForPodPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesMetricsForPodResponse = zV1Beta1PodMetrics;

export const zGetKubernetesMetricsForAllPodsPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesMetricsForAllPodsResponse = zV1Beta1PodMetricsList;

/**
 * List of namespace names to delete
 */
export const zDeleteKubernetesNamespaceBody = z.array(z.string());

export const zDeleteKubernetesNamespacePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesNamespaceResponse = z.string();

export const zGetKubernetesNamespacesPath = z.object({
  id: z.int(),
});

export const zGetKubernetesNamespacesQuery = z.object({
  withResourceQuota: z.boolean().optional(),
  withUnhealthyEvents: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetKubernetesNamespacesResponse = z.array(
  zPortainerK8sNamespaceInfo
);

/**
 * Namespace configuration details
 */
export const zCreateKubernetesNamespaceBody = zModelsK8sNamespaceDetails;

export const zCreateKubernetesNamespacePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCreateKubernetesNamespaceResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesCreateNamespaceResponse;

/**
 * Namespace details
 */
export const zUpdateKubernetesNamespaceDeprecatedBody =
  zModelsK8sNamespaceDetails2;

export const zUpdateKubernetesNamespaceDeprecatedPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUpdateKubernetesNamespaceDeprecatedResponse =
  zPortainerK8sNamespaceInfo;

export const zGetKubernetesNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

export const zGetKubernetesNamespaceQuery = z.object({
  withResourceQuota: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetKubernetesNamespaceResponse = zPortainerK8sNamespaceInfo;

/**
 * Namespace details
 */
export const zUpdateKubernetesNamespaceBody = zModelsK8sNamespaceDetails2;

export const zUpdateKubernetesNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesNamespaceResponse = zPortainerK8sNamespaceInfo;

export const zRestartKubernetesApplicationPath = z.object({
  id: z.int(),
  namespace: z.string(),
  kind: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zRestartKubernetesApplicationResponse = z.void();

export const zGetAllKubernetesApplicationPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

export const zGetAllKubernetesApplicationQuery = z.object({
  resourceType: z.string().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesApplicationResponse = zModelsK8sApplication;

/**
 * ConfigMap definition
 */
export const zCreateKubernetesConfigMapBody =
  zKubernetesK8sConfigMapWriteRequest2;

export const zCreateKubernetesConfigMapPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zCreateKubernetesConfigMapResponse = zModelsK8sConfigMap;

export const zDeleteKubernetesConfigMapPath = z.object({
  id: z.int(),
  namespace: z.string(),
  configmap: z.string(),
});

/**
 * Success
 */
export const zDeleteKubernetesConfigMapResponse = z.void();

export const zGetKubernetesConfigMapPath = z.object({
  id: z.int(),
  namespace: z.string(),
  configmap: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesConfigMapResponse = zModelsK8sConfigMap;

/**
 * ConfigMap definition
 */
export const zUpdateKubernetesConfigMapBody =
  zKubernetesK8sConfigMapWriteRequest2;

export const zUpdateKubernetesConfigMapPath = z.object({
  id: z.int(),
  namespace: z.string(),
  configmap: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesConfigMapResponse = zModelsK8sConfigMap;

export const zGetKubernetesDeploymentsForNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

export const zGetKubernetesDeploymentsForNamespaceQuery = z.object({
  labelSelector: z.string().optional(),
  fieldSelector: z.string().optional(),
});

/**
 * Success
 */
export const zGetKubernetesDeploymentsForNamespaceResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentListResponse;

/**
 * Deployment definition
 */
export const zCreateKubernetesDeploymentBody =
  zKubernetesK8sDeploymentWriteRequest2;

export const zCreateKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zCreateKubernetesDeploymentResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse;

export const zDeleteKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zDeleteKubernetesDeploymentResponse = z.void();

export const zGetKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesDeploymentResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse;

/**
 * Annotations to apply
 */
export const zPatchKubernetesDeploymentBody =
  zKubernetesK8sDeploymentPatchRequest;

export const zPatchKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zPatchKubernetesDeploymentResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse;

/**
 * Deployment definition
 */
export const zUpdateKubernetesDeploymentBody =
  zKubernetesK8sDeploymentWriteRequest2;

export const zUpdateKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesDeploymentResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse;

/**
 * Revision to roll back to
 */
export const zRollbackKubernetesDeploymentBody =
  zKubernetesK8sDeploymentRollbackRequest;

export const zRollbackKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zRollbackKubernetesDeploymentResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse;

/**
 * Desired replica count
 */
export const zScaleKubernetesDeploymentBody =
  zKubernetesK8sDeploymentScaleRequest;

export const zScaleKubernetesDeploymentPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zScaleKubernetesDeploymentResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesDeploymentResponse;

export const zGetKubernetesEventsForNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

export const zGetKubernetesEventsForNamespaceQuery = z.object({
  resourceId: z.string().optional(),
});

/**
 * Success
 */
export const zGetKubernetesEventsForNamespaceResponse =
  z.array(zKubernetesK8sEvent);

export const zGetKubernetesIngressControllersByNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesIngressControllersByNamespaceResponse = z.array(
  zModelsK8sIngressController
);

/**
 * Ingress controllers
 */
export const zUpdateKubernetesIngressControllersByNamespaceBody =
  zModelsK8sIngressControllerArray;

export const zUpdateKubernetesIngressControllersByNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesIngressControllersByNamespaceResponse = z.void();

export const zGetAllKubernetesIngressesPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zGetAllKubernetesIngressesResponse = z.array(
  zModelsK8sIngressInfo
);

/**
 * Ingress details
 */
export const zCreateKubernetesIngressBody = zModelsK8sIngressInfo2;

export const zCreateKubernetesIngressPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zCreateKubernetesIngressResponse = z.void();

/**
 * Ingress details
 */
export const zUpdateKubernetesIngressBody = zModelsK8sIngressInfo2;

export const zUpdateKubernetesIngressPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesIngressResponse = z.void();

export const zGetKubernetesIngressPath = z.object({
  id: z.int(),
  namespace: z.string(),
  ingress: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesIngressResponse = zModelsK8sIngressInfo;

export const zGetKubernetesPersistentVolumeClaimsInNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesPersistentVolumeClaimsInNamespaceResponse = z.array(
  zModelsK8sPersistentVolumeClaim
);

/**
 * PersistentVolumeClaim definition
 */
export const zCreateKubernetesPersistentVolumeClaimBody =
  zKubernetesK8sPersistentVolumeClaimCreateRequest;

export const zCreateKubernetesPersistentVolumeClaimPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zCreateKubernetesPersistentVolumeClaimResponse =
  zModelsK8sPersistentVolumeClaim;

export const zGetKubernetesPersistentVolumeClaimPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesPersistentVolumeClaimResponse =
  zModelsK8sPersistentVolumeClaim;

export const zGetKubernetesPodsForNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

export const zGetKubernetesPodsForNamespaceQuery = z.object({
  labelSelector: z.string().optional(),
  fieldSelector: z.string().optional(),
});

/**
 * Success
 */
export const zGetKubernetesPodsForNamespaceResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesPodListResponse;

export const zDeleteKubernetesPodPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zDeleteKubernetesPodResponse = z.void();

export const zGetKubernetesPodLogsPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

export const zGetKubernetesPodLogsQuery = z.object({
  container: z.string().optional(),
  tailLines: z.int().optional(),
  sinceSeconds: z.int().optional(),
  timestamps: z.boolean().optional(),
  previous: z.boolean().optional(),
  follow: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetKubernetesPodLogsResponse = z.string();

export const zRestartKubernetesPodPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zRestartKubernetesPodResponse = z.void();

export const zGetKubernetesReplicaSetsPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

export const zGetKubernetesReplicaSetsQuery = z.object({
  deployment: z.string().optional(),
  labelSelector: z.string().optional(),
  fieldSelector: z.string().optional(),
});

/**
 * Success
 */
export const zGetKubernetesReplicaSetsResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesReplicaSetListResponse;

export const zGetKubernetesResourceQuotasPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesResourceQuotasResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesResourceQuotaListResponse;

/**
 * Secret definition
 */
export const zCreateKubernetesSecretBody = zKubernetesK8sSecretWriteRequest2;

export const zCreateKubernetesSecretPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zCreateKubernetesSecretResponse = zModelsK8sSecret;

export const zDeleteKubernetesSecretPath = z.object({
  id: z.int(),
  namespace: z.string(),
  secret: z.string(),
});

/**
 * Success
 */
export const zDeleteKubernetesSecretResponse = z.void();

export const zGetKubernetesSecretPath = z.object({
  id: z.int(),
  namespace: z.string(),
  secret: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesSecretResponse = zModelsK8sSecret;

/**
 * Secret definition
 */
export const zUpdateKubernetesSecretBody = zKubernetesK8sSecretWriteRequest2;

export const zUpdateKubernetesSecretPath = z.object({
  id: z.int(),
  namespace: z.string(),
  secret: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesSecretResponse = zModelsK8sSecret;

export const zGetKubernetesServiceAccountPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesServiceAccountResponse =
  zKubernetesK8sServiceAccount;

/**
 * New imagePullSecrets list
 */
export const zUpdateKubernetesServiceAccountImagePullSecretsBody =
  zKubernetesK8sServiceAccountImagePullSecretsUpdatePayload;

export const zUpdateKubernetesServiceAccountImagePullSecretsPath = z.object({
  id: z.int(),
  namespace: z.string(),
  name: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesServiceAccountImagePullSecretsResponse = z.void();

export const zGetKubernetesServicesByNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesServicesByNamespaceResponse = z.array(
  zModelsK8sServiceInfo
);

/**
 * Service definition
 */
export const zCreateKubernetesServiceBody = zModelsK8sServiceInfo2;

export const zCreateKubernetesServicePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zCreateKubernetesServiceResponse = z.void();

/**
 * Service definition
 */
export const zUpdateKubernetesServiceBody = zModelsK8sServiceInfo2;

export const zUpdateKubernetesServicePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zUpdateKubernetesServiceResponse = z.void();

/**
 * Update details
 */
export const zKubernetesNamespacesToggleSystemBody =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesNamespacesToggleSystemPayload;

export const zKubernetesNamespacesToggleSystemPath = z.object({
  id: z.int(),
  namespace: z.string(),
});

/**
 * Success
 */
export const zKubernetesNamespacesToggleSystemResponse = z.void();

export const zGetKubernetesVolumesInNamespacePath = z.object({
  id: z.int(),
  namespace: z.string(),
});

export const zGetKubernetesVolumesInNamespaceQuery = z.object({
  withApplications: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetKubernetesVolumesInNamespaceResponse = z.record(
  z.string(),
  zKubernetesK8sVolumeInfo
);

export const zGetKubernetesNamespacesCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesNamespacesCountResponse = z.int();

export const zGetKubernetesNodesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesNodesResponse = z.array(
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesNodeResponse
);

/**
 * Drain options, matching kubectl drain flags. Defaults are applied to any omitted field.
 */
export const zDrainNodeBody =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesDrainNodePayload;

export const zDrainNodePath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * Success
 */
export const zDrainNodeResponse = z.void();

export const zGetKubernetesNodesLimitsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesNodesLimitsResponse = zPortainerK8sNodesLimits;

export const zGetAllKubernetesPersistentVolumeClaimsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesPersistentVolumeClaimsResponse = z.array(
  zModelsK8sPersistentVolumeClaim
);

/**
 * List of PVCs to delete (namespace + name)
 */
export const zDeleteKubernetesPersistentVolumeClaimsBody = z.array(
  zModelsK8sVolumeDeleteRequest
);

export const zDeleteKubernetesPersistentVolumeClaimsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesPersistentVolumeClaimsResponse = z.void();

/**
 * PVC resize request
 */
export const zResizeKubernetesPersistentVolumeClaimBody =
  zModelsK8sPvcResizeRequest;

export const zResizeKubernetesPersistentVolumeClaimPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zResizeKubernetesPersistentVolumeClaimResponse = z.void();

export const zGetAllKubernetesPersistentVolumesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesPersistentVolumesResponse = z.array(
  zModelsK8sPersistentVolume
);

export const zGetKubernetesPersistentVolumePath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesPersistentVolumeResponse =
  zModelsK8sPersistentVolume;

/**
 * List of PV names to delete
 */
export const zDeleteKubernetesPersistentVolumesBody = z.array(z.string());

export const zDeleteKubernetesPersistentVolumesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesPersistentVolumesResponse = z.void();

/**
 * Reclaim policy update request
 */
export const zUpdateKubernetesPersistentVolumeReclaimPolicyBody =
  zModelsK8sPvReclaimPolicyRequest;

export const zUpdateKubernetesPersistentVolumeReclaimPolicyPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUpdateKubernetesPersistentVolumeReclaimPolicyResponse = z.void();

export const zGetAllKubernetesPodsPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesPodsQuery = z.object({
  labelSelector: z.string().optional(),
  fieldSelector: z.string().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesPodsResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesPodListResponse;

export const zGetKubernetesRbacStatusPath = z.object({
  id: z.int(),
});

/**
 * RBAC status
 */
export const zGetKubernetesRbacStatusResponse = z.boolean();

/**
 * A map where the key is the namespace and the value is an array of role bindings to delete
 */
export const zDeleteRoleBindingsBody = zModelsK8sRoleBindingDeleteRequests;

export const zDeleteRoleBindingsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteRoleBindingsResponse = z.void();

export const zGetKubernetesRoleBindingsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesRoleBindingsResponse = z.array(
  zModelsK8sRoleBinding
);

export const zGetKubernetesRolesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesRolesResponse = z.array(zModelsK8sRole);

/**
 * A map where the key is the namespace and the value is an array of roles to delete
 */
export const zDeleteRolesBody = zModelsK8sRoleDeleteRequests;

export const zDeleteRolesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteRolesResponse = z.void();

/**
 * Namespaces, whether to include secrets, lifetime in seconds and description for the scoped kubeconfig
 */
export const zCreateKubernetesScopedKubeconfigBody =
  zKubernetesScopedKubeconfigPayload;

export const zCreateKubernetesScopedKubeconfigPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zCreateKubernetesScopedKubeconfigResponse =
  zKubernetesScopedKubeconfigResponse;

export const zDeleteKubernetesScopedKubeconfigPath = z.object({
  id: z.int(),
  scopedKubeconfigId: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesScopedKubeconfigResponse = z.void();

export const zGetKubernetesScopedKubeconfigPath = z.object({
  id: z.int(),
  scopedKubeconfigId: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesScopedKubeconfigResponse =
  zKubernetesScopedKubeconfigStatusResponse;

export const zGetKubernetesSecretsPath = z.object({
  id: z.int(),
});

export const zGetKubernetesSecretsQuery = z.object({
  isUsed: z.boolean(),
});

/**
 * Success
 */
export const zGetKubernetesSecretsResponse = z.array(zModelsK8sSecret);

export const zGetKubernetesSecretsCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesSecretsCountResponse = z.int();

/**
 * A map where the key is the namespace and the value is an array of service accounts to delete
 */
export const zDeleteServiceAccountsBody =
  zKubernetesK8sServiceAccountDeleteRequests;

export const zDeleteServiceAccountsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteServiceAccountsResponse = z.void();

export const zGetKubernetesServiceAccountsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesServiceAccountsResponse = z.array(
  zKubernetesK8sServiceAccount
);

export const zGetKubernetesServicesPath = z.object({
  id: z.int(),
});

export const zGetKubernetesServicesQuery = z.object({
  withApplications: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetKubernetesServicesResponse = z.array(zModelsK8sServiceInfo);

export const zGetAllKubernetesServicesCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesServicesCountResponse = z.int();

/**
 * A map where the key is the namespace and the value is an array of services to delete
 */
export const zDeleteKubernetesServicesBody = zModelsK8sServiceDeleteRequests;

export const zDeleteKubernetesServicesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesServicesResponse = z.void();

export const zGetAllKubernetesStorageClassesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesStorageClassesResponse = z.array(
  zModelsK8sStorageClass
);

export const zGetKubernetesStorageClassPath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesStorageClassResponse = zModelsK8sStorageClass;

export const zSetDefaultKubernetesStorageClassPath = z.object({
  id: z.int(),
  name: z.string(),
});

/**
 * Success
 */
export const zSetDefaultKubernetesStorageClassResponse = z.void();

/**
 * List of StorageClass names to delete
 */
export const zDeleteKubernetesStorageClassesBody = z.array(z.string());

export const zDeleteKubernetesStorageClassesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteKubernetesStorageClassesResponse = z.void();

export const zGetKubernetesVersionPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetKubernetesVersionResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerKubernetesKubernetesVersionResponse;

export const zGetAllKubernetesVolumesPath = z.object({
  id: z.int(),
});

export const zGetAllKubernetesVolumesQuery = z.object({
  withApplications: z.boolean().optional(),
});

/**
 * Success
 */
export const zGetAllKubernetesVolumesResponse = z.record(
  z.string(),
  zKubernetesK8sVolumeInfo
);

export const zGetKubernetesVolumePath = z.object({
  id: z.int(),
  namespace: z.string(),
  volume: z.string(),
});

/**
 * Success
 */
export const zGetKubernetesVolumeResponse = zKubernetesK8sVolumeInfo;

export const zGetAllKubernetesVolumesCountPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAllKubernetesVolumesCountResponse = z.int();

/**
 * LDAPSettings
 */
export const zLdapAdminGroupsBody = zLdapAdminGroupsPayload;

/**
 * Success
 */
export const zLdapAdminGroupsResponse = z.array(z.string());

/**
 * details
 */
export const zLdapCheckBody = zLdapCheckPayload;

/**
 * Success
 */
export const zLdapCheckResponse = z.void();

/**
 * details
 */
export const zLdapGroupsBody = zLdapGroupsPayload;

/**
 * Success
 */
export const zLdapGroupsResponse = z.array(zPortainerLdapUser);

/**
 * details
 */
export const zLdapTestLoginBody = zLdapTestLoginPayload;

/**
 * Success
 */
export const zLdapTestLoginResponse2 = zLdapTestLoginResponse;

/**
 * details
 */
export const zLdapUsersBody = zLdapUsersPayload;

/**
 * Success
 */
export const zLdapUsersResponse = z.array(zPortainerLdapUser);

/**
 * Licenses
 */
export const zLicensesListResponse = z.array(zLiblicensePortainerLicense);

/**
 * list of licenses keys to attach
 */
export const zLicensesAttachBody = zLicensesAttachPayload;

export const zLicensesAttachQuery = z.object({
  force: z.boolean().optional(),
});

/**
 * Success license data will be in `body.Licenses`, Failures will be in `body.ConflictingKeys = error`
 */
export const zLicensesAttachResponse = zLicensesAttachData;

/**
 * License info
 */
export const zLicensesInfoResponse = zLicensesLicenseInfo;

/**
 * list of license keys to remove
 */
export const zLicensesDeleteBody = zLicensesDeletePayload;

/**
 * OK
 */
export const zMotdResponse = zMotdMotd;

export const zGetAlertsQuery = z.object({
  status: z.string(),
});

/**
 * Success
 */
export const zGetAlertsResponse = z.array(z.record(z.string(), z.unknown()));

export const zTestAlertManagerConnectivityQuery = z.object({
  url: z.string(),
});

/**
 * Success
 */
export const zTestAlertManagerConnectivityResponse = z.record(
  z.string(),
  z.unknown()
);

/**
 * Success
 */
export const zGetAllAlertRulesResponse = z.array(
  z.record(z.string(), z.unknown())
);

/**
 * Alert rule details
 */
export const zCreateAlertRuleBody = zObservabilityAlertRuleCreatePayload;

/**
 * Success
 */
export const zCreateAlertRuleResponse = z.record(z.string(), z.unknown());

export const zDeleteAlertRulePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zDeleteAlertRuleResponse = z.void();

export const zGetAlertRulePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAlertRuleResponse = z.record(z.string(), z.unknown());

/**
 * Alert rule details
 */
export const zUpdateAlertRuleBody = zObservabilityAlertRuleUpdatePayload;

export const zUpdateAlertRulePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUpdateAlertRuleResponse = z.record(z.string(), z.unknown());

export const zGetAlertRuleEnvironmentsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAlertRuleEnvironmentsResponse =
  zObservabilityAlertRuleEnvironmentsResponse;

/**
 * Alert rule group attachments
 */
export const zUpdateAlertRuleGroupsBody =
  zObservabilityAlertRuleGroupsUpdatePayload;

export const zUpdateAlertRuleGroupsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUpdateAlertRuleGroupsResponse = zPortainereeAlertingRule;

/**
 * Alert rule tier configuration
 */
export const zUpdateAlertRuleTiersBody =
  zObservabilityAlertRuleTiersUpdatePayload;

export const zUpdateAlertRuleTiersPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUpdateAlertRuleTiersResponse = zPortainereeAlertingRule;

/**
 * Success
 */
export const zGetAllAlertingSettingsResponse = z.array(
  z.record(z.string(), z.unknown())
);

/**
 * Alerting settings details
 */
export const zUpdateAlertingSettingsBody = zObservabilityAlertingUpdatePayload;

/**
 * Success
 */
export const zUpdateAlertingSettingsResponse = z.record(
  z.string(),
  z.unknown()
);

export const zGetAlertingSettingsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zGetAlertingSettingsResponse = z.record(z.string(), z.unknown());

/**
 * Silence details
 */
export const zCreateSilenceBody = zObservabilityCreateSilencePayload;

/**
 * Success
 */
export const zCreateSilenceResponse = z.record(z.string(), z.unknown());

export const zDeleteSilencePath = z.object({
  id: z.string(),
});

export const zDeleteSilenceQuery = z.object({
  alertManagerURL: z.string(),
});

/**
 * Success
 */
export const zDeleteSilenceResponse = z.record(z.string(), z.unknown());

export const zEnvironmentObservabilityDiscoveryPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zEnvironmentObservabilityDiscoveryResponse =
  zObservabilityEnvironmentObservabilityResponse;

export const zObservabilityEnvironmentLogsPath = z.object({
  id: z.int(),
});

export const zObservabilityEnvironmentLogsQuery = z.object({
  namespace: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  search: z.string().optional(),
  severity: z.array(z.string()).optional(),
  from: z.string(),
  to: z.string(),
  skip: z.int().optional(),
  limit: z.int().optional(),
});

/**
 * Success
 */
export const zObservabilityEnvironmentLogsResponse = zObservabilityLogsResponse;

export const zObservabilityEnvironmentMetricsPath = z.object({
  id: z.int(),
});

export const zObservabilityEnvironmentMetricsQuery = z.object({
  namespace: z.string().optional(),
  groupBy: z.string().optional(),
  kind: z.string().optional(),
  name: z.string().optional(),
  metric: z.string(),
  aggregation: z.string(),
  from: z.string(),
  to: z.string(),
});

/**
 * OK
 */
export const zObservabilityEnvironmentMetricsResponse =
  zOneuptimeMetricsAggregateResponse;

export const zOmniGetClusterPath = z.object({
  credentialID: z.int(),
  name: z.string(),
});

/**
 * Cluster details
 */
export const zOmniGetClusterResponse = zOmniClusterData;

export const zOmniGetK8sVersionUpgradeStatusPath = z.object({
  credentialID: z.int(),
  name: z.string(),
});

/**
 * Kubernetes upgrade status
 */
export const zOmniGetK8sVersionUpgradeStatusResponse =
  zOmniUpgradeStatusResponse;

export const zOmniGetTalosVersionUpgradeStatusPath = z.object({
  credentialID: z.int(),
  name: z.string(),
});

/**
 * Talos upgrade status
 */
export const zOmniGetTalosVersionUpgradeStatusResponse =
  zOmniUpgradeStatusResponse;

/**
 * Cluster creation request
 */
export const zOmniCreateClusterBody = zOmniCreateClusterPayload;

export const zOmniCreateClusterPath = z.object({
  credentialID: z.int(),
});

/**
 * Created cluster environment
 */
export const zOmniCreateClusterResponse = zPortainereeEndpoint;

export const zOmniDeleteClusterPath = z.object({
  credentialID: z.int(),
});

export const zOmniDeleteClusterQuery = z.object({
  name: z.string(),
});

/**
 * Success
 */
export const zOmniDeleteClusterResponse = z.void();

/**
 * Provisioning cancellation request
 */
export const zOmniCancelProvisioningBody = zOmniCancelProvisioningPayload;

export const zOmniCancelProvisioningPath = z.object({
  credentialID: z.int(),
});

/**
 * Success
 */
export const zOmniCancelProvisioningResponse = z.void();

/**
 * Cluster update request
 */
export const zOmniUpdateClusterBody = zOmniUpdateClusterPayload;

export const zOmniUpdateClusterPath = z.object({
  credentialID: z.int(),
});

/**
 * Success
 */
export const zOmniUpdateClusterResponse = z.void();

/**
 * Cluster validation request
 */
export const zOmniValidateClusterBody = zOmniValidateClusterPayload;

export const zOmniValidateClusterPath = z.object({
  credentialID: z.int(),
});

/**
 * Cluster configuration is valid
 */
export const zOmniValidateClusterResponse = z.void();

export const zOmniGetSupportedTalosVersionsPath = z.object({
  credentialID: z.int(),
});

/**
 * Map of Talos versions to compatible Kubernetes versions
 */
export const zOmniGetSupportedTalosVersionsResponse = zPortainereeTalosVersions;

export const zOmniGetMachinePath = z.object({
  credentialID: z.int(),
  name: z.string(),
});

/**
 * Machine details
 */
export const zOmniGetMachineResponse = zOmniMachineData;

export const zOmniGetMachineLogsPath = z.object({
  credentialID: z.int(),
  name: z.string(),
});

/**
 * Machine logs
 */
export const zOmniGetMachineLogsResponse = z.string();

export const zOmniListMachinesPath = z.object({
  credentialID: z.int(),
});

export const zOmniListMachinesQuery = z.object({
  clusterName: z.string().optional(),
  isAvailable: z.boolean().optional(),
});

/**
 * List of machines
 */
export const zOmniListMachinesResponse = z.array(zOmniMachineData);

export const zOmniRebootNodePath = z.object({
  credentialID: z.int(),
  name: z.string(),
});

export const zOmniRebootNodeQuery = z.object({
  cluster: z.string(),
});

/**
 * Success
 */
export const zOmniRebootNodeResponse = z.void();

export const zOmniValidateServiceAccountQuery = z.object({
  endpoint: z.string().optional(),
  serviceAccountKey: z.string().optional(),
});

/**
 * Success
 */
export const zPolicyListResponse = zPoliciesPolicyListResponse;

/**
 * Policy details
 */
export const zPolicyCreateBody = zPoliciesPolicyCreatePayload;

/**
 * Success
 */
export const zPolicyCreateResponse = zPoliciesPolicy;

export const zPolicyDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zPolicyDeleteResponse = z.void();

export const zPolicyInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zPolicyInspectResponse = zPoliciesPolicy;

/**
 * Policy details
 */
export const zPolicyUpdateBody = zPoliciesPolicyUpdatePayload;

export const zPolicyUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zPolicyUpdateResponse = zPoliciesPolicy;

/**
 * Conflict check details
 */
export const zPolicyConflictsBody = zPoliciesPolicyConflictsPayload;

/**
 * Success
 */
export const zPolicyConflictsResponse = zPoliciesPolicyConflictsResponse;

/**
 * Success
 */
export const zPolicyMetadataResponse = zPoliciesPolicyMetadataResponse;

/**
 * Connection details
 */
export const zPolicyTestObservabilityConnectionBody =
  zPoliciesTestObservabilityConnectionPayload;

/**
 * OK
 */
export const zPolicyTestObservabilityConnectionResponse =
  zPoliciesTestObservabilityConnectionResponse;

export const zPolicyTemplateListQuery = z.object({
  category: z.string().optional(),
  type: z.string().optional(),
});

/**
 * Success
 */
export const zPolicyTemplateListResponse = zPoliciesTemplateListResponse;

export const zPolicyTemplateInspectPath = z.object({
  id: z.string(),
});

/**
 * Success
 */
export const zPolicyTemplateInspectResponse = zPoliciesPolicyTemplate;

export const zRecommendationListQuery = z.object({
  category: z.enum(['governance', 'security', 'operations']).optional(),
  severity: z.enum(['error', 'warning', 'info']).optional(),
});

/**
 * Success
 */
export const zRecommendationListResponse = z.array(
  zRecommendationsRecommendationResponse
);

/**
 * Success
 */
export const zRecommendationSummaryResponse = zRecommendationsSummaryResponse;

/**
 * Success
 */
export const zRegistryListResponse = z.array(zPortainereeRegistry);

/**
 * Registry details
 */
export const zRegistryCreateBody = zRegistriesRegistryCreatePayload;

/**
 * Success
 */
export const zRegistryCreateResponse = zPortainereeRegistry;

export const zRegistryDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zRegistryDeleteResponse = z.void();

export const zRegistryInspectPath = z.object({
  id: z.int(),
});

export const zRegistryInspectQuery = z.object({
  endpointId: z.int().optional(),
});

/**
 * Success
 */
export const zRegistryInspectResponse = zPortainereeRegistry;

/**
 * Registry details
 */
export const zRegistryUpdateBody = zRegistriesRegistryUpdatePayload;

export const zRegistryUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zRegistryUpdateResponse = zPortainereeRegistry;

/**
 * Registry configuration
 */
export const zRegistryConfigureBody = zRegistriesRegistryConfigurePayload;

export const zRegistryConfigurePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zRegistryConfigureResponse = z.void();

export const zEcrDeleteRepositoryPath = z.object({
  id: z.int(),
  repositoryName: z.string(),
});

/**
 * Tag Array
 */
export const zEcrDeleteTagsBody = zRegistriesDeleteTagsPayload;

export const zEcrDeleteTagsPath = z.object({
  id: z.int(),
  repositoryName: z.int(),
});

/**
 * Success
 */
export const zEcrDeleteTagsResponse = z.void();

/**
 * Tags to delete
 */
export const zRepositoryTagsDeleteBody = zRegistriesRepositoryTagsDeletePayload;

export const zRepositoryTagsDeletePath = z.object({
  id: z.int(),
  repositoryName: z.string(),
});

/**
 * Success
 */
export const zRepositoryTagsDeleteResponse = z.void();

/**
 * Registry credentials to test
 */
export const zRegistryPingBody = zRegistriesRegistryPingPayload;

/**
 * Success
 */
export const zRegistryPingResponse = zRegistriesRegistryPingResponse;

/**
 * Resource control details
 */
export const zResourceControlCreateBody =
  zResourcecontrolsResourceControlCreatePayload;

/**
 * Success
 */
export const zResourceControlCreateResponse = zPortainerResourceControl;

export const zResourceControlDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zResourceControlDeleteResponse = z.void();

/**
 * Resource control details
 */
export const zResourceControlUpdateBody =
  zResourcecontrolsResourceControlUpdatePayload;

export const zResourceControlUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zResourceControlUpdateResponse = zPortainerResourceControl;

/**
 * Restore request payload
 */
export const zRestoreBody = zBackupRestorePayload;

export const zRestoreHeaders = z.object({
  'X-Setup-Token': z.string().optional(),
});

/**
 * Success
 */
export const zRoleListResponse = z.array(zPortainereeRole);

/**
 * Success
 */
export const zSettingsInspectResponse = zPortainereeSettings;

/**
 * New settings
 */
export const zSettingsUpdateBody = zSettingsSettingsUpdatePayload;

/**
 * Success
 */
export const zSettingsUpdateResponse = zPortainereeSettings;

/**
 * Success
 */
export const zSettingsAdditionalFunctionalityInspectResponse =
  zSettingsSettingsAdditionalFunctionalityInspectResponse;

/**
 * New settings
 */
export const zSettingsAdditionalFunctionalityUpdateBody =
  zSettingsSettingsAdditionalFunctionalityUpdatePayload;

/**
 * Success
 */
export const zSettingsAdditionalFunctionalityUpdateResponse = z.void();

/**
 * Update default registry
 */
export const zDefaultRegistryUpdateBody = zSettingsDefaultRegistryUpdatePayload;

/**
 * Success
 */
export const zDefaultRegistryUpdateResponse = zPortainereeSettings;

/**
 * Success
 */
export const zSettingsEdgeMtlscaCertificatesResponse =
  zSettingsSettingsCaCertResponse;

/**
 * Success
 */
export const zSettingsEdgeMtlsCertificatesResponse =
  zSettingsSettingsCertResponse;

/**
 * Success
 */
export const zSettingsExperimentalInspectResponse =
  zSettingsSettingsExperimentalInspectResponse;

/**
 * New settings
 */
export const zSettingsExperimentalUpdateBody =
  zSettingsSettingsExperimentalUpdatePayload;

/**
 * Success
 */
export const zSettingsExperimentalUpdateResponse = z.void();

/**
 * Success
 */
export const zSettingsPublicResponse = zSettingsPublicSettingsResponse;

/**
 * OK
 */
export const zGenerateResponse = zModelsSshKeyPair;

/**
 * Success
 */
export const zSslInspectResponse = zPortainereeSslSettings;

/**
 * SSL Settings
 */
export const zSslUpdateBody = zSslSslUpdatePayload;

/**
 * Success
 */
export const zSslUpdateResponse = z.void();

export const zStackListQuery = z.object({
  filters: z.string().optional(),
});

export const zStackListResponse = z.union([
  z.array(zPortainereeStack),
  z.void(),
]);

export const zStackDeletePath = z.object({
  id: z.int(),
});

export const zStackDeleteQuery = z.object({
  external: z.boolean().optional(),
  removeVolumes: z.boolean().optional(),
  endpointId: z.int(),
});

/**
 * Success
 */
export const zStackDeleteResponse = z.void();

export const zStackInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zStackInspectResponse = zPortainereeStack;

/**
 * Stack details
 */
export const zStackUpdateBody = zStacksUpdateStackPayload;

export const zStackUpdatePath = z.object({
  id: z.int(),
});

export const zStackUpdateQuery = z.object({
  endpointId: z.int(),
});

/**
 * Success
 */
export const zStackUpdateResponse = zPortainereeStack;

export const zStackAssociatePath = z.object({
  id: z.int(),
});

export const zStackAssociateQuery = z.object({
  endpointId: z.int(),
  swarmId: z.int(),
  orphanedRunning: z.boolean(),
});

/**
 * Success
 */
export const zStackAssociateResponse = zPortainereeStack;

/**
 * Stack conversion details
 */
export const zStackConvertBody = zStacksStackConvertPayload;

export const zStackConvertPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zStackConvertResponse = zStacksStackConvertResponse;

export const zStackFileInspectPath = z.object({
  id: z.int(),
});

export const zStackFileInspectQuery = z.object({
  version: z.int().optional(),
  commitHash: z.string().optional(),
});

/**
 * Success
 */
export const zStackFileInspectResponse = zStacksStackFileResponse;

/**
 * Git configs for pull and redeploy a stack
 */
export const zStackUpdateGitBody = zStacksStackGitUpdatePayload;

export const zStackUpdateGitPath = z.object({
  id: z.int(),
});

export const zStackUpdateGitQuery = z.object({
  endpointId: z.int().optional(),
});

/**
 * Success
 */
export const zStackUpdateGitResponse = zStacksStackResponse;

/**
 * Git configs for pull and redeploy of a stack. **StackName** may only be populated for Kuberenetes stacks, and if specified with a blank string, it will be set to blank
 */
export const zStackGitRedeployBody = zStacksStackGitRedeployPayload;

export const zStackGitRedeployPath = z.object({
  id: z.int(),
});

export const zStackGitRedeployQuery = z.object({
  endpointId: z.int().optional(),
});

/**
 * Success
 */
export const zStackGitRedeployResponse = zPortainereeStack;

export const zStackImagesStatusPath = z.object({
  id: z.int(),
});

export const zStackImagesStatusQuery = z.object({
  refresh: z.boolean().optional(),
});

/**
 * Success
 */
export const zStackImagesStatusResponse = zImagesStatusResponse;

/**
 * Stack migration details
 */
export const zStackMigrateBody = zStacksStackMigratePayload;

export const zStackMigratePath = z.object({
  id: z.int(),
});

export const zStackMigrateQuery = z.object({
  endpointId: z.int().optional(),
});

/**
 * Success
 */
export const zStackMigrateResponse = zPortainereeStack;

export const zStackStartPath = z.object({
  id: z.int(),
});

export const zStackStartQuery = z.object({
  endpointId: z.int(),
});

/**
 * Success
 */
export const zStackStartResponse = zPortainereeStack;

export const zStackStopPath = z.object({
  id: z.int(),
});

export const zStackStopQuery = z.object({
  endpointId: z.int(),
});

/**
 * Success
 */
export const zStackStopResponse = zPortainereeStack;

/**
 * stack config
 */
export const zStackCreateKubernetesGitBody =
  zStacksKubernetesGitDeploymentPayload;

export const zStackCreateKubernetesGitQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateKubernetesGitResponse =
  zStacksCreateKubernetesStackResponse;

/**
 * stack config
 */
export const zStackCreateKubernetesFileBody =
  zStacksKubernetesStringDeploymentPayload;

export const zStackCreateKubernetesFileQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateKubernetesFileResponse =
  zStacksCreateKubernetesStackResponse;

/**
 * stack config
 */
export const zStackCreateKubernetesUrlBody =
  zStacksKubernetesManifestUrlDeploymentPayload;

export const zStackCreateKubernetesUrlQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateKubernetesUrlResponse =
  zStacksCreateKubernetesStackResponse;

export const zStackCreateDockerStandaloneFileBody = z.object({
  Name: z.string(),
  Env: z.string().optional(),
  file: z.union([z.instanceof(Blob), z.instanceof(File)]).optional(),
});

export const zStackCreateDockerStandaloneFileQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateDockerStandaloneFileResponse = zPortainereeStack;

/**
 * stack config
 */
export const zStackCreateDockerStandaloneRepositoryBody =
  zStacksComposeStackFromGitRepositoryPayload;

export const zStackCreateDockerStandaloneRepositoryQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateDockerStandaloneRepositoryResponse = zPortainereeStack;

/**
 * stack config
 */
export const zStackCreateDockerStandaloneStringBody =
  zStacksComposeStackFromFileContentPayload;

export const zStackCreateDockerStandaloneStringQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateDockerStandaloneStringResponse = zPortainereeStack;

export const zStackCreateDockerSwarmFileBody = z.object({
  Name: z.string().optional(),
  SwarmID: z.string().optional(),
  Env: z.string().optional(),
  file: z.union([z.instanceof(Blob), z.instanceof(File)]).optional(),
});

export const zStackCreateDockerSwarmFileQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateDockerSwarmFileResponse = zPortainereeStack;

/**
 * stack config
 */
export const zStackCreateDockerSwarmRepositoryBody =
  zStacksSwarmStackFromGitRepositoryPayload;

export const zStackCreateDockerSwarmRepositoryQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateDockerSwarmRepositoryResponse = zPortainereeStack;

/**
 * stack config
 */
export const zStackCreateDockerSwarmStringBody =
  zStacksSwarmStackFromFileContentPayload;

export const zStackCreateDockerSwarmStringQuery = z.object({
  endpointId: z.int(),
});

/**
 * OK
 */
export const zStackCreateDockerSwarmStringResponse = zPortainereeStack;

export const zStacksImageStatusClearQuery = z.object({
  environmentId: z.int().optional(),
  swarmId: z.string().optional(),
});

/**
 * Success
 */
export const zStacksImageStatusClearResponse = z.void();

export const zStackDeleteKubernetesByNamePath = z.object({
  name: z.string(),
});

export const zStackDeleteKubernetesByNameQuery = z.object({
  external: z.boolean().optional(),
  endpointId: z.int(),
});

/**
 * Success
 */
export const zStackDeleteKubernetesByNameResponse = z.void();

export const zStacksWebhookInvokePath = z.object({
  webhookID: z.string(),
});

/**
 * Success
 */
export const zGetDebugLogStatusResponse = zSupportDebugLogPayload;

/**
 * Debug log should be set to enabled or disabled
 */
export const zSetDebugLogStatusBody = zSupportDebugLogPayload;

/**
 * Success
 */
export const zSetDebugLogStatusResponse = zSupportDebugLogPayload;

/**
 * Success
 */
export const zSystemInfoResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerSystemSystemInfoResponse;

/**
 * Success
 */
export const zSystemNodesCountResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerSystemNodesCountResponse;

/**
 * Success
 */
export const zSystemStatusResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerSystemStatus;

/**
 * Success
 */
export const zSystemUpdateResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerSystemStatus;

/**
 * Success
 */
export const zSystemVersionResponse =
  zGithubComPortainerPortainerEeApiHttpHandlerSystemVersionResponse;

/**
 * Success
 */
export const zTagListResponse = z.array(zPortainerTag);

/**
 * Tag details
 */
export const zTagCreateBody = zTagsTagCreatePayload;

/**
 * Success
 */
export const zTagCreateResponse = zPortainerTag;

export const zTagDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTagDeleteResponse = z.void();

/**
 * Success
 */
export const zTeamMembershipListResponse = z.array(zPortainerTeamMembership);

/**
 * Team membership details
 */
export const zTeamMembershipCreateBody =
  zTeammembershipsTeamMembershipCreatePayload;

/**
 * Success
 */
export const zTeamMembershipCreateResponse = zPortainerTeamMembership;

export const zTeamMembershipDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTeamMembershipDeleteResponse = z.void();

/**
 * Team membership details
 */
export const zTeamMembershipUpdateBody =
  zTeammembershipsTeamMembershipUpdatePayload;

export const zTeamMembershipUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTeamMembershipUpdateResponse = zPortainerTeamMembership;

export const zTeamListQuery = z.object({
  onlyLedTeams: z.boolean().optional(),
  environmentId: z.int().optional(),
});

/**
 * Success
 */
export const zTeamListResponse = z.array(zPortainerTeam);

/**
 * details
 */
export const zTeamCreateBody = zTeamsTeamCreatePayload;

/**
 * Success
 */
export const zTeamCreateResponse = zPortainerTeam;

export const zTeamDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTeamDeleteResponse = z.void();

export const zTeamInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTeamInspectResponse = zPortainerTeam;

/**
 * Team details
 */
export const zTeamUpdateBody = zTeamsTeamUpdatePayload;

export const zTeamUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTeamUpdateResponse = zPortainerTeam;

export const zTeamMembershipsPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTeamMembershipsResponse = z.array(zPortainerTeamMembership);

/**
 * Success
 */
export const zTemplateListResponse = zTemplatesListResponse;

export const zTemplateFilePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zTemplateFileResponse = zTemplatesFileResponse;

export const zHelmRepoSearchQuery = z.object({
  repo: z.string().optional(),
  registryId: z.string().optional(),
  chart: z.string().optional(),
  useCache: z.string().optional(),
});

/**
 * Success
 */
export const zHelmRepoSearchResponse = z.string();

export const zHelmShowPath = z.object({
  command: z.string(),
});

export const zHelmShowQuery = z.object({
  repo: z.string().optional(),
  registryId: z.string().optional(),
  environmentId: z.string().optional(),
  chart: z.string(),
  version: z.string().optional(),
});

/**
 * Success
 */
export const zHelmShowResponse = z.string();

export const zUploadTlsBody = z.object({
  folder: z.string(),
  file: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

export const zUploadTlsPath = z.object({
  certificate: z.enum(['ca', 'cert', 'key']),
});

/**
 * Success
 */
export const zUploadTlsResponse = z.void();

export const zAuthLogsListQuery = z.object({
  offset: z.int().optional(),
  limit: z.int().optional(),
  before: z.int().optional(),
  after: z.int().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  keyword: z.string().optional(),
});

/**
 * Success
 */
export const zAuthLogsListResponse = z.array(zPortainereeAuthActivityLog);

export const zAuthLogsCsvQuery = z.object({
  before: z.int().optional(),
  after: z.int().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  limit: z.int().optional(),
  keyword: z.string().optional(),
});

export const zLogsListQuery = z.object({
  offset: z.int().optional(),
  limit: z.int().optional(),
  before: z.int().optional(),
  after: z.int().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  keyword: z.string().optional(),
  context: z.array(z.string()).optional(),
  username: z.array(z.string()).optional(),
});

/**
 * Success
 */
export const zLogsListResponse = zUseractivityLogsListResponse;

export const zLogsCsvQuery = z.object({
  before: z.int().optional(),
  after: z.int().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  limit: z.int().optional(),
  keyword: z.string().optional(),
});

export const zUserListQuery = z.object({
  environmentId: z.int().optional(),
});

/**
 * Success
 */
export const zUserListResponse = z.array(zUsersUser);

/**
 * User details
 */
export const zUserCreateBody = zUsersUserCreatePayload;

/**
 * Success
 */
export const zUserCreateResponse = zPortainereeUser;

export const zUserDeletePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserDeleteResponse = z.void();

export const zUserInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserInspectResponse = zPortainereeUser;

/**
 * User details
 */
export const zUserUpdateBody = zUsersUserUpdatePayload;

export const zUserUpdatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserUpdateResponse = zPortainereeUser;

export const zUserEffectiveAccessInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserEffectiveAccessInspectResponse = z.array(
  zUsersEffectiveAccessEntry
);

export const zHelmUserRepositoriesListPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zHelmUserRepositoriesListResponse =
  zUsersHelmUserRepositoryResponse;

/**
 * Helm Repository
 */
export const zHelmUserRepositoryCreateBody = zUsersAddHelmRepoUrlPayload;

export const zHelmUserRepositoryCreatePath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zHelmUserRepositoryCreateResponse = zPortainerHelmUserRepository;

export const zHelmUserRepositoryDeletePath = z.object({
  id: z.int(),
  repositoryID: z.int(),
});

/**
 * Success
 */
export const zHelmUserRepositoryDeleteResponse = z.void();

export const zUserMembershipsInspectPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserMembershipsInspectResponse = zPortainerTeamMembership;

export const zUserMembershipsSyncPath = z.object({
  id: z.int(),
});

/**
 * Updated team memberships
 */
export const zUserMembershipsSyncResponse = z.array(zPortainerTeamMembership);

export const zUserNamespacesPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserNamespacesResponse = zUsersNamespaceMapping;

/**
 * details
 */
export const zUserUpdatePasswordBody = zUsersUserUpdatePasswordPayload;

export const zUserUpdatePasswordPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserUpdatePasswordResponse = z.void();

export const zUserGetApiKeysPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserGetApiKeysResponse = z.array(zPortainerApiKey);

/**
 * details
 */
export const zUserGenerateApiKeyBody = zUsersUserAccessTokenCreatePayload;

export const zUserGenerateApiKeyPath = z.object({
  id: z.int(),
});

/**
 * Success
 */
export const zUserGenerateApiKeyResponse = zUsersAccessTokenResponse;

export const zUserRemoveApiKeyPath = z.object({
  id: z.int(),
  keyID: z.int(),
});

/**
 * Success
 */
export const zUserRemoveApiKeyResponse = z.void();

/**
 * Success
 */
export const zUserAdminCheckResponse = z.void();

/**
 * User details
 */
export const zUserAdminInitBody = zUsersAdminInitPayload;

export const zUserAdminInitHeaders = z.object({
  'X-Setup-Token': z.string().optional(),
});

/**
 * Success
 */
export const zUserAdminInitResponse = zPortainereeUser;

export const zCurrentUserInspectQuery = z.object({
  noEndpointAuthorizations: z.boolean(),
});

/**
 * Success
 */
export const zCurrentUserInspectResponse = zUsersCurrentUserInspectResponse;

export const zCurrentUserEndpointAuthorizationsInspectPath = z.object({
  endpointID: z.int(),
});

/**
 * Success
 */
export const zCurrentUserEndpointAuthorizationsInspectResponse =
  zUsersCurrentUserEndpointAuthResponse;

export const zCurrentUserEndpointNamespaceAuthorizationsInspectPath = z.object({
  endpointID: z.int(),
});

/**
 * Success
 */
export const zCurrentUserEndpointNamespaceAuthorizationsInspectResponse =
  zUsersCurrentUserEndpointNamespaceAuthResponse;

export const zWebhookListQuery = z.object({
  filters: z.string().optional(),
});

/**
 * OK
 */
export const zWebhookListResponse = z.array(zPortainerWebhook);

/**
 * Webhook data
 */
export const zWebhookCreateBody = zWebhooksWebhookCreatePayload;

/**
 * OK
 */
export const zWebhookCreateResponse = zPortainerWebhook;

export const zWebhookDeletePath = z.object({
  id: z.int(),
});

export const zWebhookExecutePath = z.object({
  id: z.string(),
});

/**
 * Webhook data
 */
export const zWebhookUpdateBody = zWebhooksWebhookUpdatePayload;

export const zWebhookUpdatePath = z.object({
  id: z.int(),
});

/**
 * OK
 */
export const zWebhookUpdateResponse = zPortainerWebhook;

/**
 * Webhook data
 */
export const zWebhookReassignBody = zWebhooksWebhookReassignPayload;

export const zWebhookReassignPath = z.object({
  id: z.int(),
});

export const zWebhookReassignResponse = z.union([zPortainerWebhook, z.void()]);

export const zWebsocketAttachQuery = z.object({
  endpointId: z.int(),
  nodeName: z.string().optional(),
});

export const zWebsocketExecQuery = z.object({
  endpointId: z.int(),
  nodeName: z.string().optional(),
});

export const zWebsocketKubernetesShellQuery = z.object({
  endpointId: z.int(),
});

export const zWebsocketNodeShellExecQuery = z.object({
  endpointId: z.int(),
  nodeName: z.string(),
});

export const zWebsocketPodExecQuery = z.object({
  endpointId: z.int(),
  namespace: z.string(),
  podName: z.string(),
  containerName: z.string(),
  command: z.string(),
});
